export const dashboard = (
  <svg
    width={15}
    height={21}
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.961 19.54V1.56M1.968 19.54V5.555M13.953 19.54v-6.992"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const products = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.25"
    height="14.252"
    viewBox="0 0 14.25 14.252"
  >
    <path
      id="columns"
      d="M9.426,3h5a1.428,1.428,0,0,1,1.428,1.428v10a1.428,1.428,0,0,1-1.428,1.428h-5M9.426,3h-5A1.428,1.428,0,0,0,3,4.428v10a1.428,1.428,0,0,0,1.428,1.428h5M9.426,3V15.852"
      transform="translate(-2.301 -2.3)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const users = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.107"
    height="14.675"
    viewBox="0 0 18.107 14.675"
  >
    <g id="users" transform="translate(0.7 0.7)">
      <path
        id="Path_21711"
        data-name="Path 21711"
        d="M12.424,19.284V17.856A2.856,2.856,0,0,0,9.568,15H3.856A2.856,2.856,0,0,0,1,17.856v1.428"
        transform="translate(-1 -6.009)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <ellipse
        id="Ellipse_246"
        data-name="Ellipse 246"
        cx="2.992"
        cy="2.99"
        rx="2.992"
        ry="2.99"
        transform="translate(2.963 0)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21712"
        data-name="Path 21712"
        d="M22.142,19.321V17.893A2.856,2.856,0,0,0,20,15.13"
        transform="translate(-5.434 -6.139)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21713"
        data-name="Path 21713"
        d="M16,3.13a2.856,2.856,0,0,1,0,5.533"
        transform="translate(-4.29 -2.707)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const manage = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.049"
    height="15.184"
    viewBox="0 0 15.049 15.184"
  >
    <path
      id="tool"
      d="M11.353,5.069a.714.714,0,0,0,0,1L12.5,7.211a.714.714,0,0,0,1,0l2.692-2.692a4.284,4.284,0,0,1-5.669,5.669L5.584,15.122A1.515,1.515,0,0,1,3.442,12.98L8.376,8.046a4.284,4.284,0,0,1,5.669-5.669L11.36,5.062Z"
      transform="translate(-2.299 -1.216)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const reports = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.715"
    height="15.705"
    viewBox="0 0 15.715 15.705"
  >
    <g id="pie-chart" transform="translate(0.734 0.7)">
      <path
        id="Path_21721"
        data-name="Path 21721"
        d="M15.715,12.155A7.14,7.14,0,1,1,6.284,2.83"
        transform="translate(-1.999 -2.237)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21722"
        data-name="Path 21722"
        d="M19.14,9.14A7.14,7.14,0,0,0,12,2V9.14Z"
        transform="translate(-4.86 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const subscriptions = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.895"
    height="14.445"
    viewBox="0 0 15.895 14.445"
  >
    <path
      id="Registrations"
      d="M16.494,9.522H13.6l-2.174,6.522L7.073,3,4.9,9.522H2"
      transform="translate(-1.3 -2.3)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const mysubscriptions = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.7"
    height="15.468"
    viewBox="0 0 15.7 15.468"
  >
    <g id="check-circle" transform="translate(0.884 0.847)">
      <path
        id="Path_21716"
        data-name="Path 21716"
        d="M15.826,8.275v.636a6.913,6.913,0,1,1-4.1-6.318"
        transform="translate(-2 -1.994)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21717"
        data-name="Path 21717"
        d="M17.987,4l-6.913,6.92L9,8.846"
        transform="translate(-4.161 -2.613)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const marketing = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17.688"
    height="10.548"
    viewBox="0 0 17.688 10.548"
  >
    <g id="trending-up" transform="translate(0.99 0.99)">
      <path
        id="Path_21719"
        data-name="Path 21719"
        d="M16.707,6,9.925,12.783l-3.57-3.57L1,14.568"
        transform="translate(-1 -6)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21720"
        data-name="Path 21720"
        d="M17,6h4.284v4.284"
        transform="translate(-5.576 -6)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const website = (
  <svg
    className="svg-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="15.639"
    height="14.217"
    viewBox="0 0 15.639 14.217"
  >
    <g
      transform="translate(.219 .7)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    >
      <rect
        data-name="Rectangle 1574"
        width="14.24"
        height="9.68"
        rx={1}
        transform="translate(.48)"
      />
      <path data-name="Line 772" d="M4.98 12.816h5" />
      <path data-name="Line 773" d="M7.479 9.65v3.165" />
    </g>
  </svg>
);

export const settings = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.526 15.162C14.459 15.162 16.026 13.8188 16.026 12.162C16.026 10.5051 14.459 9.16199 12.526 9.16199C10.593 9.16199 9.026 10.5051 9.026 12.162C9.026 13.8188 10.593 15.162 12.526 15.162Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.377 14.983C19.2441 15.2843 19.2044 15.6186 19.2633 15.9426C19.3221 16.2666 19.4766 16.5656 19.707 16.801L19.767 16.861C19.9654 17.0436 20.1248 17.2644 20.2357 17.5102C20.3465 17.7559 20.4066 18.0216 20.4121 18.2911C20.4177 18.5607 20.3688 18.8286 20.2682 19.0788C20.1676 19.3289 20.0174 19.5561 19.8268 19.7468C19.6361 19.9374 19.4089 20.0876 19.1588 20.1882C18.9086 20.2888 18.6407 20.3377 18.3711 20.3321C18.1016 20.3266 17.8359 20.2665 17.5902 20.1557C17.3444 20.0448 17.1236 19.8854 16.941 19.687L16.881 19.627C16.6475 19.401 16.3528 19.2485 16.0335 19.1884C15.7142 19.1282 15.3842 19.163 15.0845 19.2885C14.7847 19.414 14.5284 19.6246 14.3472 19.8944C14.166 20.1641 14.0679 20.4811 14.065 20.806V20.976C14.065 21.5064 13.8543 22.0151 13.4792 22.3902C13.1041 22.7653 12.5954 22.976 12.065 22.976C11.5346 22.976 11.0259 22.7653 10.6508 22.3902C10.2757 22.0151 10.065 21.5064 10.065 20.976V20.886C10.0577 20.5557 9.95133 20.2352 9.75963 19.9661C9.56794 19.697 9.2998 19.4918 8.99 19.377C8.68869 19.2441 8.35445 19.2044 8.0304 19.2633C7.70636 19.3221 7.40737 19.4766 7.172 19.707L7.112 19.767C6.929 19.964 6.70817 20.122 6.4627 20.2317C6.21723 20.3414 5.95217 20.4004 5.68336 20.4054C5.41454 20.4103 5.1475 20.3609 4.89819 20.2603C4.64887 20.1597 4.42241 20.0098 4.23233 19.8196C4.04225 19.6295 3.89247 19.403 3.79192 19.1536C3.69137 18.9043 3.64213 18.6372 3.64714 18.3684C3.65215 18.0996 3.71131 17.8346 3.82108 17.5891C3.93084 17.3437 4.08897 17.1229 4.286 16.94L4.346 16.88C4.57197 16.6465 4.72448 16.3518 4.78465 16.0325C4.84482 15.7132 4.81 15.3832 4.68451 15.0835C4.55901 14.7837 4.34836 14.5274 4.07863 14.3462C3.80889 14.165 3.49193 14.0669 3.167 14.064H3C2.46957 14.064 1.96086 13.8533 1.58579 13.4782C1.21071 13.1031 1 12.5944 1 12.064C1 11.5336 1.21071 11.0249 1.58579 10.6498C1.96086 10.2747 2.46957 10.064 3 10.064H3.09C3.42035 10.057 3.74098 9.95084 4.01024 9.75932C4.27951 9.56781 4.48499 9.29977 4.6 8.99C4.73295 8.68869 4.77257 8.35445 4.71375 8.0304C4.65493 7.70636 4.50037 7.40737 4.27 7.172L4.21 7.112C4.00704 6.93083 3.84317 6.71015 3.72843 6.46346C3.61369 6.21678 3.55048 5.94928 3.54268 5.67733C3.53488 5.40538 3.58264 5.13469 3.68305 4.88184C3.78346 4.62898 3.9344 4.39927 4.12664 4.20676C4.31888 4.01424 4.54838 3.86297 4.80109 3.76221C5.05381 3.66144 5.32442 3.61329 5.59639 3.62071C5.86835 3.62813 6.13594 3.69096 6.38278 3.80535C6.62963 3.91974 6.85054 4.08329 7.032 4.286L7.092 4.346C7.32737 4.57637 7.62636 4.73093 7.9504 4.78975C8.27445 4.84857 8.60869 4.80895 8.91 4.676H8.99C9.28561 4.54959 9.53779 4.33946 9.71547 4.07152C9.89316 3.80357 9.98858 3.4895 9.99 3.168V3C9.99 2.46957 10.2007 1.96086 10.5758 1.58579C10.9509 1.21071 11.4596 1 11.99 1C12.5204 1 13.0291 1.21071 13.4042 1.58579C13.7793 1.96086 13.99 2.46957 13.99 3V3.09C13.9945 3.41348 14.0934 3.72859 14.2746 3.99665C14.4557 4.2647 14.7112 4.47402 15.0096 4.59892C15.308 4.72381 15.6364 4.75884 15.9545 4.6997C16.2725 4.64056 16.5664 4.48982 16.8 4.266L16.86 4.206C17.0426 4.00762 17.2634 3.8482 17.5092 3.73734C17.7549 3.62647 18.0206 3.56644 18.2901 3.56085C18.5597 3.55527 18.8276 3.60425 19.0778 3.70484C19.3279 3.80543 19.5551 3.95556 19.7458 4.14621C19.9364 4.33686 20.0866 4.56409 20.1872 4.81424C20.2878 5.06439 20.3367 5.33229 20.3311 5.60185C20.3256 5.87141 20.2655 6.13706 20.1547 6.38283C20.0438 6.6286 19.8844 6.84941 19.686 7.032L19.626 7.092C19.3963 7.32781 19.2425 7.62701 19.1844 7.95104C19.1263 8.27507 19.1665 8.60907 19.3 8.91V8.99C19.4264 9.28561 19.6365 9.53779 19.9045 9.71547C20.1724 9.89316 20.4865 9.98858 20.808 9.99H20.978C21.5084 9.99 22.0171 10.2007 22.3922 10.5758C22.7673 10.9509 22.978 11.4596 22.978 11.99C22.978 12.5204 22.7673 13.0291 22.3922 13.4042C22.0171 13.7793 21.5084 13.99 20.978 13.99H20.888C20.5668 13.9902 20.2526 14.0844 19.9842 14.2608C19.7157 14.4372 19.5047 14.6882 19.377 14.983V14.983Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const documents = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.822"
    height="15.68"
    viewBox="0 0 12.822 15.68"
  >
    <g id="file" transform="translate(0.699 0.7)">
      <path
        id="Path_21714"
        data-name="Path 21714"
        d="M10.426,2h-5A1.428,1.428,0,0,0,4,3.428V14.852a1.428,1.428,0,0,0,1.428,1.428H14a1.428,1.428,0,0,0,1.428-1.428V7Z"
        transform="translate(-4 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21715"
        data-name="Path 21715"
        d="M13,2V7h5"
        transform="translate(-6.574 -2)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const rightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const leftArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5.241"
    height="11.265"
    viewBox="0 0 5.241 11.265"
  >
    <path
      id="Path_41"
      data-name="Path 41"
      d="M7212.063-9151.6l-3.56,4.65,3.56,4.651"
      transform="translate(-7207.804 9152.58)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const downArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="#A3A6AC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);


export const downChevArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-chevron-down"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1.646 4.646a.5.5 0 01.708 0L8 10.293l5.646-5.647a.5.5 0 01.708.708l-6 6a.5.5 0 01-.708 0l-6-6a.5.5 0 010-.708"
    />
  </svg>
)

export const externalLink = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13.822"
    height="13.535"
    viewBox="0 0 13.822 13.535"
  >
    <g id="external-link" transform="translate(0.699 0.035)">
      <path
        id="Path_21436"
        data-name="Path 21436"
        d="M13.667,10.978v4.267a1.422,1.422,0,0,1-1.422,1.422H4.422A1.422,1.422,0,0,1,3,15.244V7.422A1.422,1.422,0,0,1,4.422,6H8.689"
        transform="translate(-3 -3.867)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21437"
        data-name="Path 21437"
        d="M15,3h3.361V6.36"
        transform="translate(-6.115 -2.253)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <line
        id="Line_123"
        data-name="Line 123"
        y1={7}
        x2={7}
        transform="translate(5.133 0.955)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const superadminIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-app-indicator"
    viewBox="0 0 16 16"
  >
    <path d="M5.5 2A3.5 3.5 0 0 0 2 5.5v5A3.5 3.5 0 0 0 5.5 14h5a3.5 3.5 0 0 0 3.5-3.5V8a.5.5 0 0 1 1 0v2.5a4.5 4.5 0 0 1-4.5 4.5h-5A4.5 4.5 0 0 1 1 10.5v-5A4.5 4.5 0 0 1 5.5 1H8a.5.5 0 0 1 0 1H5.5z" />
    <path d="M16 3a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
  </svg>
);

export const profileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-person"
    viewBox="0 0 16 16"
  >
    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
  </svg>
);

export const settingsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-gear"
    viewBox="0 0 16 16"
  >
    <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z" />
    <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z" />
  </svg>
);

export const logoutIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-box-arrow-left"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M6 12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-8a.5.5 0 0 0-.5.5v2a.5.5 0 0 1-1 0v-2A1.5 1.5 0 0 1 6.5 2h8A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 5 12.5v-2a.5.5 0 0 1 1 0v2z"
    />
    <path
      fillRule="evenodd"
      d="M.146 8.354a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L1.707 7.5H10.5a.5.5 0 0 1 0 1H1.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3z"
    />
  </svg>
);

export const moonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-moon"
    viewBox="0 0 16 16"
  >
    <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
  </svg>
);

export const shield = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.326"
    height="17.558"
    viewBox="0 0 14.326 17.558"
  >
    <path
      id="Icon_feather-shield"
      data-name="Icon feather-shield"
      d="M12.463,19.158s6.463-3.232,6.463-8.079V5.424L12.463,3,6,5.424v5.655C6,15.926,12.463,19.158,12.463,19.158Z"
      transform="translate(-5.3 -2.3)"
      fill="none"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const mykademyLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={150}
    height={32}
    className="d-block my-1"
    viewBox="0 0 9367.293 1486.342"
  >
    {" "}
    <g transform="translate(34 -312)">
      {" "}
      <g transform="translate(-34 312)">
        {" "}
        <g transform="translate(2255.718 89.226)">
          {" "}
          <path
            d="M506.1,425.869c0-68.6-9.147-114.334-27.441-146.347-18.293-27.44-45.733-41.16-91.467-41.16h-41.16c-13.72,0-27.44,4.573-41.16,4.573V819.178H94.5V101.16c18.294-4.573,41.16-9.147,64.027-13.72s50.307-9.147,77.747-13.72,54.88-9.147,82.32-9.147C346.035,60,373.475,60,400.915,60c54.88,0,96.041,4.573,132.628,18.294C565.556,92.014,593,110.307,615.864,128.6c32.013-22.867,64.027-36.587,105.187-50.307S794.225,60,830.812,60c59.454,0,109.76,9.147,146.347,22.867,36.587,18.294,68.6,41.16,91.467,68.6,22.867,32.013,36.587,64.027,45.733,109.76q13.72,61.741,13.72,137.2V819.178H917.706V425.869c0-68.6-9.147-114.334-27.44-146.347-18.293-27.44-45.733-41.16-91.467-41.16-9.147,0-27.44,4.573-45.734,9.146s-36.587,13.72-50.307,22.867q6.86,34.3,13.72,68.6c0,22.866,4.574,50.307,4.574,77.747V823.751H510.677V425.869Z"
            transform="translate(-94.5 278.429)"
            fill="currentColor"
          />{" "}
          <path
            d="M873.3,64.773c-41.16,141.774-86.893,278.975-132.627,402.456S644.637,714.19,589.757,833.1c-18.293,41.16-41.16,77.747-59.454,109.761s-41.16,54.88-64.027,73.174-50.307,32.013-82.321,41.161-64.027,13.72-105.187,13.72c-32.014,0-64.027-4.573-91.467-9.146s-50.307-13.72-68.6-18.294l36.587-169.214c22.867,9.147,41.16,13.72,59.454,13.72,18.294,4.573,36.587,4.573,54.88,4.573,36.587,0,68.6-9.147,86.894-32.013,18.293-18.294,36.587-50.307,50.307-82.321-50.307-96.041-96.041-201.228-146.348-320.135S169.007,206.548,123.274,60.2H347.368c9.147,36.587,22.867,77.747,32.014,118.907,13.72,41.16,27.44,86.894,41.16,132.627s27.44,86.894,41.16,128.054,27.44,77.747,41.16,114.334c13.72-32.013,22.867-73.174,36.587-114.334s27.44-82.321,41.16-128.054,22.867-86.894,36.587-132.627c13.72-41.16,22.867-82.321,32.013-118.907H873.3Z"
            transform="translate(988.053 287.376)"
            fill="currentColor"
          />{" "}
          <path
            d="M348.076,674.577c22.867-22.867,41.16-45.734,64.027-68.6S457.837,555.67,476.13,532.8c22.867-22.867,41.16-45.734,59.454-68.6s32.013-41.16,45.733-54.88H832.852C782.545,468.776,732.238,523.656,686.5,573.963S585.891,679.15,531.011,734.031c27.44,27.44,59.454,54.88,86.894,91.467,32.013,36.587,59.454,73.174,86.893,109.761s54.88,77.747,77.747,114.334S828.279,1122.766,842,1154.78H599.61c-13.72-22.867-32.013-50.307-50.307-82.321s-41.16-59.454-59.454-91.467-45.734-59.454-68.6-86.894-45.734-50.307-73.174-68.6v324.708H137.7V84.613L348.075,52.6V674.577Z"
            transform="translate(1837.99 -52.6)"
            fill="currentColor"
          />{" "}
          <path
            d="M474.335,59.9c64.027,0,114.334,9.147,155.494,22.867S703,119.354,730.443,142.221q34.3,41.16,54.88,96.04c9.147,36.587,13.72,77.747,13.72,128.054V805.357c-32.013,4.573-73.174,13.72-128.054,22.867s-118.908,13.72-196.655,13.72c-50.307,0-91.467-4.573-132.627-13.72s-73.174-22.867-100.614-41.16-50.307-45.734-64.027-77.747S154.2,640.717,154.2,594.983s9.146-82.321,27.44-109.761c18.294-32.013,41.16-54.88,68.6-73.174s64.026-32.014,100.614-41.16,77.747-13.72,118.907-13.72c27.441,0,50.308,0,73.175,4.573s36.587,4.573,50.307,9.147V352.594c0-36.587-9.147-64.027-32.014-86.894S501.776,233.687,446.9,233.687c-36.587,0-73.174,4.573-105.187,9.147-36.587,4.573-64.027,13.72-91.467,22.867L222.8,96.486c13.72-4.573,27.441-9.147,45.734-13.72s36.587-9.147,59.454-9.147c22.867-4.573,45.734-4.573,68.6-9.147C424.029,59.9,446.895,59.9,474.335,59.9Zm18.294,617.4h59.454c18.293,0,32.013-4.573,45.733-4.573V512.663c-9.146,0-22.867-4.573-36.587-4.573-18.293,0-32.013-4.573-45.734-4.573-18.293,0-36.586,0-54.88,4.573s-32.013,9.147-45.734,13.72-22.867,13.72-32.013,27.44c-9.146,9.147-9.146,27.44-9.146,41.16,0,32.013,9.146,54.88,32.013,68.6C419.455,668.157,451.468,677.3,492.629,677.3Z"
            transform="translate(2576.096 273.955)"
            fill="currentColor"
          />{" "}
          <path
            d="M871.324,1127.339c-18.293,4.573-41.16,9.147-64.026,18.294-22.867,4.573-50.308,9.147-77.747,13.72s-54.881,4.573-82.321,9.147-54.88,4.573-82.321,4.573q-89.18,0-164.641-27.44c-50.307-18.294-86.893-45.734-123.481-77.747-32.013-32.014-59.453-73.174-77.747-123.481-18.293-45.734-27.44-100.614-27.44-160.068S180.746,670,194.467,619.7s36.586-91.467,64.027-123.481,64.026-59.454,105.187-77.747,86.894-27.44,141.775-27.44c27.44,0,54.88,4.573,77.747,9.147s45.733,13.72,68.6,22.867V84.614L862.178,52.6V1127.339Zm-480.2-356.722c0,64.027,13.72,118.907,45.734,155.494s73.174,59.454,132.627,59.454h50.307c18.294,0,27.441-4.573,41.16-4.573V596.83c-13.72-9.146-32.013-13.72-50.308-22.867-22.867-4.573-41.159-9.147-64.026-9.147C441.428,569.39,391.121,633.417,391.121,770.617Z"
            transform="translate(3354.46 -52.6)"
            fill="currentColor"
          />{" "}
          <path
            d="M190.4,457.782c0-64.027,9.147-123.48,32.013-173.788q27.439-75.46,82.32-123.481C336.747,128.5,377.908,101.06,419.068,87.34c41.16-18.293,86.893-27.44,132.627-27.44,105.188,0,187.508,32.014,251.536,96.041C862.683,219.968,894.7,316.008,894.7,439.489v41.16c0,13.72,0,27.44-4.574,41.16H409.92c4.574,45.734,22.867,77.747,59.454,105.187s82.32,36.587,146.348,36.587c36.586,0,77.747-4.573,114.333-9.147s68.6-13.72,91.467-27.44l27.441,173.788c-9.146,4.573-27.441,9.146-45.733,18.293-18.294,4.574-41.161,9.147-64.027,13.72s-45.733,9.146-73.174,9.146c-27.44,4.573-54.88,4.573-77.747,4.573-68.6,0-123.481-9.146-173.787-32.013q-75.462-27.44-123.481-82.321C259,695.6,236.134,659.011,217.839,608.7S190.4,512.663,190.4,457.782Zm498.5-82.32c0-18.293-4.574-36.587-9.146-50.307s-13.72-32.014-22.867-45.734-22.867-22.867-41.161-32.013-36.586-13.72-59.453-13.72-45.734,4.573-59.454,13.72c-18.293,9.147-32.013,18.293-41.16,32.013s-18.294,27.44-27.441,45.734q-6.86,27.44-13.72,54.88H688.9Z"
            transform="translate(4195.452 273.955)"
            fill="currentColor"
          />{" "}
          <path
            d="M620.9,425.869c0-68.6-9.146-114.334-27.44-146.347-18.293-27.44-45.734-41.16-91.467-41.16h-41.16c-13.72,0-27.441,4.573-41.16,4.573V819.178H209.3V101.16c18.294-4.573,41.161-9.147,64.026-13.72s50.308-9.147,77.748-13.72,54.88-9.147,82.32-9.147C460.835,60,488.274,60,515.715,60c54.88,0,96.041,4.573,132.627,18.294S707.8,110.307,730.663,128.6c32.013-22.867,64.026-36.587,105.187-50.307S909.024,60,945.611,60c59.454,0,109.761,9.147,146.347,22.867,36.587,18.294,68.6,41.16,91.468,68.6s36.588,64.027,45.734,109.76q13.72,61.741,13.72,137.2V819.178H1032.5V425.869c0-68.6-9.148-114.334-27.441-146.347-18.293-27.44-45.734-41.16-91.468-41.16-9.147,0-27.44,4.573-45.733,9.146s-36.586,13.72-50.307,22.867q6.862,34.3,13.721,68.6c0,22.866,4.573,50.307,4.573,77.747V823.751H625.475V425.869Z"
            transform="translate(5040.917 278.429)"
            fill="currentColor"
          />{" "}
          <path
            d="M988.1,64.773c-41.16,141.774-86.894,278.975-132.628,402.456S759.437,714.19,704.556,833.1c-18.294,41.16-41.16,77.747-59.454,109.761s-41.16,54.88-64.026,73.174-50.307,32.013-82.321,41.161-64.027,13.72-105.187,13.72c-32.013,0-64.027-4.573-91.467-9.146s-50.307-13.72-68.6-18.294l36.587-169.214c22.867,9.147,41.16,13.72,59.453,13.72,18.293,4.573,36.587,4.573,54.881,4.573,36.586,0,68.6-9.147,86.893-32.013,18.293-18.294,36.588-50.307,50.307-82.321-50.307-96.041-96.04-201.228-146.347-320.135S283.808,206.548,238.074,60.2H462.168c9.146,36.587,22.866,77.747,32.013,118.907,13.721,41.16,27.44,86.894,41.16,132.627s27.441,86.894,41.16,128.054,27.44,77.747,41.16,114.334c13.72-32.013,22.867-73.174,36.587-114.334s27.44-82.321,41.16-128.054S722.848,224.841,732,179.107c13.719-41.16,22.866-82.321,32.013-118.907H988.1Z"
            transform="translate(6123.47 287.376)"
            fill="currentColor"
          />{" "}
        </g>{" "}
        <g transform="translate(0)">
          {" "}
          <g transform="translate(1984.838) rotate(90)">
            {" "}
            <path
              d="M114.334,109.761,429.9,0V1102.18c0,73.174-45.734,137.2-114.334,164.641L0,1376.582V274.4c4.573-73.174,45.733-137.2,114.334-164.641"
              transform="translate(0 352.149)"
              fill="#64caa1"
            />{" "}
            <path
              d="M114.334,109.761,429.9,0V1102.18c0,73.174-45.734,137.2-114.334,164.641L0,1376.581V274.4c4.573-73.174,50.307-137.2,114.334-164.641"
              transform="translate(1056.446 256.108)"
              fill="#64caa1"
            />{" "}
            <path
              d="M0,0"
              transform="translate(320.135 818.631)"
              fill="#148f84"
            />{" "}
            <path
              d="M114.334,109.761,429.9,0V1710.437c0,73.174-45.734,137.2-114.334,164.641L0,1984.838V274.4c0-73.174,45.734-137.2,114.334-164.641"
              transform="translate(530.51)"
              fill="#64caa1"
            />{" "}
            <path
              d="M0,0Z"
              transform="translate(635.697 772.898)"
              fill="#148f84"
              fillRule="evenodd"
            />{" "}
          </g>{" "}
        </g>{" "}
      </g>{" "}
    </g>{" "}
  </svg>
);

export const mykademySquareDarkLogo = (
<svg
  xmlns="http://www.w3.org/2000/svg"
  width={21}
  height={15.71}
  viewBox="0 0 21 15.71"
>
  <g fill="#272535">
    <path
      d="M1.2 1.135L4.518 0v11.646a1.926 1.926 0 01-1.2 1.748L0 14.53V2.86a1.919 1.919 0 011.2-1.725"
      transform="rotate(90 10.5 10.5) translate(0 3.769)"
    />
    <path
      d="M1.2 1.135L4.518 0v11.646a1.926 1.926 0 01-1.2 1.748L0 14.53V2.883a2 2 0 011.2-1.748"
      transform="rotate(90 10.5 10.5) translate(11.193 2.724)"
    />
    <path
      d="M1.2 1.135L4.518 0v18.117a1.925 1.925 0 01-1.2 1.748L0 21V2.883a2.027 2.027 0 011.2-1.748"
      transform="rotate(90 10.5 10.5) translate(5.585)"
    />
  </g>
</svg>
);

export const viewLiveSiteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    fill="currentColor"
    className="bi bi-box-arrow-up-right"
    viewBox="0 0 16 16"
  >
    {" "}
    <path
      fillRule="evenodd"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
    />{" "}
    <path
      fillRule="evenodd"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
    />{" "}
  </svg>
);

export const helpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-question-circle"
    viewBox="0 0 16 16"
  >
    {" "}
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />{" "}
    <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z" />{" "}
  </svg>
);

export const bellIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.2"
    height="15.62"
    viewBox="0 0 14.2 15.62"
  >
    {" "}
    <g id="bell" transform="translate(0.7 0.7)">
      {" "}
      <path
        id="Path_21414"
        data-name="Path 21414"
        d="M13.667,6.267a4.267,4.267,0,1,0-8.533,0c0,4.978-2.133,6.4-2.133,6.4H15.8s-2.133-1.422-2.133-6.4"
        transform="translate(-3 -2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
      <path
        id="Path_21415"
        data-name="Path 21415"
        d="M12.73,21a1.422,1.422,0,0,1-2.46,0"
        transform="translate(-5.1 -7.489)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
    </g>{" "}
  </svg>
);

export const chatIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.2"
    height="14.2"
    viewBox="0 0 14.2 14.2"
  >
    {" "}
    <path
      id="message-square"
      d="M15.8,11.533a1.422,1.422,0,0,1-1.422,1.422H5.844L3,15.8V4.422A1.422,1.422,0,0,1,4.422,3h9.956A1.422,1.422,0,0,1,15.8,4.422Z"
      transform="translate(-2.3 -2.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />{" "}
  </svg>
);

export const chatFilledIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-chat-left-fill"
    viewBox="0 0 16 16"
  >
    <path d="M2 0a2 2 0 0 0-2 2v12.793a.5.5 0 0 0 .854.353l2.853-2.853A1 1 0 0 1 4.414 12H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
  </svg>
);

export const speakerIcon = (
  <svg
    width={20}
    height={17}
    viewBox="0 0 20 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 4L2 4C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6L0 10C0 10.5304 0.210714 11.0391 0.585786 11.4142C0.960859 11.7893 1.46957 12 2 12H3V16C3 16.2652 3.10536 16.5196 3.29289 16.7071C3.48043 16.8946 3.73478 17 4 17H6C6.26522 17 6.51957 16.8946 6.70711 16.7071C6.89464 16.5196 7 16.2652 7 16V12H10L15 16V0L10 4ZM13 11.6L11 10H2V6L11 6L13 4.4V11.6ZM19.5 8C19.5 9.71 18.54 11.26 17 12V4C18.53 4.75 19.5 6.3 19.5 8Z"
      fill="currentColor"
    />
  </svg>
)

export const rightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.718"
    height="4.631"
    viewBox="0 0 9.718 4.631"
  >
    {" "}
    <path
      id="Path_40581"
      data-name="Path 40581"
      d="M7.756,2.95,3.879,0,0,2.95"
      transform="translate(8.737 3.931) rotate(180)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />{" "}
  </svg>
);

export const cubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-grid-3x3-gap"
    viewBox="0 0 16 16"
  >
    {" "}
    <path d="M4 2v2H2V2h2zm1 12v-2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm5 10v-2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm0-5V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zM9 2v2H7V2h2zm5 0v2h-2V2h2zM4 7v2H2V7h2zm5 0v2H7V7h2zm5 0h-2v2h2V7zM4 12v2H2v-2h2zm5 0v2H7v-2h2zm5 0v2h-2v-2h2zM12 1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zm-1 6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zm1 4a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-2z" />{" "}
  </svg>
);

export const togglerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.2"
    height="20.2"
    viewBox="0 0 20.2 20.2"
  >
    <g
      id="Group_18767"
      data-name="Group 18767"
      transform="translate(-1619.701 -31.699)"
    >
      <g id="more-horizontal" transform="translate(1620.301 32.3)">
        <circle
          id="Ellipse_263"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 -0.001)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <g
        id="more-horizontal-2"
        data-name="more-horizontal"
        transform="translate(1620.301 40.123)"
      >
        <circle
          id="Ellipse_263-2"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264-2"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265-2"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 0.176)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
      <g
        id="more-horizontal-3"
        data-name="more-horizontal"
        transform="translate(1620.301 47.948)"
      >
        <circle
          id="Ellipse_263-3"
          data-name="Ellipse 263"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(8 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_264-3"
          data-name="Ellipse 264"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(16 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
        <circle
          id="Ellipse_265-3"
          data-name="Ellipse 265"
          cx="1.5"
          cy="1.5"
          r="1.5"
          transform="translate(0 0.351)"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
        />
      </g>
    </g>
  </svg>
);

export const downArrowBlue = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="6.119"
    height="11.658"
    viewBox="0 0 6.119 11.658"
  >
    <path
      id="Path_21616"
      data-name="Path 21616"
      d="M0,0,4.42,3.71,8.84,0"
      transform="translate(1.409 10.249) rotate(-90)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const calendarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="15"
    fill="#6f75bc"
    className="bi bi-calendar4"
    viewBox="0 0 16 16"
  >
    <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1H2zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V5z" />
  </svg>
);

export const editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.831"
    height="15.665"
    viewBox="0 0 15.831 15.665"
  >
    <path
      id="edit-2"
      d="M12.791,2.768a2.035,2.035,0,1,1,2.878,2.878L5.957,15.357,2,16.437,3.079,12.48Z"
      transform="translate(-1.3 -1.472)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const binIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.999"
    height="14.288"
    viewBox="0 0 12.999 14.288"
  >
    <g id="trash_1_" data-name="trash (1)" transform="translate(0.7 0.7)">
      <path
        id="Path_13"
        data-name="Path 13"
        d="M3,6H14.6"
        transform="translate(-3 -3.422)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_14"
        data-name="Path 14"
        d="M14.021,4.578V13.6a1.289,1.289,0,0,1-1.289,1.289H6.289A1.289,1.289,0,0,1,5,13.6V4.578m1.933,0V3.289A1.289,1.289,0,0,1,8.222,2H10.8a1.289,1.289,0,0,1,1.289,1.289V4.578"
        transform="translate(-3.711 -2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const externalLinkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"
    />
    <path
      fillRule="evenodd"
      d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"
    />
  </svg>
);

export const linkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-link"
    viewBox="0 0 16 16"
  >
    <path d="M6.354 5.5H4a3 3 0 000 6h3a3 3 0 002.83-4H9q-.13 0-.25.031A2 2 0 017 10.5H4a2 2 0 110-4h1.535c.218-.376.495-.714.82-1z" />
    <path d="M9 5.5a3 3 0 00-2.83 4h1.098A2 2 0 019 6.5h3a2 2 0 110 4h-1.535a4 4 0 01-.82 1H12a3 3 0 100-6z" />
  </svg>
)

export const downloadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9.075"
    height="9.914"
    viewBox="0 0 9.075 9.914"
  >
    {" "}
    <g
      id="Icon_feather-download"
      data-name="Icon feather-download"
      transform="translate(-5.902 -3.8)"
    >
      {" "}
      <path
        id="Path_40557"
        data-name="Path 40557"
        d="M10.5,15l3.547,3.547L17.595,15"
        transform="translate(-3.608 -5.534)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
      <path
        id="Path_40558"
        data-name="Path 40558"
        d="M18,13.014V4.5"
        transform="translate(-7.56)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
    </g>{" "}
  </svg>
);

export const copyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12.733"
    height="12.734"
    viewBox="0 0 12.733 12.734"
  >
    <g
      id="Icon_feather-copy"
      data-name="Icon feather-copy"
      transform="translate(-2.3 -2.3)"
    >
      <path
        id="Path_40559"
        data-name="Path 40559"
        d="M14.633,13.5h5.1a1.133,1.133,0,0,1,1.133,1.133v5.1a1.133,1.133,0,0,1-1.133,1.133h-5.1A1.133,1.133,0,0,1,13.5,19.733v-5.1A1.133,1.133,0,0,1,14.633,13.5Z"
        transform="translate(-6.533 -6.533)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_40560"
        data-name="Path 40560"
        d="M4.7,10.367H4.133A1.133,1.133,0,0,1,3,9.233v-5.1A1.133,1.133,0,0,1,4.133,3h5.1a1.133,1.133,0,0,1,1.133,1.133V4.7"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const vCopyIcon = (
<svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_683_203)">
      <path
        d="M10.6666 0.666504H2.66665C1.93331 0.666504 1.33331 1.2665 1.33331 1.99984V11.3332H2.66665V1.99984H10.6666V0.666504ZM12.6666 3.33317H5.33331C4.59998 3.33317 3.99998 3.93317 3.99998 4.6665V13.9998C3.99998 14.7332 4.59998 15.3332 5.33331 15.3332H12.6666C13.4 15.3332 14 14.7332 14 13.9998V4.6665C14 3.93317 13.4 3.33317 12.6666 3.33317ZM12.6666 13.9998H5.33331V4.6665H12.6666V13.9998Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_683_203">
        <rect width={16} height={16} fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
);

export const menuHamburgerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.837"
    height="16.558"
    viewBox="0 0 23.837 16.558"
  >
    <g data-name="Icon feather-menu" transform="translate(-3.5 -8)">
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(0 -1.721)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40586"
        data-name="Path 40586"
        d="M4.5,9H26.337"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40587"
        data-name="Path 40587"
        d="M4.5,27H26.337"
        transform="translate(0 -3.442)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const menuCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.27"
    height="18.27"
    viewBox="0 0 18.27 18.27"
  >
    <g
      id="Icon_feather-menu"
      data-name="Icon feather-menu"
      transform="translate(-3.086 -7.144)"
    >
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(14.046 -7.351) rotate(45)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40588"
        data-name="Path 40588"
        d="M0,0H21.837"
        transform="translate(19.942 8.558) rotate(135)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const lockPadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.169"
    height="17.81"
    viewBox="0 0 16.169 17.81"
  >
    <g
      id="Icon_feather-lock"
      data-name="Icon feather-lock"
      transform="translate(-3.8 -2.3)"
    >
      <path
        id="Path_40549"
        data-name="Path 40549"
        d="M6.141,16.5H17.628a1.641,1.641,0,0,1,1.641,1.641v5.743a1.641,1.641,0,0,1-1.641,1.641H6.141A1.641,1.641,0,0,1,4.5,23.884V18.141A1.641,1.641,0,0,1,6.141,16.5Z"
        transform="translate(0 -6.116)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_40550"
        data-name="Path 40550"
        d="M10.5,10.384V7.1a4.1,4.1,0,1,1,8.2,0v3.282"
        transform="translate(-2.718)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-x"
    viewBox="0 0 16 16"
  >
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
  </svg>
);

export const closeIconBlue = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="#6f75bc"
    className="bi bi-x-lg"
    viewBox="0 0 16 16"
  >
    <path d="M2.146 2.854a.5.5 0 11.708-.708L8 7.293l5.146-5.147a.5.5 0 01.708.708L8.707 8l5.147 5.146a.5.5 0 01-.708.708L8 8.707l-5.146 5.147a.5.5 0 01-.708-.708L7.293 8 2.146 2.854z" />
  </svg>
);

export const chervonDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={4}
    viewBox="0 0 9.718 4.631"
  >
    <path
      id="Path_40581"
      data-name="Path 40581"
      d="M7.756,2.95,3.879,0,0,2.95"
      transform="translate(8.737 3.931) rotate(180)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const removeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.763"
    height="7.763"
    viewBox="0 0 7.763 7.763"
  >
    <g data-name="Group 17821" transform="translate(0.99 0.99)">
      <path
        id="Path_21632"
        data-name="Path 21632"
        d="M0,0V8.177"
        transform="translate(5.783 0) rotate(45)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21633"
        data-name="Path 21633"
        d="M0,0V8.177"
        transform="translate(5.782 5.783) rotate(135)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const addIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10.39"
    height="10.391"
    viewBox="0 0 10.39 10.391"
  >
    <g id="Group_17764" data-name="Group 17764" transform="translate(0.7 0.7)">
      <path
        id="Path_9"
        data-name="Path 9"
        d="M1756.344,206.134h-8.99"
        transform="translate(-1747.354 -201.864)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_32"
        data-name="Path 32"
        d="M8.991,0H0"
        transform="translate(4.495) rotate(90)"
        fill="none"
        stroke="#6f75bc"
        strokeLinecap="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const toolIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.049"
    height="15.184"
    viewBox="0 0 15.049 15.184"
  >
    <path
      id="tool"
      d="M11.353,5.069a.714.714,0,0,0,0,1L12.5,7.211a.714.714,0,0,0,1,0l2.692-2.692a4.284,4.284,0,0,1-5.669,5.669L5.584,15.122A1.515,1.515,0,0,1,3.442,12.98L8.376,8.046a4.284,4.284,0,0,1,5.669-5.669L11.36,5.062Z"
      transform="translate(-2.299 -1.216)"
      fill="rgba(0,0,0,0)"
      stroke="#444850"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const downArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4.531}
    height={9.409}
    viewBox="0 0 4.531 9.409"
  >
    <path
      data-name="Path 40564"
      d="M2.85 0L0 3.723l2.85 3.725"
      transform="rotate(-90 3 4)"
      fill="none"
      stroke="#A3A6AC"
    />
  </svg>
);

export const upArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={4.531}
    height={9.409}
    viewBox="0 0 4.531 9.409"
  >
    <path
      data-name="Path 40564"
      d="M2.85 0L0 3.723l2.85 3.725"
      transform="rotate(90 1.5 4.5)"
      fill="none"
      stroke="#A3A6AC"
    />
  </svg>
);

export const calendarIcon101 = (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style={{ enableBackground: "new 0 0 512 512" }}
    xmlSpace="preserve"
    fill="currentColor"
  >
    <g>
      <path
        d="M93.1,69.8v23.3h325.8c12.8,0,23.2,10.4,23.3,23.3v325.8c0,12.8-10.4,23.2-23.3,23.3H93.1c-12.8,0-23.2-10.4-23.3-23.3
		V116.4c0-12.8,10.4-23.3,23.3-23.3V69.8V46.5c-38.6,0-69.8,31.2-69.8,69.8v325.8c0,38.6,31.2,69.8,69.8,69.8h325.8
		c38.6,0,69.8-31.2,69.8-69.8V116.4c0-38.6-31.2-69.8-69.8-69.8H93.1V69.8z"
      />
      <path d="M325.8,23.3v93.1c0,12.9,10.4,23.3,23.3,23.3s23.3-10.4,23.3-23.3V23.3c0-12.9-10.4-23.3-23.3-23.3S325.8,10.4,325.8,23.3" />
      <path
        d="M139.6,23.3v93.1c0,12.9,10.4,23.3,23.3,23.3c12.9,0,23.3-10.4,23.3-23.3V23.3c0-12.9-10.4-23.3-23.3-23.3
		C150.1,0,139.6,10.4,139.6,23.3"
      />
      <path
        d="M46.5,232.7h418.9c12.9,0,23.3-10.4,23.3-23.3c0-12.9-10.4-23.3-23.3-23.3H46.5c-12.9,0-23.3,10.4-23.3,23.3
		C23.3,222.3,33.7,232.7,46.5,232.7"
      />
    </g>
  </svg>
);

export const filterIcon = (
  <svg
    width={21}
    height={13}
    viewBox="0 0 21 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.076 1.5H.354M16.532 6.5H3.897M13.09 11.5H7.35"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);

export const dotsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-three-dots"
    viewBox="0 0 16 16"
  >
    <path d="M3 9.5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm5 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
  </svg>
);

export const fullAccessIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17.195}
    height={8.646}
    viewBox="0 0 17.195 8.646"
  >
    <path
      data-name="Path 40521"
      d="M113.593 160.776a5.767 5.767 0 00-1.794-1.651 4 4 0 00-1.239-.448 4.4 4.4 0 00-1.439-.009 4.161 4.161 0 00-1.984 7.29 4.129 4.129 0 00.978.613 4.477 4.477 0 001.286.344 4.059 4.059 0 002.54-.577 5.989 5.989 0 001.76-1.719 7.735 7.735 0 00.9-1.7c.021-.055.041-.107.064-.16l-.056.135a7.5 7.5 0 01.842-1.489l.073-.1.023-.028a.463.463 0 00-.043.056l.124-.154c.085-.1.171-.2.263-.3a4.857 4.857 0 01.44-.414c.024-.021.049-.039.073-.058s.07-.055 0 0-.008.006.008-.006a4.035 4.035 0 01.827-.479l-.135.056a3.529 3.529 0 01.888-.243l-.15.021a3.61 3.61 0 01.955 0l-.15-.021a3.635 3.635 0 01.9.246l-.135-.056a3.594 3.594 0 01.609.329c.047.032.094.066.141.1s.105.09-.036-.028c.024.021.051.041.077.062.085.071.167.145.244.224s.152.16.224.244c.013.015.06.056.062.077 0-.024-.094-.124-.028-.036.034.047.068.094.1.141a3.594 3.594 0 01.329.609l-.056-.135a3.656 3.656 0 01.246.9l-.021-.15a3.8 3.8 0 010 .991l.021-.15a3.634 3.634 0 01-.246.9l.056-.135a3.594 3.594 0 01-.329.609c-.032.047-.066.094-.1.141s-.09.105.028-.036c-.021.024-.041.051-.062.077-.071.085-.145.167-.224.244s-.16.152-.244.224c-.015.013-.056.06-.077.062.024 0 .124-.094.036-.028a6.106 6.106 0 01-.141.1 3.593 3.593 0 01-.609.329l.135-.056a3.657 3.657 0 01-.9.246l.15-.021a3.61 3.61 0 01-.955 0l.15.021a3.55 3.55 0 01-.888-.243l.135.056a3.76 3.76 0 01-.583-.31c-.087-.056-.173-.115-.256-.179s.075.06.028.023l-.062-.051-.122-.1a5.574 5.574 0 01-.438-.431c-.068-.075-.134-.152-.2-.229l-.085-.107c-.07-.088.064.085.028.036l-.051-.068a.61.61 0 00-.337-.26.564.564 0 00-.694.393.547.547 0 00.056.434 5.767 5.767 0 001.794 1.651 4 4 0 001.239.448 4.4 4.4 0 001.438.009 4.161 4.161 0 001.986-7.29 4.13 4.13 0 00-.978-.613 4.477 4.477 0 00-1.286-.344 4.059 4.059 0 00-2.54.577 5.989 5.989 0 00-1.76 1.719 7.735 7.735 0 00-.9 1.7 3.808 3.808 0 01-.064.16l.056-.135a7.565 7.565 0 01-.842 1.491l-.073.1-.023.028a.463.463 0 00.043-.056l-.124.154c-.085.1-.171.2-.263.3a4.857 4.857 0 01-.44.414c-.024.021-.049.039-.073.058s-.07.055 0 0 .008-.006-.008.006a4.036 4.036 0 01-.827.479l.135-.056a3.529 3.529 0 01-.888.243l.15-.021a3.61 3.61 0 01-.955 0l.15.021a3.634 3.634 0 01-.9-.246l.135.056a3.593 3.593 0 01-.609-.329c-.047-.032-.094-.066-.141-.1s-.105-.09.036.028c-.024-.021-.051-.041-.077-.062-.085-.071-.167-.145-.244-.224s-.152-.16-.224-.244c-.013-.015-.06-.056-.062-.077 0 .024.094.124.028.036-.034-.047-.068-.094-.1-.141a3.594 3.594 0 01-.329-.609l.056.135a3.656 3.656 0 01-.246-.9l.021.15a3.8 3.8 0 010-.991l-.021.15a3.634 3.634 0 01.246-.9l-.056.135a3.594 3.594 0 01.329-.609c.032-.047.066-.094.1-.141s.09-.105-.028.036c.021-.024.041-.051.062-.077.071-.085.145-.167.224-.244s.16-.152.244-.224c.015-.013.056-.06.077-.062-.024 0-.124.094-.036.028.047-.034.094-.068.141-.1a3.592 3.592 0 01.609-.329l-.135.056a3.657 3.657 0 01.9-.246l-.15.021a3.611 3.611 0 01.955 0l-.15-.021a3.55 3.55 0 01.888.243l-.135-.056a3.919 3.919 0 01.583.308c.086.056.173.115.256.179s-.075-.06-.028-.023l.062.051.122.1a5.569 5.569 0 01.438.431c.068.075.134.152.2.229l.085.107c.07.088-.064-.085-.028-.036l.051.068a.61.61 0 00.337.259.564.564 0 00.694-.393.557.557 0 00-.058-.434z"
      fill="#ced2d9"
      stroke="#ced2d9"
      strokeWidth={0.3}
      transform="translate(-105.462 -158.446)"
    />
  </svg>
);

export const daysIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={15.622}
    viewBox="0 0 14.2 15.622"
  >
    <g
      transform="translate(.7 .7)"
      fill="none"
      stroke="#ced2d9"
      strokeWidth={1.4}
    >
      <rect
        data-name="Rectangle 10"
        width={12.8}
        height={12.8}
        rx={2}
        transform="translate(0 1.422)"
      />
      <path
        data-name="Line 2"
        transform="translate(9.244)"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 3"
        transform="translate(3.556)"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0 0L0 2.844"
      />
      <path
        data-name="Line 4"
        transform="translate(0 5.689)"
        strokeLinejoin="round"
        d="M0 0L12.8 0"
      />
    </g>
  </svg>
);

export const dateIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.2}
    height={15.622}
    viewBox="0 0 14.2 15.622"
  >
    <g data-name="Group 18386" stroke="#ced2d9" strokeLinecap="round">
      <g fill="none" strokeWidth={1.4} transform="translate(.7 .7)">
        <rect
          data-name="Rectangle 10"
          width={12.8}
          height={12.8}
          rx={2}
          transform="translate(0 1.422)"
        />
        <path
          data-name="Line 2"
          transform="translate(9.244)"
          strokeLinejoin="round"
          d="M0 0L0 2.844"
        />
        <path
          data-name="Line 3"
          transform="translate(3.556)"
          strokeLinejoin="round"
          d="M0 0L0 2.844"
        />
        <path
          data-name="Line 4"
          transform="translate(0 5.689)"
          strokeLinejoin="round"
          d="M0 0L12.8 0"
        />
      </g>
      <g
        data-name="Ellipse 1"
        transform="translate(.7 .7) translate(7.944 9.244)"
        fill="#ced2d9"
        strokeWidth={1}
      >
        <circle cx={1.422} cy={1.422} r={1.422} stroke="none" />
        <circle cx={1.422} cy={1.422} r={0.922} fill="none" />
      </g>
    </g>
  </svg>
);

export const questionPool = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.159"
    height="15.929"
    viewBox="0 0 16.159 15.929"
  >
    <g
      id="Question_Pool"
      data-name="Question Pool"
      transform="translate(0.89 0.852)"
    >
      <path
        id="Path_21716"
        data-name="Path 21716"
        d="M16.279,8.481v.657a7.14,7.14,0,1,1-4.234-6.526"
        transform="translate(-2 -1.994)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21717"
        data-name="Path 21717"
        d="M18.282,4l-7.14,7.147L9,9"
        transform="translate(-4.002 -2.568)"
        fill="none"
        stroke="#444850"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const tagCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.764}
    height={7.764}
    pointerEvents="none"
    viewBox="0 0 7.764 7.764"
  >
    <g
      data-name="Group 18380"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21632"
        d="M5.784 0L0 5.784"
        transform="translate(.99 .99)"
      />
      <path
        data-name="Path 21633"
        d="M5.784 5.784L0 0"
        transform="translate(.99 .99)"
      />
    </g>
  </svg>
);

export const exclamationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-exclamation-circle"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
    <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
  </svg>
);

export const oliveLogo = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={76.675}
    height={19.286}
    viewBox="0 0 76.675 19.286"
  >
    <g transform="translate(.014 .016)">
      <path
        data-name="Path 36"
        d="M269.552 196.37l-.012 3.729 11.521.036.012-3.728-7.483-.024z"
        transform="translate(-247.596 -181.274)"
      />
      <path
        data-name="Rectangle 3071"
        transform="rotate(-89.828 43.72 -24.825)"
        d="M0 0H3.728V8.189H0z"
      />
      <path
        data-name="Rectangle 3072"
        transform="rotate(-89.828 22.965 -13.3)"
        d="M0 0H9.166V4.039H0z"
      />
      <path
        data-name="Rectangle 3073"
        transform="rotate(-89.828 27.546 -8.703)"
        d="M0 0H9.166V4.039H0z"
      />
      <path
        data-name="Rectangle 3074"
        transform="rotate(-90 18.484 -3.414)"
        d="M0 0H14.603V4.039H0z"
      />
      <path
        data-name="Path 37"
        d="M513.661 30.713l-4.291-.013 7.162 18.353 4.292.013z"
        transform="translate(-466.385 -30.139)"
      />
      <path
        data-name="Rectangle 3075"
        transform="rotate(-90 39.851 -28.361)"
        d="M0 0H3.728V7.735H0z"
      />
      <path
        data-name="Rectangle 3076"
        transform="rotate(-89.828 36.422 -32.15)"
        d="M0 0H3.728V8.189H0z"
      />
      <path
        data-name="Path 38"
        d="M753.643 31.47l-.023 7.145 4.038.013.011-3.418.012-3.728z"
        transform="translate(-689.205 -30.842)"
      />
      <path
        data-name="Path 39"
        d="M753.21 124.1l4.039.013.011-3.728.012-3.729.011-3.728-4.04-.013z"
        transform="translate(-688.831 -105.146)"
      />
      <path
        data-name="Path 40"
        d="M628.63 46.885l6.326-15.912-4.291-.013-4.165 10.472z"
        transform="translate(-573.238 -30.377)"
      />
      <path
        data-name="Path 41"
        d="M24.236 37.159A5.778 5.778 0 0132.3 29.1l2.743-2.743A9.629 9.629 0 0021.491 39.9z"
        transform="translate(-19.329 -24.194)"
      />
      <path
        data-name="Path 42"
        d="M70.674 67.749a5.778 5.778 0 01-8.045 8.043l-2.751 2.751A9.629 9.629 0 0073.425 65z"
        transform="translate(-56.329 -61.43)"
      />
    </g>
  </svg>
);

export const imgIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={15.19} height={15.19}>
    <g
      data-name="Icon feather-image"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40523"
        d="M2.2.7h10.5a1.5 1.5 0 0 1 1.5 1.5v10.5a1.5 1.5 0 0 1-1.5 1.5H2.2a1.5 1.5 0 0 1-1.5-1.5V2.2A1.5 1.5 0 0 1 2.2.7Z"
      />
      <path
        data-name="Path 40524"
        d="M5.95 4.825A1.125 1.125 0 1 1 4.825 3.7 1.125 1.125 0 0 1 5.95 4.825Z"
      />
      <path data-name="Path 40525" d="m14.2 9.7-3.75-3.75L2.2 14.2" />
    </g>
  </svg>
);

export const imageIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-image"
    viewBox="0 0 16 16"
  >
    <path d="M6.002 5.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0" />
    <path d="M2.002 1a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V3a2 2 0 00-2-2zm12 1a1 1 0 011 1v6.5l-3.777-1.947a.5.5 0 00-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 00-.63.062L1.002 12V3a1 1 0 011-1z" />
  </svg>
);

export const userIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M8 8a3 3 0 100-6 3 3 0 000 6zm2-3a2 2 0 11-4 0 2 2 0 014 0zm4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4zm-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10c-2.29 0-3.516.68-4.168 1.332-.678.678-.83 1.418-.832 1.664h10z" />
  </svg>
);

export const phoneIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.718}
    height={12.741}
    viewBox="0 0 12.718 12.741"
  >
    <path
      d="M12.017 9.19v1.71a1.138 1.138 0 01-1.241 1.138 11.261 11.261 0 01-4.911-1.747 11.1 11.1 0 01-3.414-3.417A11.261 11.261 0 01.704 1.94 1.138 1.138 0 011.837.7h1.707a1.138 1.138 0 011.138.979 7.307 7.307 0 00.4 1.6 1.138 1.138 0 01-.256 1.2l-.724.721a9.1 9.1 0 003.414 3.415l.723-.723a1.138 1.138 0 011.2-.256 7.307 7.307 0 001.6.4 1.138 1.138 0 01.979 1.155z"
      fill="rgba(0,0,0,0)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const envelopeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    viewBox="0 0 16 16"
  >
    <path d="M0 4a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v.217l7 4.2 7-4.2V4a1 1 0 00-1-1H2zm13 2.383l-4.708 2.825L15 11.105V5.383zm-.034 6.876l-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 002 13h12a1 1 0 00.966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z" />
  </svg>
);

export const searchIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={15.69} height={15.69}>
    <g
      data-name="Icon feather-search"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40535"
        d="M13.144 6.922A6.222 6.222 0 1 1 6.922.7a6.222 6.222 0 0 1 6.222 6.222Z"
      />
      <path data-name="Path 40536" d="m14.7 14.7-3.383-3.383" />
    </g>
  </svg>
);
export const eyeClosedIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={17.149} height={16.98}>
    <g fill="none" stroke="#9b9ba2">
      <path
        data-name="Path 21633"
        d="M12.752 12.763a7.164 7.164 0 0 1-4.226 1.466C3.546 14.228.7 8.537.7 8.537a13.126 13.126 0 0 1 3.6-4.226m2.732-1.295a6.489 6.489 0 0 1 1.494-.171c4.98 0 7.826 5.692 7.826 5.692a13.162 13.162 0 0 1-1.537 2.27m-4.781-.762a2.134 2.134 0 1 1-3.016-3.017"
      />
      <path data-name="Line 160" d="m1.159.99 15 15" />
    </g>
  </svg>
);

export const layersStackIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={16.016} height={15.538}>
    <g
      data-name="Icon feather-layers"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 40526"
        d="M8.008.7.939 4.234l7.069 3.534 7.069-3.534Z"
      />
      <path data-name="Path 40527" d="m.939 11.303 7.069 3.534 7.069-3.534" />
      <path data-name="Path 40528" d="m.939 7.769 7.069 3.534 7.069-3.534" />
    </g>
  </svg>
);

export const keyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.524}
    height={15.107}
    viewBox="0 0 15.524 15.107"
  >
    <path
      d="M14.117.99l-1.412 1.412M7.33 7.777a3.884 3.884 0 11-5.493 0 3.884 3.884 0 015.493 0zm0 0l2.9-2.9m0 0l2.121 2.113 2.472-2.472-2.118-2.116m-2.472 2.472l2.472-2.472"
      fill="none"
      stroke="#13171f"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);
export const eyeOpenedIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={17.093} height={12.813}>
    <g transform="translate(-.3 -3.3)" fill="none" stroke="#6f75bc">
      <path
        data-name="Path 21634"
        d="M1 9.707S3.853 4 8.847 4s7.847 5.707 7.847 5.707-2.853 5.707-7.847 5.707S1 9.707 1 9.707Z"
      />
      <circle
        data-name="Ellipse 35"
        cx={2}
        cy={2}
        r={2}
        transform="translate(7 7.413)"
      />
    </g>
  </svg>
);

export const divisionIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={14.252} height={14.252}>
    <path
      d="M7.126.7h5a1.428 1.428 0 0 1 1.428 1.428v10a1.428 1.428 0 0 1-1.428 1.428h-5M7.126.7h-5A1.428 1.428 0 0 0 .7 2.128v10a1.428 1.428 0 0 0 1.428 1.428h5M7.126.7v12.852"
      fill="rgba(0,0,0,0)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    />
  </svg>
);

export const clockIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-clock"
  >
    <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
    <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
  </svg>
);

export const checkCircleComplete = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-check-circle"
      viewBox="0 0 16 16"
    >
      <path d="M8 15A7 7 0 118 1a7 7 0 010 14m0 1A8 8 0 108 0a8 8 0 000 16" />
      <path d="M10.97 4.97l-.02.022-3.473 4.425-2.093-2.094a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-1.071-1.05" />
    </svg>
)

export const checkCircleFill = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-check-circle-fill"
    viewBox="0 0 16 16"
  >
    <path d="M16 8A8 8 0 110 8a8 8 0 0116 0zm-3.97-3.03a.75.75 0 00-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-.01-1.05z" />
  </svg>
);

export const thumbsUpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 235.5 250"
    xmlSpace="preserve"
  >
    <path
      d="M194.9 78.7c-23.9-.2-60.7.1-60.7.1s1-4.2 3.5-38.1c2.5-34.2-39.1-38.9-43.5-38-4.5.9-5.2 3-6.5 6.3-1.3 3.3-27.4 69.4-27.4 69.4s-30.2-.2-37 .6c-9.2.7-19.1 9.7-19.1 20.8V227c2 11.1 10.9 16.6 17.8 19.1 7.5.2 22.5.5 29.5.4 8.2-.2 15.4-7.7 18.5-12 6.8 4.3 27.5 11.9 37.2 11.8 11.5-.1 31.2.4 64 0 29.8-.4 36.6-20.7 38.6-28 3.9-13.7 10-45.6 19.7-80.6 13.1-47.4-19.9-58.8-34.6-59zM57.2 224.5c0 2.3-3 6.1-5.7 6.7-3.2 0-23.2.2-25.3 0-1.9-.4-6.9-1.3-6.7-10.4.1-7 .2-113.5 0-118.4-.2-5 3.5-8.4 6.2-8.4h31.5v130.5zm158.3-94.4c-5.9 23.3-17.9 75.6-21.3 87.2-2.5 8.3-14 13.9-20.6 13.7-13.7-.4-60.4.7-67.6 0-15.6-1.5-26.9-8.9-33.2-12.2.1-4.4 0-131 0-131l28.1-69.9s23.6 3 22.1 24.3c-1.1 15.7-4.4 34.9-4.6 44.4-.1 4.5 3.8 7.4 6.4 7.4 2.7 0 50.6-.3 70.9.3 13.7.5 26.1 11.1 19.8 35.8z"
      fill="currentColor"
    />
  </svg>
);

export const playIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    xmlSpace="preserve"
  >
    <circle cx={25} cy={25} r={25} fill="#fff" />
    <path fill="#13171f" d="M31.5 25L18.5 17.5 18.5 32.5z" />
  </svg>
);

export const StarBlankIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-star"
    viewBox="0 0 16 16"
  >
    <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 00-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767l-3.686 1.894.694-3.957a.56.56 0 00-.163-.505L1.71 6.745l4.052-.576a.53.53 0 00.393-.288L8 2.223l1.847 3.658a.53.53 0 00.393.288l4.052.575-2.906 2.77a.56.56 0 00-.163.506l.694 3.957-3.686-1.894a.5.5 0 00-.461 0z" />
  </svg>
)

export const StarIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-star-fill"
    viewBox="0 0 16 16"
  >
    <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
  </svg>
);

export const StarHalfIcon = (props) => (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-star-half"
      viewBox="0 0 16 16"
    {...props}
    >
      <path d="M5.354 5.119L7.538.792A.52.52 0 018 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.54.54 0 0116 6.32a.55.55 0 01-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.5.5 0 01-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 01-.172-.403.6.6 0 01.085-.302.51.51 0 01.37-.245zM8 12.027a.5.5 0 01.232.056l3.686 1.894-.694-3.957a.56.56 0 01.162-.505l2.907-2.77-4.052-.576a.53.53 0 01-.393-.288L8.001 2.223 8 2.226z" />
    </svg>
)

export const bookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-book"
    viewBox="0 0 16 16"
  >
    <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811V2.828zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492V2.687zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 000 2.5v11a.5.5 0 00.707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 00.78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0016 13.5v-11a.5.5 0 00-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783z" />
  </svg>
);

export const checkCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.072}
    height={12.831}
    viewBox="0 0 13.072 12.831"
  >
    <g
      fill="none"
      stroke="#a4a7ad"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21716"
        d="M11.229 5.106v.517A5.615 5.615 0 117.9.486"
        transform="translate(.853 .822)"
      />
      <path
        data-name="Path 21717"
        d="M11.23 1.126l-5.616 5.62L3.93 5.062"
        transform="translate(.853 .822)"
      />
    </g>
  </svg>
);

export const geoMarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-geo-alt"
    viewBox="0 0 16 16"
  >
    <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 018 14.58a31.481 31.481 0 01-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0110 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 002 6c0 4.314 6 10 6 10z" />
    <path d="M8 8a2 2 0 110-4 2 2 0 010 4zm0 1a3 3 0 100-6 3 3 0 000 6z" />
  </svg>
);

export const folderBlueIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width={21.916} height={18.189} viewBox="0 0 21.916 18.189">
    <g data-name="Group 20972" transform="translate(14021.958 -7748.905)">
      <path
        data-name="Path 49286"
        d="M2281.169 518.651v-3.916a2.228 2.228 0 011.972-2.416h4.237a1.742 1.742 0 011.161.464l1.845 1.647h10.729a2.228 2.228 0 011.972 2.416v1.805z"
        transform="translate(-16303.127 7236.586)"
        fill="#397ff5"
      />
      <rect data-name="Rectangle 11501" width={21.915} height={14.144} rx={2} transform="translate(-14021.957 7752.949)" fill="#73a4f8" />
    </g>
  </svg>
);

export const insertPdfIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" xmlSpace="preserve">
    <path d="M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z" fill="#e2e5e7" />
    <path d="M384 128h96L352 0v96c0 17.6 14.4 32 32 32z" fill="#b0b7bd" />
    <path fill="#cad1d8" d="M480 224L384 128 480 128z" />
    <path d="M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z" fill="#f15642" />
    <g fill="#fff">
      <path d="M101.744 303.152c0-4.224 3.328-8.832 8.688-8.832h29.552c16.64 0 31.616 11.136 31.616 32.48 0 20.224-14.976 31.488-31.616 31.488h-21.36v16.896c0 5.632-3.584 8.816-8.192 8.816-4.224 0-8.688-3.184-8.688-8.816v-72.032zm16.88 7.28v31.872h21.36c8.576 0 15.36-7.568 15.36-15.504 0-8.944-6.784-16.368-15.36-16.368h-21.36zM196.656 384c-4.224 0-8.832-2.304-8.832-7.92v-72.672c0-4.592 4.608-7.936 8.832-7.936h29.296c58.464 0 57.184 88.528 1.152 88.528h-30.448zm8.064-72.912V368.4h21.232c34.544 0 36.08-57.312 0-57.312H204.72zM303.872 312.112v20.336h32.624c4.608 0 9.216 4.608 9.216 9.072 0 4.224-4.608 7.68-9.216 7.68h-32.624v26.864c0 4.48-3.184 7.92-7.664 7.92-5.632 0-9.072-3.44-9.072-7.92v-72.672c0-4.592 3.456-7.936 9.072-7.936h44.912c5.632 0 8.96 3.344 8.96 7.936 0 4.096-3.328 8.704-8.96 8.704h-37.248v.016z" />
    </g>
    <path d="M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z" fill="#cad1d8" />
  </svg>
);

export const insertPngIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 512 512" xmlSpace="preserve">
    <path d="M128 0c-17.6 0-32 14.4-32 32v448c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32V128L352 0H128z" fill="#e2e5e7" />
    <path d="M384 128h96L352 0v96c0 17.6 14.4 32 32 32z" fill="#b0b7bd" />
    <path fill="#cad1d8" d="M480 224L384 128 480 128z" />
    <path d="M416 416c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16h352c8.8 0 16 7.2 16 16v160z" fill="#a066aa" />
    <g fill="#fff">
      <path d="M92.816 303.152c0-4.224 3.312-8.848 8.688-8.848h29.568c16.624 0 31.6 11.136 31.6 32.496 0 20.224-14.976 31.472-31.6 31.472H109.68v16.896c0 5.648-3.552 8.832-8.176 8.832-4.224 0-8.688-3.184-8.688-8.832v-72.016zm16.864 7.28v31.856h21.376c8.56 0 15.344-7.552 15.344-15.488 0-8.96-6.784-16.368-15.344-16.368H109.68zM178.976 304.432c0-4.624 1.024-9.088 7.68-9.088 4.592 0 5.632 1.152 9.072 4.464l42.336 52.976v-49.632c0-4.224 3.696-8.848 8.064-8.848 4.608 0 9.072 4.624 9.072 8.848v72.016c0 5.648-3.456 7.792-6.784 8.832-4.464 0-6.656-1.024-10.352-4.464l-42.336-53.744v49.392c0 5.648-3.456 8.832-8.064 8.832s-8.704-3.184-8.704-8.832v-70.752h.016zM351.44 374.16c-9.088 7.536-20.224 10.752-31.472 10.752-26.88 0-45.936-15.36-45.936-45.808 0-25.84 20.096-45.92 47.072-45.92 10.112 0 21.232 3.456 29.168 11.264 7.808 7.664-3.456 19.056-11.12 12.288-4.736-4.624-11.392-8.064-18.048-8.064-15.472 0-30.432 12.4-30.432 30.432 0 18.944 12.528 30.448 29.296 30.448 7.792 0 14.448-2.304 19.184-5.76V348.08h-19.184c-11.392 0-10.24-15.632 0-15.632h25.584c4.736 0 9.072 3.6 9.072 7.568v27.248c0 2.288-1.008 4.448-3.184 6.896z" />
    </g>
    <path d="M400 432H96v16h304c8.8 0 16-7.2 16-16v-16c0 8.8-7.2 16-16 16z" fill="#cad1d8" />
  </svg>
);

export const shareOIcon = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-share"
      viewBox="0 0 16 16"
    >
    <path d="M13.5 1a1.5 1.5 0 100 3 1.5 1.5 0 000-3zM11 2.5a2.5 2.5 0 11.603 1.628l-6.718 3.12a2.499 2.499 0 010 1.504l6.718 3.12a2.5 2.5 0 11-.488.876l-6.718-3.12a2.5 2.5 0 110-3.256l6.718-3.12A2.5 2.5 0 0111 2.5zm-8.5 4a1.5 1.5 0 100 3 1.5 1.5 0 000-3zm11 5.5a1.5 1.5 0 100 3 1.5 1.5 0 000-3z" />
  </svg>
)

export const customiseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-sliders2"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M10.5 1a.5.5 0 01.5.5v4a.5.5 0 01-1 0V4H1.5a.5.5 0 010-1H10V1.5a.5.5 0 01.5-.5zM12 3.5a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5zm-6.5 2A.5.5 0 016 6v1.5h8.5a.5.5 0 010 1H6V10a.5.5 0 01-1 0V6a.5.5 0 01.5-.5zM1 8a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2A.5.5 0 011 8zm9.5 2a.5.5 0 01.5.5v4a.5.5 0 01-1 0V13H1.5a.5.5 0 010-1H10v-1.5a.5.5 0 01.5-.5zm1.5 2.5a.5.5 0 01.5-.5h2a.5.5 0 010 1h-2a.5.5 0 01-.5-.5z"
    />
  </svg>
)

export const stackIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-stack"
    viewBox="0 0 16 16"
  >
    <path d="M14.12 10.163l1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 01-.534 0L.165 11.555a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 01.534 0l7.568 3.784a.3.3 0 010 .535L8.267 8.165a.598.598 0 01-.534 0L.165 4.382a.299.299 0 010-.535L7.733.063z" />
    <path d="M14.12 6.576l1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 01-.534 0L.165 7.968a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z" />
  </svg>
)

export const boxOIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-box2"
    viewBox="0 0 16 16"
  >
    <path d="M2.95.4a1 1 0 01.8-.4h8.5a1 1 0 01.8.4l2.85 3.8a.5.5 0 01.1.3V15a1 1 0 01-1 1H1a1 1 0 01-1-1V4.5a.5.5 0 01.1-.3L2.95.4zM7.5 1H3.75L1.5 4h6V1zm1 0v3h6l-2.25-3H8.5zM15 5H1v10h14V5z" />
  </svg>
)

export const awardIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-award-fill"
    viewBox="0 0 16 16"
  >
    <path d="M8 0l1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z" />
    <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z" />
  </svg>
)


export const chervonRightIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-chevron-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z"
    />
  </svg>
);

export const twitterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-twitter"
    viewBox="0 0 16 16"
  >
    <path d="M5.026 15c6.038 0 9.341-5.003 9.341-9.334 0-.14 0-.282-.006-.422A6.685 6.685 0 0016 3.542a6.658 6.658 0 01-1.889.518 3.301 3.301 0 001.447-1.817 6.533 6.533 0 01-2.087.793A3.286 3.286 0 007.875 6.03a9.325 9.325 0 01-6.767-3.429 3.289 3.289 0 001.018 4.382A3.323 3.323 0 01.64 6.575v.045a3.288 3.288 0 002.632 3.218 3.203 3.203 0 01-.865.115 3.23 3.23 0 01-.614-.057 3.283 3.283 0 003.067 2.277A6.588 6.588 0 01.78 13.58a6.32 6.32 0 01-.78-.045A9.344 9.344 0 005.026 15z" />
  </svg>
);

export const instaLogoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-instagram"
    viewBox="0 0 16 16"
  >
    <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 00-1.417.923A3.927 3.927 0 00.42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 001.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 00-.923-1.417A3.911 3.911 0 0013.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 01-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 01-.92-.598 2.48 2.48 0 01-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 100 1.92.96.96 0 000-1.92zm-4.27 1.122a4.109 4.109 0 100 8.217 4.109 4.109 0 000-8.217zm0 1.441a2.667 2.667 0 110 5.334 2.667 2.667 0 010-5.334z" />
  </svg>
);

export const facebookLogoIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-facebook"
    viewBox="0 0 16 16"
  >
    <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z" />
  </svg>
);

export const linkedInIcon = (
  <svg 
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-linkedin"
    viewBox="0 0 16 16"
  >
    <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854zm4.943 12.248V6.169H2.542v7.225zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248S2.4 3.226 2.4 3.934c0 .694.521 1.248 1.327 1.248zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016l.016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225z"/>
  </svg>
)

export const twitterXIcon = (
  <svg 
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-twitter-x"
    viewBox="0 0 16 16"
  >
    <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
  </svg>
)

export const cashIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-cash"
    viewBox="0 0 16 16"
  >
    <path d="M8 10a2 2 0 100-4 2 2 0 000 4z" />
    <path d="M0 4a1 1 0 011-1h14a1 1 0 011 1v8a1 1 0 01-1 1H1a1 1 0 01-1-1V4zm3 0a2 2 0 01-2 2v4a2 2 0 012 2h10a2 2 0 012-2V6a2 2 0 01-2-2H3z" />
  </svg>
)

export const cartIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-cart"
    viewBox="0 0 16 16"
  >
    <path d="M0 1.5A.5.5 0 01.5 1H2a.5.5 0 01.485.379L2.89 3H14.5a.5.5 0 01.491.592l-1.5 8A.5.5 0 0113 12H4a.5.5 0 01-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 01-.5-.5zM3.102 4l1.313 7h8.17l1.313-7H3.102zM5 12a2 2 0 100 4 2 2 0 000-4zm7 0a2 2 0 100 4 2 2 0 000-4zm-7 1a1 1 0 110 2 1 1 0 010-2zm7 0a1 1 0 110 2 1 1 0 010-2z" />
  </svg>
)

export const infinityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-infinity"
    viewBox="0 0 16 16"
  >
    <path d="M5.68 5.792L7.345 7.75 5.681 9.708a2.75 2.75 0 110-3.916zM8 6.978L6.416 5.113l-.014-.015a3.75 3.75 0 100 5.304l.014-.015L8 8.522l1.584 1.865.014.015a3.75 3.75 0 100-5.304l-.014.015L8 6.978zm.656.772l1.663-1.958a2.75 2.75 0 110 3.916L8.656 7.75z" />
  </svg>
)

export const globeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-globe2"
    viewBox="0 0 16 16"
  >
    <path d="M0 8a8 8 0 1116 0A8 8 0 010 8zm7.5-6.923c-.67.204-1.335.82-1.887 1.855-.143.268-.276.56-.395.872.705.157 1.472.257 2.282.287V1.077zM4.249 3.539c.142-.384.304-.744.481-1.078a6.7 6.7 0 01.597-.933A7.01 7.01 0 003.051 3.05c.362.184.763.349 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9.124 9.124 0 01-1.565-.667A6.964 6.964 0 001.018 7.5h2.49zm1.4-2.741a12.344 12.344 0 00-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332zM8.5 5.09V7.5h2.99a12.342 12.342 0 00-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.612 13.612 0 017.5 10.91V8.5H4.51zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741H8.5zm-3.282 3.696c.12.312.252.604.395.872.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a6.696 6.696 0 01-.598-.933 8.853 8.853 0 01-.481-1.079 8.38 8.38 0 00-1.198.49 7.01 7.01 0 002.276 1.522zm-1.383-2.964A13.36 13.36 0 013.508 8.5h-2.49a6.963 6.963 0 001.362 3.675c.47-.258.995-.482 1.565-.667zm6.728 2.964a7.009 7.009 0 002.275-1.521 8.376 8.376 0 00-1.197-.49 8.853 8.853 0 01-.481 1.078 6.688 6.688 0 01-.597.933zM8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855.143-.268.276-.56.395-.872A12.63 12.63 0 008.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.963 6.963 0 0014.982 8.5h-2.49a13.36 13.36 0 01-.437 3.008zM14.982 7.5a6.963 6.963 0 00-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008h2.49zM11.27 2.461c.177.334.339.694.482 1.078a8.368 8.368 0 001.196-.49 7.01 7.01 0 00-2.275-1.52c.218.283.418.597.597.932zm-.488 1.343a7.765 7.765 0 00-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
  </svg>
)

export const globeBoldIcon =(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.4}
    height={16.4}
    viewBox="0 0 16.4 16.4"
  >
    <g
      transform="translate(-1.188 -1.188)"
      fill="none"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 266"
        cx={7.5}
        cy={7.5}
        r={7.5}
        transform="translate(1.888 1.888)"
      />
      <path
        data-name="Line 836"
        transform="translate(1.888 9.888)"
        d="M0 0L15 0"
      />
      <path
        data-name="Path 40570"
        d="M9.388 1.993a11.314 11.314 0 012.958 7.395 11.314 11.314 0 01-2.958 7.4A11.314 11.314 0 016.43 9.393a11.314 11.314 0 012.958-7.4z"
      />
    </g>
  </svg>
)

export const rssIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.967}
    height={11.574}
    viewBox="0 0 14.967 11.574"
  >
    <g
      data-name="radio (2)"
      transform="translate(-1.302 -3.94)"
      fill="none"
      stroke="#76777a"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <circle
        data-name="Ellipse 437"
        cx={1.357}
        cy={1.357}
        r={1.357}
        transform="translate(7.429 8.37)"
      />
      <path
        data-name="Path 49029"
        d="M11.663 6.85a4.071 4.071 0 010 5.761M5.909 12.6a4.071 4.071 0 010-5.761m7.674-1.909a6.785 6.785 0 010 9.594m-9.594 0a6.785 6.785 0 010-9.594"
      />
    </g>
  </svg>
)

export const archiveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.676}
    height={11.773}
    viewBox="0 0 13.676 11.773"
  >
    <g
      transform="translate(.731 .7)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path data-name="Path 49028" d="M11.104 7.225V0h-10v7.225" />
      <path
        data-name="Rectangle 11316"
        transform="translate(-.031 7.304)"
        d="M0 0H12.276V3.069H0z"
      />
      <path
        data-name="Line 1470"
        transform="translate(5.339 5.002)"
        d="M0 0L1.534 0"
      />
    </g>
  </svg>
)

export const cookieIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23.05}
    height={23.075}
    viewBox="0 0 23.05 23.075"
  >
    <path
      d="M13.787 13.234a1.791 1.791 0 001.267-3.051 1.791 1.791 0 00-2.533 2.533 1.723 1.723 0 001.266.518zm-2.3 5.757a1.769 1.769 0 10-1.267-.518 1.723 1.723 0 001.264.519zm7.484 1.094a1.131 1.131 0 10-.82-.331 1.114 1.114 0 00.817.331zm-3.454 6.909a11.141 11.141 0 01-4.462-.907 11.6 11.6 0 01-6.146-6.146 11.456 11.456 0 01.216-9.413 11.852 11.852 0 013.008-3.9 11.566 11.566 0 014.347-2.3 10.783 10.783 0 015.109-.187 5.219 5.219 0 00.23 2.447 5.027 5.027 0 001.221 1.954 4.952 4.952 0 001.972 1.18 5.116 5.116 0 002.418.178 3.066 3.066 0 00.633 3.152A4.24 4.24 0 0027 14.587a10.791 10.791 0 01-.59 4.75 11.51 11.51 0 01-2.4 3.944 11.9 11.9 0 01-3.771 2.706 11.149 11.149 0 01-4.725 1.007zm0-1.727a9.239 9.239 0 006.793-2.691 10.2 10.2 0 003.02-6.636 5.923 5.923 0 01-2.519-1.713 5.2 5.2 0 01-1.195-2.605 6.427 6.427 0 01-3.929-2.015 6.607 6.607 0 01-1.827-3.943 9.23 9.23 0 00-3.987.691 10.046 10.046 0 00-3.224 2.13A9.842 9.842 0 006.5 11.666a9.65 9.65 0 00-.777 3.814 9.442 9.442 0 002.85 6.937 9.442 9.442 0 006.941 2.85zm.026-9.931z"
      transform="translate(-4 -3.919)"
      fill="#fff"
    />
  </svg>
)


export const plusIcon = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-plus"
    >
      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
    </svg>
  )
  
  export const heartIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-heart"
      viewBox="0 0 16 16"
    >
      <path d="M8 2.748l-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143q.09.083.176.171a3 3 0 01.176-.17C12.72-3.042 23.333 4.867 8 15" />
    </svg>
  )
  
  
  export const heartFilledIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-heart-fill"
      viewBox="0 0 16 16"
    >
      <path
        fillRule="evenodd"
        d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
      />
    </svg>
  )

  export const bookhalfIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-book-half"
      viewBox="0 0 16 16"
    >
      <path d="M8.5 2.687c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 000 2.5v11a.5.5 0 00.707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 00.78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0016 13.5v-11a.5.5 0 00-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
    </svg>
  )


export const dashboardIcon = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={14.801}
      height={16.268}
      viewBox="0 0 14.801 16.268"
    >
      <g
        data-name="Group 27700"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
      >
        <path
          data-name="Path 49075"
          d="M18 275.646l6.6-5.134 6.6 5.134v8.066a1.467 1.467 0 01-1.467 1.467H19.467A1.467 1.467 0 0118 283.712z"
          transform="translate(-17.2 -269.712)"
        />
        <path
          data-name="Path 49076"
          d="M22.401 285.18v-7.334h4.4v7.334"
          transform="translate(-17.2 -269.712)"
        />
      </g>
    </svg>
)

export const coursesIcon= (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14.191}
    height={14.191}
    viewBox="0 0 14.191 14.191"
  >
    <path
      d="M24.8 318.846h4.9a1.4 1.4 0 011.4 1.4v9.793a1.4 1.4 0 01-1.4 1.4h-4.9m0-12.593h-4.9a1.4 1.4 0 00-1.4 1.4v9.793a1.4 1.4 0 001.4 1.4h4.9m0-12.593v12.591"
      fill="rgba(0,0,0,0)"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
      transform="translate(-17.7 -318.046)"
      data-name="Group 27699"
    />
  </svg>
)

export const apprenticeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.584}
    height={14.66}
    viewBox="0 0 15.584 14.66"
  >
    <g
      data-name="Group 27698"
      transform="translate(-17.2 -364.05)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <rect
        data-name="Rectangle 11437"
        width={13.984}
        height={10.208}
        rx={2}
        transform="translate(18 367.702)"
      />
      <path
        data-name="Path 49073"
        d="M27.933 377.91v-11.609a1.451 1.451 0 00-1.447-1.451h-2.9a1.451 1.451 0 00-1.453 1.451v11.609"
      />
    </g>
  </svg>
);

export const documentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.399}
    height={15.099}
    viewBox="0 0 12.399 15.099"
  >
    <g
      data-name="Group 27697"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49071"
        d="M25.075 410.864H20.35a1.35 1.35 0 00-1.35 1.35v10.8a1.35 1.35 0 001.35 1.35h8.1a1.35 1.35 0 001.35-1.35v-7.425z"
        transform="translate(-18.2 -410.064)"
      />
      <path
        data-name="Path 49072"
        d="M25.075 410.864v4.725H29.8"
        transform="translate(-18.2 -410.064)"
      />
    </g>
  </svg>
);

export const communityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.589}
    height={15.098}
    viewBox="0 0 18.589 15.098"
  >
    <g
      data-name="Group 27696"
      transform="translate(-15.2 -456.405)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 21711"
        d="M27.616 470.703v-1.456a2.9 2.9 0 00-2.9-2.9H18.9a2.9 2.9 0 00-2.9 2.9v1.452"
      />
      <ellipse
        data-name="Ellipse 246"
        cx={3.042}
        cy={3.04}
        rx={3.042}
        ry={3.04}
        transform="translate(19.013 457.205)"
      />
      <path
        data-name="Path 21712"
        d="M32.989 470.609v-1.452a2.9 2.9 0 00-2.178-2.81"
      />
      <path data-name="Path 21713" d="M27.907 457.635a2.9 2.9 0 010 5.626" />
    </g>
  </svg>
)

export const marketIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.308}
    height={15.761}
    viewBox="0 0 16.308 15.761"
  >
    <g
      data-name="Group 27695"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49083"
        d="M25.081 502.652L18 506.192l7.081 3.54 7.081-3.54z"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49084"
        d="M18 513.273l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49085"
        d="M18 509.732l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
    </g>
  </svg>
);

export const calendarsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.6}
    height={15.6}
    viewBox="0 0 15.6 15.6"
  >
    <g data-name="Group 27694">
      <g
        data-name="Group 27686"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.6}
        transform="translate(-17.2 -625.2)"
      >
        <rect
          data-name="Rectangle 11524"
          width={14}
          height={13}
          rx={2}
          transform="translate(18 627)"
        />
        <path
          data-name="Line 1554"
          transform="translate(28 626)"
          d="M0 0L0 3"
        />
        <path
          data-name="Line 1555"
          transform="translate(22 626)"
          d="M0 0L0 3"
        />
        <path
          data-name="Line 1556"
          transform="translate(18 632)"
          d="M0 0L14 0"
        />
      </g>
    </g>
  </svg>
);

export const laptopIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-laptop"
    viewBox="0 0 16 16"
  >
    <path d="M13.5 3a.5.5 0 01.5.5V11H2V3.5a.5.5 0 01.5-.5zm-11-1A1.5 1.5 0 001 3.5V12h14V3.5A1.5 1.5 0 0013.5 2zM0 12.5h16a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 010 12.5" />
  </svg>
);

export const replyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-reply-fill"
    viewBox="0 0 16 16"
  >
    <path d="M5.921 11.9L1.353 8.62a.72.72 0 010-1.238L5.921 4.1A.716.716 0 017 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z" />
  </svg>
);


export const playBtnIcon = (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.404 31.143c5.078-2.934 5.078-10.267 0-13.204L19.462 2.942c-5.081-2.938-11.44.732-11.44 6.603V39.54c0 5.871 6.359 9.54 11.44 6.6l25.942-14.997z"
      fill="currentColor"
    />
  </svg>
);

export const deadlineIcon = (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.5h-.5v-1h-1v1h-5v-1h-1v1H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1zm0 9H2V5h8v5.5zM10 4H2V2.5h8V4z"
      fill="currentColor"
    />
  </svg>
);

export const submittedIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 15.072h7v2H7v-2zm0-4h10v2H7v-2zm0-4h10v2H7v-2zm12-4h-4.18c-.42-1.16-1.52-2-2.82-2-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04a2.008 2.008 0 00-1.44 1.19c-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zm7 16.25H5v-14h14v14z"
      fill="currentColor"
    />
  </svg>
);

export const menuBookIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 4.572c1.17 0 2.39.15 3.5.5.75.25 1.4.55 2 1v14.6c0 .25-.25.5-.5.5-.1 0-.15 0-.25-.05-1.4-.75-3.1-1.05-4.75-1.05-1.7 0-4.15.65-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5-1.45 0-3.4.45-4.75 1.1-.05 0-.087.012-.125.025-.038.012-.075.025-.125.025-.25 0-.5-.25-.5-.5V6.072c1.45-1.1 3.55-1.5 5.5-1.5 1.95 0 4.05.4 5.5 1.5 1.45-1.1 3.55-1.5 5.5-1.5zm0 13.5c1.2 0 2.4.15 3.5.5v-11.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5v11.5c1.35-.85 3.8-1.5 5.5-1.5zm2.5-7.24c-.77-.17-1.62-.26-2.5-.26-1.8 0-3.37.35-4.5.99v-1.66c1.26-.54 2.8-.83 4.5-.83.86 0 1.71.09 2.5.24v1.52zm-7 1.73v1.66c1.13-.64 2.7-.99 4.5-.99.88 0 1.73.09 2.5.26v-1.52c-.79-.15-1.64-.24-2.5-.24-1.7 0-3.24.3-4.5.83zm0 2.67c1.26-.54 2.8-.83 4.5-.83.86 0 1.71.08 2.5.24v1.52c-.77-.17-1.62-.26-2.5-.26-1.8 0-3.37.35-4.5.99v-1.66z"
      fill="currentColor"
    />
  </svg>
);

export const certificateIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M12.357 15.069a.679.679 0 01-.188.471.631.631 0 01-.455.195H7.857a.631.631 0 01-.454-.195.68.68 0 01-.189-.471c0-.177.068-.347.189-.471a.631.631 0 01.454-.196h3.857c.17 0 .334.07.455.196.12.124.188.294.188.47zm-.643-3.332H7.857c-.17 0-.334.07-.454.195a.68.68 0 00-.189.471c0 .177.068.346.189.471.12.125.284.195.454.195h3.857c.17 0 .334-.07.455-.195a.679.679 0 00.188-.47.679.679 0 00-.188-.472.631.631 0 00-.455-.195zm9 5.454v5.208a.686.686 0 01-.083.336.656.656 0 01-.236.246.626.626 0 01-.645.002l-1.928-1.145-1.929 1.145a.627.627 0 01-.88-.248.686.686 0 01-.084-.336V20.4H5.286c-.341 0-.668-.14-.91-.39A1.358 1.358 0 014 19.067V8.405c0-.354.135-.693.377-.943.24-.25.568-.39.909-.39h14.143c.34 0 .668.14.909.39s.377.59.377.943v2.543c.406.403.73.888.95 1.424a4.46 4.46 0 010 3.394 4.331 4.331 0 01-.95 1.425zm-5.785 1.876V17.19a4.393 4.393 0 01-1.252-2.634 4.456 4.456 0 01.657-2.857A4.197 4.197 0 0116.6 9.933a4.04 4.04 0 012.83.138V8.405H5.286v10.662h9.643zm4.5-1a4.042 4.042 0 01-3.215 0v3.184l1.286-.763a.625.625 0 01.638 0l1.286.764.005-3.184zm1.286-3.998c0-.593-.17-1.173-.488-1.666a2.917 2.917 0 00-1.298-1.104 2.798 2.798 0 00-1.672-.171 2.863 2.863 0 00-1.481.82c-.405.42-.68.954-.792 1.536a3.1 3.1 0 00.165 1.733c.219.548.59 1.016 1.065 1.346a2.804 2.804 0 002.714.277c.352-.151.67-.372.94-.65.268-.279.48-.61.626-.973.146-.364.22-.754.22-1.148zM13 6.072l.94-2.07 2.06-.93-2.06-.93L13 .072l-.92 2.07-2.08.93 2.08.93.92 2.07zM2.5 6.072l.5-2 2-.5-2-.5-.5-2-.5 2-2 .5 2 .5.5 2z" />
  </svg>
);

export const liveIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.99 5a.75.75 0 010 1.06 8.5 8.5 0 000 12.022.75.75 0 01-1.061 1.06C1.024 15.237 1.024 8.906 4.929 5A.75.75 0 015.99 5zm13.08 0c3.905 3.906 3.905 10.238 0 14.143a.75.75 0 01-1.06-1.06 8.5 8.5 0 000-12.022A.75.75 0 1119.07 5zM8.818 7.83a.75.75 0 010 1.06 4.5 4.5 0 000 6.365.75.75 0 01-1.06 1.06 6 6 0 010-8.485.75.75 0 011.06 0zm7.425 0a6 6 0 010 8.485.752.752 0 01-1.07.01.75.75 0 01.009-1.07 4.501 4.501 0 000-6.364.75.75 0 011.06-1.06M12 10.572a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"
      fill="currentColor"
    />
  </svg>
);

export const activitiesIcon = (
  <svg
    width={24}
    height={25}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 2.072h-4.18c-.42-1.16-1.52-2-2.82-2-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-16c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5v-16h2v3h10v-3h2v16z"
      fill="currentColor"
    />
  </svg>
);

export const remindersIcon = (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <path
        fillRule="nonzero"
        d="M0 0H24V24H0z"
      />
      <circle
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        cx={12}
        cy={12}
        r={9}
      />
      <path
        d="M9 12h2.5a.5.5 0 00.5-.5V7"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const pieIcon = (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm7.93 9H13V4.07c3.61.45 6.48 3.32 6.93 6.93zM4 12c0-4.07 3.06-7.44 7-7.93v15.86c-3.94-.49-7-3.86-7-7.93zm9 7.93V13h6.93A8.002 8.002 0 0113 19.93z"
      fill="currentColor"
    />
  </svg>
);

export const rightArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.22}
    height={15.397}
    viewBox="0 0 7.22 15.397"
  >
    <path
      data-name="Path 49063"
      d="M1.402 1.402l4.818 6.3-4.818 6.294"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
);

export const unitBankIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.308}
    height={15.761}
    viewBox="0 0 16.308 15.761"
  >
    <g
      data-name="Group 27695"
      fill="none"
      stroke="#a4a7ad"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.6}
    >
      <path
        data-name="Path 49083"
        d="M25.081 502.652L18 506.192l7.081 3.54 7.081-3.54z"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49084"
        d="M18 513.273l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49085"
        d="M18 509.732l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
    </g>
  </svg>
);

export const certiIcon = (
  <svg
    width={14}
    height={12}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 6C6.5 6.13261 6.44732 6.25979 6.35355 6.35355C6.25979 6.44732 6.13261 6.5 6 6.5H3C2.86739 6.5 2.74021 6.44732 2.64645 6.35355C2.55268 6.25979 2.5 6.13261 2.5 6C2.5 5.86739 2.55268 5.74021 2.64645 5.64645C2.74021 5.55268 2.86739 5.5 3 5.5H6C6.13261 5.5 6.25979 5.55268 6.35355 5.64645C6.44732 5.74021 6.5 5.86739 6.5 6ZM6 3.5H3C2.86739 3.5 2.74021 3.55268 2.64645 3.64645C2.55268 3.74021 2.5 3.86739 2.5 4C2.5 4.13261 2.55268 4.25979 2.64645 4.35355C2.74021 4.44732 2.86739 4.5 3 4.5H6C6.13261 4.5 6.25979 4.44732 6.35355 4.35355C6.44732 4.25979 6.5 4.13261 6.5 4C6.5 3.86739 6.44732 3.74021 6.35355 3.64645C6.25979 3.55268 6.13261 3.5 6 3.5ZM13 7.59188V11.5C13.0008 11.5881 12.9783 11.6749 12.9347 11.7516C12.8911 11.8282 12.8281 11.892 12.752 11.9364C12.6758 11.9808 12.5893 12.0043 12.5011 12.0045C12.413 12.0047 12.3263 11.9816 12.25 11.9375L10.75 11.0787L9.25 11.9375C9.17366 11.9816 9.08702 12.0047 8.99887 12.0045C8.91072 12.0043 8.82419 11.9808 8.74804 11.9364C8.6719 11.892 8.60885 11.8282 8.56529 11.7516C8.52173 11.6749 8.49921 11.5881 8.5 11.5V10H1C0.734784 10 0.48043 9.89464 0.292893 9.70711C0.105357 9.51957 0 9.26522 0 9V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H12C12.2652 0 12.5196 0.105357 12.7071 0.292893C12.8946 0.48043 13 0.734784 13 1V2.90812C13.3161 3.2108 13.5676 3.57433 13.7394 3.97681C13.9113 4.37928 13.9999 4.81238 13.9999 5.25C13.9999 5.68762 13.9113 6.12072 13.7394 6.5232C13.5676 6.92567 13.3161 7.2892 13 7.59188ZM8.5 9V7.59188C7.95513 7.06639 7.61078 6.3672 7.52637 5.61495C7.44196 4.86269 7.62278 4.10457 8.03764 3.4714C8.45249 2.83822 9.07535 2.36972 9.79874 2.14674C10.5221 1.92376 11.3007 1.96028 12 2.25V1H1V9H8.5ZM12 8.25C11.604 8.41544 11.1791 8.50063 10.75 8.50063C10.3209 8.50063 9.89598 8.41544 9.5 8.25V10.6388L10.5 10.0662C10.5756 10.0231 10.6611 10.0003 10.7481 10.0003C10.8352 10.0003 10.9207 10.0231 10.9963 10.0662L11.9963 10.6388L12 8.25ZM13 5.25C13 4.80499 12.868 4.36998 12.6208 3.99997C12.3736 3.62996 12.0222 3.34157 11.611 3.17127C11.1999 3.00097 10.7475 2.95642 10.311 3.04323C9.87459 3.13005 9.47368 3.34434 9.15901 3.65901C8.84434 3.97368 8.63005 4.37459 8.54323 4.81105C8.45642 5.2475 8.50097 5.6999 8.67127 6.11104C8.84157 6.52217 9.12996 6.87357 9.49997 7.12081C9.86998 7.36804 10.305 7.5 10.75 7.5C11.0455 7.5 11.3381 7.4418 11.611 7.32873C11.884 7.21566 12.1321 7.04992 12.341 6.84099C12.5499 6.63206 12.7157 6.38402 12.8287 6.11104C12.9418 5.83805 13 5.54547 13 5.25Z"
      fill="currentColor"
    />
  </svg>
);

export const playBlueIcon = (
  <svg
    width={41}
    height={41}
    viewBox="0 0 41 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x={0.5} y={0.5} width={40} height={40} rx={20} fill="#33397E" />
    <path
      d="M28.077 18.1178C28.5067 18.3476 28.8662 18.6908 29.1169 19.1104C29.3676 19.5301 29.5 20.0104 29.5 20.5C29.5 20.9896 29.3676 21.4699 29.1169 21.8896C28.8662 22.3092 28.5067 22.6524 28.077 22.8822L16.6132 29.1524C14.7673 30.163 12.5 28.8491 12.5 26.771V14.2299C12.5 12.151 14.7673 10.8379 16.6132 11.8468L28.077 18.1178Z"
      fill="white"
    />
  </svg>
);


export const homeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.966}
    height={14.252}
    viewBox="0 0 12.966 14.252"
  >
    <g
      data-name="Icon feather-home"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 49075"
        d="M4.5 7.5L10.283 3l5.783 4.5v7.068a1.285 1.285 0 01-1.285 1.285h-9A1.285 1.285 0 014.5 14.566z"
        transform="translate(-3.8 -2.3)"
      />
      <path
        data-name="Path 49076"
        d="M8.355 15.852V9.426h3.855v6.426"
        transform="translate(-3.8 -2.3)"
      />
    </g>
  </svg>
)

export const briefcaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-briefcase"
    viewBox="0 0 16 16"
  >
    <path d="M6.5 1A1.5 1.5 0 005 2.5V3H1.5A1.5 1.5 0 000 4.5v8A1.5 1.5 0 001.5 14h13a1.5 1.5 0 001.5-1.5v-8A1.5 1.5 0 0014.5 3H11v-.5A1.5 1.5 0 009.5 1h-3zm0 1h3a.5.5 0 01.5.5V3H6v-.5a.5.5 0 01.5-.5zm1.886 6.914L15 7.151V12.5a.5.5 0 01-.5.5h-13a.5.5 0 01-.5-.5V7.15l6.614 1.764a1.5 1.5 0 00.772 0zM1.5 4h13a.5.5 0 01.5.5v1.616L8.129 7.948a.5.5 0 01-.258 0L1 6.116V4.5a.5.5 0 01.5-.5z" />
  </svg>
)

export const certificateBadge = (
  <svg
    width={92}
    height={93}
    viewBox="0 0 92 93"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_613_1920)">
      <path
        d="M14.265 33.166c-.213-.89-3.482-21.581 21.12-30.258S84.67 9.981 84.03 34.478c-.646 24.497-25.975 36.773-45.94 34.974-19.965-1.8-23.826-36.286-23.826-36.286z"
        fill="#F9F1CA"
      />
      <path
        d="M8.697 45.553h-.049c-.29.04-.431.075-.572.11-.13.03-.257.06-.519.101-.165.025-.272.166-.247.312.024.145.18.251.34.226.29-.04.431-.075.572-.11.13-.03.257-.061.519-.101.16-.025.271-.166.247-.312-.024-.136-.15-.231-.296-.231l.005.005zM20.125 44.486c.111 0 .242.01.48-.025.233-.035.35-.07.456-.1.097-.03.18-.056.369-.08.203-.03.3-.041.407-.051.107-.01.213-.02.432-.055.218-.03.33-.056.436-.08.097-.02.194-.046.388-.071a7.84 7.84 0 01.413-.055c.106-.016.213-.026.422-.056.223-.03.334-.06.441-.085.097-.025.19-.045.383-.076a.942.942 0 01.34 0c.116.015.262.03.51-.005.227-.035.348-.065.45-.095.097-.025.184-.05.369-.08.228-.036.344-.066.45-.096.098-.025.19-.05.374-.08.165-.026.272-.166.248-.312-.024-.136-.15-.232-.296-.232h-.049a3.37 3.37 0 00-.45.096c-.098.025-.185.05-.379.08-.228.036-.35.066-.451.096a2.42 2.42 0 01-.374.08.94.94 0 01-.34 0 1.743 1.743 0 00-.513.005c-.223.03-.335.06-.442.086-.097.025-.189.045-.383.075-.204.03-.31.04-.412.056-.107.015-.214.025-.422.055-.223.03-.33.055-.437.08-.102.02-.194.046-.388.07-.204.03-.3.041-.407.051-.107.01-.218.025-.432.055-.233.035-.354.07-.456.1-.097.031-.18.056-.368.081-.18.025-.267.025-.37.02-.11 0-.242-.01-.48.03-.203.03-.305.04-.412.056a9.4 9.4 0 00-.427.055c-.198.03-.295.04-.402.05-.107.01-.218.02-.437.05-.228.036-.349.071-.456.101-.097.03-.184.05-.368.08-.218.03-.33.056-.437.081a3.005 3.005 0 01-.393.07c-.194.03-.296.036-.393.04a4.712 4.712 0 00-.446.046c-.213.03-.315.05-.422.065l-.412.06a3.21 3.21 0 01-.393.04 4.944 4.944 0 00-.451.046c-.233.035-.354.075-.46.106-.098.03-.176.055-.36.085-.194.03-.286.03-.383.035-.107 0-.233.01-.456.04-.213.03-.315.05-.422.066-.102.02-.204.035-.412.065-.228.035-.35.066-.451.096-.097.025-.185.05-.374.08-.18.025-.267.02-.364.02a2.244 2.244 0 00-.485.025c-.165.026-.271.166-.247.312.024.15.18.252.34.226.179-.025.266-.025.363-.02.117 0 .248.01.485-.025.228-.035.35-.065.456-.095.097-.03.185-.05.374-.08.213-.031.315-.051.422-.066.102-.015.204-.03.412-.066.19-.03.286-.03.383-.035.107 0 .233-.005.456-.04a2.55 2.55 0 00.461-.106c.097-.03.18-.055.359-.085.194-.03.291-.035.393-.04.111-.005.223-.015.446-.045.209-.03.315-.05.422-.066.102-.015.204-.03.412-.065a3.23 3.23 0 01.393-.04c.112-.01.223-.016.446-.046.224-.03.33-.055.437-.08.102-.02.194-.045.393-.07.233-.036.35-.07.456-.101.097-.03.184-.05.368-.08.2-.03.296-.04.403-.05.107-.01.218-.02.437-.051.203-.03.305-.04.407-.055.107-.01.213-.025.427-.056.18-.025.267-.025.369-.02l.024.005zM28.686 43.22c.199-.03.296-.035.398-.045a5.923 5.923 0 00.892-.126c.102-.02.2-.045.398-.07.233-.035.354-.07.46-.1.098-.031.185-.056.374-.081.204-.03.301-.04.408-.05.106-.01.223-.02.441-.05.204-.031.31-.041.412-.056.107-.015.219-.025.432-.055a1.76 1.76 0 01.374-.02c.116 0 .242.005.485-.03.233-.036.354-.071.46-.101.098-.03.185-.056.37-.08.203-.03.305-.04.411-.056.107-.01.219-.025.432-.055.223-.03.335-.056.441-.08.102-.02.194-.046.393-.076.209-.03.31-.045.417-.055.107-.015.214-.026.432-.06.223-.036.335-.061.447-.086a4.017 4.017 0 01.509-.09c-.02-.182-.044-.363-.068-.544-.044 0-.092.01-.15.016a5.13 5.13 0 00-.447.085 3.965 3.965 0 01-.388.075c-.208.03-.31.046-.417.056-.107.015-.213.025-.427.06-.223.03-.334.055-.441.08a3.022 3.022 0 01-.393.07c-.204.03-.306.041-.407.051-.107.01-.219.025-.437.055-.233.035-.354.07-.46.1a1.96 1.96 0 01-.37.081 1.76 1.76 0 01-.373.02c-.116 0-.242-.005-.485.03-.209.03-.31.04-.412.056-.107.015-.214.025-.432.055-.204.03-.3.04-.407.05-.107.01-.219.02-.442.056-.233.035-.354.07-.46.1-.098.03-.185.056-.374.08-.223.03-.335.056-.442.081-.101.02-.194.045-.397.07-.2.03-.296.036-.398.04-.112.01-.228.016-.451.051-.165.025-.272.166-.248.312.025.15.18.251.34.226v.01zM73.65 31.421h-.048a3.43 3.43 0 00-.46.096c-.098.025-.19.05-.389.08-.233.035-.354.07-.46.1-.103.03-.19.05-.384.081a1.023 1.023 0 01-.354 0 1.778 1.778 0 00-.519.005c-.228.035-.34.06-.451.086a4.056 4.056 0 01-.398.075 8.71 8.71 0 01-.422.055c-.107.015-.218.025-.436.06-.223.036-.34.061-.447.081-.102.02-.199.045-.402.075-.209.03-.31.04-.417.056-.107.01-.224.025-.442.055-.237.035-.359.07-.465.1-.102.03-.185.056-.379.086a1.816 1.816 0 01-.378.02c-.117 0-.248-.01-.49.03-.209.03-.315.046-.422.056-.112.015-.218.025-.437.06-.208.03-.305.04-.412.05-.111.01-.223.02-.446.055-.238.036-.359.07-.466.101-.102.03-.189.055-.383.08-.223.036-.34.06-.446.08-.102.021-.2.046-.393.071.063.176.126.352.18.528.164-.025.261-.045.354-.07.101-.02.198-.045.402-.07.238-.036.359-.071.466-.101.102-.03.189-.055.383-.08.204-.03.305-.04.412-.05.112-.01.223-.02.446-.056.209-.03.316-.04.422-.055.112-.016.219-.026.437-.06.184-.03.276-.026.378-.02.117 0 .248.004.49-.031.238-.035.36-.07.466-.1.102-.03.184-.056.378-.086.209-.03.31-.04.417-.055.107-.01.219-.026.442-.056.223-.035.34-.06.446-.085.102-.02.199-.045.403-.07.208-.03.315-.046.422-.06.106-.016.218-.026.436-.061.228-.035.344-.06.451-.086.102-.025.194-.045.398-.075.175-.025.252-.015.354 0 .126.015.267.03.52-.005.232-.035.353-.07.46-.096.102-.03.19-.055.383-.08a3.43 3.43 0 00.46-.096c.098-.025.19-.05.389-.08.16-.025.272-.166.247-.317-.024-.135-.15-.23-.296-.23v.01zM79.578 30.617c-.117 0-.252-.005-.495.03-.213.03-.32.045-.427.055l-.446.06c-.209.03-.31.04-.422.05-.112.01-.228.02-.451.056-.238.035-.364.07-.47.1a2.16 2.16 0 01-.389.081c-.228.035-.344.06-.456.08a4.356 4.356 0 01-.407.076c-.209.03-.306.04-.412.045-.112.01-.233.015-.461.05-.16.026-.272.166-.248.317.03.15.18.252.34.226.204-.03.306-.035.412-.045.112-.01.233-.015.461-.05s.345-.06.451-.08c.107-.026.204-.046.408-.076.237-.035.363-.07.47-.1.102-.03.19-.056.388-.086.209-.03.31-.04.422-.05.112-.01.228-.02.451-.056.214-.03.32-.045.427-.055.112-.015.223-.025.446-.06.19-.025.282-.025.388-.02.117 0 .253.005.495-.03.238-.036.364-.07.47-.101.103-.03.19-.055.384-.085.213-.03.315-.04.427-.056.106-.01.223-.025.446-.055a5.36 5.36 0 00.451-.085c.102-.026.204-.046.407-.076l.427-.06c.112-.015.219-.025.442-.06.233-.036.344-.06.456-.086.106-.025.199-.045.402-.076.175-.025.257-.014.36 0 .125.016.266.03.523-.01.238-.035.359-.07.47-.1.098-.03.195-.055.394-.085.232-.036.354-.066.465-.096.102-.025.194-.05.393-.08.16-.026.272-.166.247-.317-.024-.136-.15-.231-.296-.231h-.048a3.732 3.732 0 00-.466.095c-.102.025-.194.05-.392.08-.238.036-.36.07-.466.101-.102.03-.194.055-.393.08a1.051 1.051 0 01-.359 0 1.71 1.71 0 00-.529.01c-.233.036-.344.06-.456.086a4.152 4.152 0 01-.402.075c-.214.03-.32.046-.427.06l-.442.061a6.02 6.02 0 00-.456.085 4.054 4.054 0 01-.407.076c-.213.03-.315.04-.422.055-.112.01-.223.025-.446.055-.238.036-.364.07-.47.101a2.49 2.49 0 01-.384.086c-.189.03-.281.025-.383.02l.005.015zM16.928 14.073c.175.116.267.17.354.226l.35.221c.165.106.237.166.32.227.087.065.174.135.359.251.184.12.281.17.378.226.087.05.175.096.34.201.194.126.305.176.402.221.092.04.175.08.33.181.17.106.247.166.33.227.087.06.174.125.354.241.17.11.252.166.335.226.087.06.174.12.354.236.15.096.213.156.286.222.077.075.17.16.369.286.194.126.305.176.407.221.092.04.175.076.33.176.17.111.247.166.334.227.088.06.175.12.355.236.184.12.281.176.378.226.087.05.175.096.34.201.174.11.257.166.339.226.087.06.175.121.35.232.189.12.285.17.383.226.087.045.174.09.334.196.14.09.19.146.252.221.073.086.165.191.374.327.189.126.305.176.402.221.093.045.175.08.33.181.19.12.301.176.398.221.087.04.175.086.33.186.136.086.32.055.412-.065a.258.258 0 00-.073-.382c-.189-.12-.3-.176-.397-.221a2.415 2.415 0 01-.33-.186c-.19-.126-.306-.176-.403-.222-.092-.045-.174-.08-.33-.18a.926.926 0 01-.252-.222 1.534 1.534 0 00-.373-.326c-.185-.121-.287-.171-.383-.227-.088-.045-.175-.09-.335-.196a5.77 5.77 0 01-.34-.226c-.087-.06-.174-.12-.349-.231-.184-.12-.281-.171-.378-.227-.088-.05-.175-.095-.34-.2a7.13 7.13 0 01-.334-.227c-.088-.06-.175-.125-.355-.236a2.579 2.579 0 00-.407-.221 2.042 2.042 0 01-.33-.181 1.52 1.52 0 01-.281-.221 2.219 2.219 0 00-.369-.292c-.17-.11-.257-.166-.34-.226-.087-.06-.174-.12-.354-.237a4.413 4.413 0 01-.325-.226c-.087-.06-.174-.125-.358-.241-.194-.126-.306-.176-.403-.221a2.03 2.03 0 01-.33-.181c-.184-.12-.281-.171-.378-.226-.087-.05-.175-.096-.34-.202-.165-.105-.242-.165-.32-.226-.087-.065-.174-.135-.359-.251-.174-.116-.267-.171-.354-.226-.087-.056-.175-.106-.35-.216a.304.304 0 00-.169-.05.306.306 0 00-.242.115c-.097.126-.064.291.072.382v.005zM30.292 22.75c.194.125.305.18.407.226.063.03.126.06.204.105.184-.125.378-.226.577-.301l-.102-.066c-.194-.125-.305-.175-.407-.226a2.682 2.682 0 01-.335-.186.303.303 0 00-.17-.05.3.3 0 00-.242.116.258.258 0 00.072.382h-.004zM60.564 51.45a1.524 1.524 0 01-.282-.222c-.082-.08-.17-.166-.368-.296-.185-.116-.277-.171-.369-.227-.092-.05-.175-.1-.344-.21-.175-.111-.262-.172-.354-.227a.621.621 0 01-.073-.05c-.165.125-.34.231-.52.332l.258.166.35.22c.183.116.276.172.368.227.092.05.174.1.344.211.15.095.214.156.282.221.077.076.17.166.368.297.194.125.306.176.403.221.092.045.174.08.334.186.175.116.267.17.355.226l.349.221c.16.106.233.166.305.227.088.07.175.145.364.266.194.126.315.176.417.221.092.04.175.076.325.176.165.106.238.166.316.226.087.066.174.136.358.257l.355.226.349.221c.165.106.242.166.32.226.087.066.175.136.359.252.184.12.281.17.378.226.092.05.175.095.34.201.194.126.305.176.402.221.093.045.175.08.33.181.17.11.248.166.33.227.087.06.175.125.359.246.17.11.257.166.34.226.087.06.174.12.354.236.15.096.213.156.28.221.079.076.17.161.37.292.194.126.305.176.407.221.092.04.175.08.33.181.17.11.252.166.335.227.087.06.174.12.354.24.184.121.286.177.378.227.092.05.175.096.34.201.174.11.257.171.344.226.087.06.174.12.35.231.188.121.29.176.387.227.092.045.175.09.34.196.14.09.189.146.252.221.073.085.165.191.378.327a3.5 3.5 0 00.403.221c.092.045.174.08.33.18.189.122.3.177.397.222.093.045.175.086.335.186.136.086.32.055.412-.065.097-.126.063-.292-.072-.382a3.17 3.17 0 00-.398-.221c-.087-.046-.175-.086-.335-.186-.194-.126-.305-.176-.402-.222-.093-.045-.175-.08-.335-.186a.93.93 0 01-.252-.22 1.489 1.489 0 00-.379-.328c-.189-.12-.286-.17-.383-.226a3.142 3.142 0 01-.34-.196c-.17-.11-.256-.166-.339-.226-.087-.06-.175-.12-.354-.231-.184-.121-.286-.171-.383-.227-.087-.05-.175-.095-.34-.2a7.285 7.285 0 01-.334-.227c-.088-.06-.175-.12-.355-.236-.194-.126-.31-.176-.407-.221a2.04 2.04 0 01-.33-.181 1.575 1.575 0 01-.281-.221c-.082-.076-.175-.161-.369-.292-.17-.11-.257-.171-.34-.226-.087-.06-.174-.121-.353-.237a6.56 6.56 0 01-.33-.226c-.088-.06-.175-.125-.36-.246a2.579 2.579 0 00-.407-.221 2.05 2.05 0 01-.33-.181c-.184-.121-.28-.171-.378-.227a4.808 4.808 0 01-.34-.2c-.164-.106-.242-.166-.32-.227-.087-.065-.174-.136-.358-.251a12215457194669.545 12215457194669.545 0 00-.708-.447c-.166-.106-.238-.167-.316-.227a4.025 4.025 0 00-.359-.256c-.199-.126-.315-.176-.417-.221-.092-.04-.175-.076-.325-.176a2.96 2.96 0 01-.31-.227c-.088-.07-.175-.145-.364-.266a12.93 12.93 0 00-.36-.226c-.086-.056-.174-.11-.343-.221-.19-.126-.306-.176-.403-.222-.092-.045-.175-.08-.33-.186l.015.005zM86.679 40.767c-.223-.02-.34-.02-.451-.02-.102 0-.199 0-.393-.015a1.051 1.051 0 01-.335-.075 1.612 1.612 0 00-.5-.11 3.083 3.083 0 00-.465-.01c-.102 0-.194.01-.383-.01-.228-.021-.354-.016-.461-.016-.097 0-.194.005-.383-.01h-.03c-.15 0-.28.105-.295.246-.015.151.107.287.267.297.228.02.354.015.46.015.102 0 .195-.005.384.01a3.1 3.1 0 00.465.01c.102 0 .194-.01.383.01.165.015.238.04.33.076.112.04.248.09.495.11.223.02.34.02.451.02.102 0 .199 0 .393.015l.412.04c.107.01.214.026.427.04.223.02.335.02.447.02.101 0 .198 0 .397.021.204.02.3.03.408.045.106.015.213.03.431.046.233.02.36.015.47.005.103-.005.19-.01.38.005.183.015.266.04.358.065.112.03.233.065.476.085l.412.04c.106.01.213.026.431.046a.296.296 0 00.326-.246c.014-.151-.107-.282-.267-.297l-.413-.04a9.063 9.063 0 00-.431-.046c-.18-.015-.267-.04-.364-.065a2.199 2.199 0 00-.475-.085 2.463 2.463 0 00-.471-.005c-.102.005-.19.01-.378-.005a9.6 9.6 0 01-.408-.046 9.127 9.127 0 00-.431-.045c-.224-.02-.335-.02-.447-.02-.102 0-.199 0-.397-.02l-.413-.04c-.106-.01-.213-.026-.427-.04h.015zM78.516 40.023c-.098.005-.185.01-.364 0-.2-.015-.291-.03-.393-.04-.102-.015-.209-.025-.422-.045-.218-.02-.325-.02-.437-.02-.097 0-.194 0-.383-.02-.199-.016-.3-.03-.402-.04l-.413-.041c-.218-.02-.33-.02-.441-.02-.097 0-.19 0-.383-.015a.943.943 0 01-.316-.076c-.106-.04-.237-.09-.49-.11a2.905 2.905 0 00-.45-.01c-.103 0-.185.01-.37-.005a2.895 2.895 0 00-.45-.01c-.102 0-.185.005-.369-.01h-.03c-.15 0-.28.105-.295.246-.015.15.107.286.267.296.223.02.344.016.45.01.103 0 .19-.005.374.01.228.02.35.016.456.01.102 0 .185-.01.369.01.16.016.228.04.315.076.107.04.238.09.49.11.218.02.33.02.442.016.097 0 .189 0 .378.015l.402.04c.102.01.209.025.413.04.218.02.33.02.436.02.097 0 .194 0 .383.02.2.016.296.03.398.04.102.016.209.026.422.046.228.02.35.015.461.005.097-.005.184-.01.364 0 .174.015.252.035.344.06.107.03.228.06.461.086.199.015.3.03.398.04.106.01.208.025.417.04.194.015.29.03.388.046.107.014.213.03.427.05.165.015.31-.096.325-.247.014-.15-.107-.286-.267-.296-.194-.015-.291-.03-.388-.045a7.902 7.902 0 00-.427-.05c-.199-.016-.3-.03-.402-.04-.102-.011-.21-.026-.418-.041a1.7 1.7 0 01-.349-.06 2.23 2.23 0 00-.46-.08 2.364 2.364 0 00-.462-.006v-.005zM9.973 35.015c.101 0 .194 0 .388.01.232.02.359.015.465.01.102 0 .194-.01.384.01.17.015.242.04.334.076.107.04.243.09.5.11.223.02.34.02.456.02.102 0 .199 0 .398.016.208.014.31.03.417.04l.427.04c.223.02.34.02.45.02.102 0 .2 0 .403.02l.412.04c.107.015.219.026.432.046.233.02.36.015.47.01.103-.005.19-.01.38.005.183.015.266.04.363.065.111.03.233.06.475.086l.413.04c.106.01.213.025.431.045.204.015.3.03.403.045.107.015.218.03.441.05.233.02.36.015.47.01.103 0 .195-.01.384.005.223.02.34.02.446.026.102 0 .204 0 .403.02.199.015.296.035.398.05.106.02.223.035.446.055.213.02.32.026.427.035.106.005.208.016.417.036.199.015.29.035.393.05.111.02.223.04.446.06.237.02.368.01.48 0 .102-.01.19-.015.373 0 .195.015.287.036.384.056.111.02.228.045.456.065.16.01.31-.096.325-.246a.279.279 0 00-.267-.297c-.194-.015-.286-.035-.388-.055-.107-.02-.228-.045-.456-.066a2.46 2.46 0 00-.48 0c-.102.01-.19.016-.374 0-.199-.015-.29-.035-.393-.05a4.178 4.178 0 00-.446-.06c-.213-.02-.32-.025-.427-.035-.107-.01-.208-.016-.417-.036-.199-.015-.296-.035-.398-.05a4.744 4.744 0 00-.446-.055c-.223-.02-.335-.02-.446-.02-.102 0-.199 0-.403-.02a3.146 3.146 0 00-.47-.01c-.102.005-.194.01-.379-.005-.203-.015-.3-.03-.402-.046a7.957 7.957 0 00-.437-.05l-.412-.04a9.127 9.127 0 00-.432-.045c-.184-.015-.267-.04-.364-.066-.111-.03-.232-.065-.475-.085a2.471 2.471 0 00-.47-.005c-.102.005-.19.01-.379-.005-.208-.015-.305-.03-.412-.04-.107-.016-.218-.026-.432-.046-.223-.02-.34-.02-.45-.02-.103 0-.2 0-.399-.02l-.417-.04c-.106-.01-.213-.025-.431-.04-.223-.02-.34-.02-.452-.02-.101 0-.198 0-.397-.016a1.05 1.05 0 01-.335-.075c-.111-.04-.242-.09-.5-.11a3.105 3.105 0 00-.465-.01c-.102 0-.194.01-.383-.01a3.036 3.036 0 00-.461-.01c-.102 0-.194 0-.388-.01h-.03c-.15 0-.28.105-.295.245-.015.151.102.287.267.302.228.02.354.015.46.01l-.01-.015zM.272 34.202c.223.02.344.015.45.01.103 0 .19-.005.374.01.228.02.35.015.456.01.102 0 .19-.01.374.01.16.015.232.04.32.075.106.04.237.09.49.11.223.02.334.02.441.02.097 0 .194 0 .383.016.204.015.306.03.403.04l.417.04c.218.02.33.02.437.02.101 0 .194 0 .388.02.198.016.295.03.397.04.102.016.214.026.422.046.228.02.354.015.461.005.102-.005.184-.01.369 0 .174.015.257.04.349.066.107.03.228.065.466.085.198.015.3.03.402.04.107.015.209.025.422.04.16.015.31-.095.325-.246.015-.15-.107-.286-.271-.297-.2-.015-.301-.03-.403-.04-.107-.01-.209-.025-.417-.04-.175-.015-.257-.04-.35-.065-.106-.03-.227-.066-.465-.086a2.369 2.369 0 00-.46-.005c-.103 0-.185.01-.37 0-.198-.015-.295-.03-.397-.04-.102-.015-.209-.025-.422-.045-.219-.02-.33-.02-.437-.02-.097 0-.194 0-.388-.02a4.904 4.904 0 01-.402-.04l-.418-.04c-.218-.021-.334-.021-.441-.021-.097 0-.194 0-.383-.015a.98.98 0 01-.32-.075 1.607 1.607 0 00-.49-.111 2.958 2.958 0 00-.456-.01c-.102 0-.184.01-.374-.01a2.908 2.908 0 00-.45-.01c-.103 0-.19.005-.38-.01H.297c-.15 0-.282.105-.296.246a.279.279 0 00.267.297h.005zM58.58 70.995c-.058-.075-.117-.146-.214-.302a2.488 2.488 0 00-.257-.361 2.215 2.215 0 01-.213-.297.819.819 0 01-.121-.297c-.03-.105-.058-.236-.185-.442-.111-.181-.18-.272-.242-.357a3.749 3.749 0 01-.214-.312 6.142 6.142 0 01-.199-.341c-.048-.091-.101-.177-.208-.352-.112-.181-.175-.267-.233-.352a3.92 3.92 0 01-.208-.317c-.102-.166-.146-.251-.194-.337a4.867 4.867 0 00-.209-.357c-.117-.19-.194-.281-.262-.362-.063-.075-.121-.14-.209-.291-.092-.151-.116-.227-.15-.312a1.849 1.849 0 00-.194-.407 9.57 9.57 0 01-.199-.337c-.048-.09-.102-.176-.208-.352a4.353 4.353 0 01-.19-.332c-.048-.09-.097-.186-.203-.362-.034-.055-.059-.095-.088-.135.005.382.005.769 0 1.156.078.126.122.206.16.276.049.09.102.176.21.352.086.151.116.227.15.312.033.1.077.216.193.407.117.186.194.282.262.362.063.075.117.14.214.292.102.166.145.246.194.337.048.085.097.18.208.356.107.181.175.267.233.352.058.08.112.156.209.317.102.171.15.256.199.337.048.09.102.176.208.352.112.18.175.271.243.357.058.075.111.15.208.311a.817.817 0 01.122.297c.029.106.058.236.184.442.111.186.19.282.257.362.063.076.116.141.209.297.111.186.189.276.252.362.058.075.116.146.208.302a.31.31 0 00.403.105c.145-.075.194-.241.116-.372-.111-.186-.184-.276-.252-.362l.01.005zM26.096 58.392c.073-.065.136-.126.286-.226.165-.11.247-.161.335-.216.087-.056.18-.11.354-.227.18-.12.267-.19.349-.256.078-.06.15-.12.31-.226l.335-.221c.087-.056.175-.11.35-.227.179-.12.266-.19.349-.26.077-.061.145-.122.305-.227a1.04 1.04 0 01.301-.146c.111-.035.247-.08.451-.221.19-.126.276-.206.354-.277a2.33 2.33 0 01.291-.226c.184-.126.272-.2.354-.271.073-.06.14-.121.296-.227a.26.26 0 00.063-.382.3.3 0 00-.237-.11.279.279 0 00-.175.055c-.184.126-.272.201-.354.272-.073.065-.14.12-.296.226a2.941 2.941 0 00-.354.276c-.073.066-.136.126-.291.227-.136.09-.209.115-.3.145-.113.035-.248.08-.452.221-.18.121-.267.191-.35.262-.077.06-.145.12-.305.226l-.335.221a17.9 17.9 0 00-.349.227c-.18.12-.262.19-.349.256-.078.06-.15.12-.31.226-.165.11-.248.161-.335.216-.087.056-.18.11-.354.226-.19.126-.277.207-.354.282-.073.065-.136.126-.287.226-.145.1-.223.13-.315.171-.102.045-.218.096-.412.226-.165.111-.252.166-.335.222-.087.055-.174.11-.349.226-.165.11-.243.16-.33.21-.092.056-.184.112-.364.227a2.935 2.935 0 00-.354.277c-.073.065-.136.12-.286.226-.18.12-.267.19-.35.256-.077.06-.15.12-.31.227-.16.105-.242.155-.33.2-.091.05-.189.106-.373.227a.26.26 0 00-.063.382c.097.12.281.15.417.06.16-.105.243-.15.33-.2.092-.056.19-.111.373-.227.18-.12.267-.191.35-.256.077-.06.15-.121.31-.227.19-.125.277-.206.354-.276.073-.066.136-.126.287-.226.16-.111.247-.156.334-.212.088-.055.184-.11.36-.226.164-.11.251-.166.339-.221.087-.055.174-.11.349-.231.145-.096.223-.131.31-.171.102-.045.223-.096.413-.226.189-.126.276-.212.354-.282h-.005zM32.164 53.988c.097.12.286.146.417.06.18-.12.267-.19.354-.256.078-.06.155-.12.32-.232.19-.13.282-.21.36-.281.072-.065.14-.126.295-.231.165-.11.252-.161.34-.217.092-.055.189-.11.368-.23.17-.116.257-.172.34-.222.092-.055.18-.115.354-.231.15-.1.228-.136.32-.176.102-.045.223-.096.417-.231.097-.066.17-.121.228-.166.063-.287.131-.578.194-.87-.039.025-.077.05-.126.086-.19.13-.281.21-.359.281-.073.065-.136.126-.29.231-.151.1-.229.136-.321.176a2.167 2.167 0 00-.417.227c-.17.115-.257.165-.34.22-.092.056-.18.116-.354.232-.165.11-.247.16-.34.216-.091.055-.188.11-.368.231-.19.131-.281.212-.359.282-.073.07-.14.126-.291.231-.184.12-.272.191-.354.256-.078.06-.155.121-.315.232a.26.26 0 00-.063.382h-.01zM64.764 18.11c.04-.026.083-.056.131-.091.146-.1.228-.13.316-.171.101-.045.218-.095.412-.226.189-.126.276-.211.359-.282.073-.065.136-.125.286-.226.165-.11.247-.16.335-.216.087-.055.18-.11.354-.231.18-.121.267-.191.349-.257.078-.06.15-.12.31-.231.17-.116.253-.166.34-.221.087-.056.174-.116.35-.231.179-.121.266-.191.348-.262.078-.06.15-.12.306-.226.136-.09.209-.116.3-.146.112-.035.248-.08.457-.221.189-.126.276-.206.354-.277.073-.065.136-.125.29-.226.185-.125.277-.2.355-.271.073-.066.14-.12.296-.226.13-.09.165-.262.063-.383a.318.318 0 00-.243-.11.279.279 0 00-.174.055 3.025 3.025 0 00-.354.272c-.073.065-.141.12-.296.226-.19.126-.277.206-.354.276a2.33 2.33 0 01-.291.227c-.136.09-.209.115-.306.145-.112.036-.247.08-.451.222a2.93 2.93 0 00-.35.261c-.077.06-.145.12-.305.226a5.44 5.44 0 01-.34.221c-.087.056-.174.116-.349.232-.18.12-.266.19-.349.256-.078.06-.15.12-.31.226-.165.11-.248.161-.335.216-.087.056-.18.111-.359.232-.19.13-.277.21-.359.281-.073.066-.136.126-.286.226-.15.1-.228.131-.32.171-.102.046-.219.096-.413.226-.092.06-.16.106-.218.141.155.11.3.237.437.387l.014.005zM72.346 13.118c.194-.13.286-.211.368-.282.073-.065.146-.125.306-.236.189-.125.276-.206.364-.276.077-.066.145-.126.31-.237a.26.26 0 00.063-.382.318.318 0 00-.242-.11.279.279 0 00-.175.055c-.19.13-.281.206-.364.281-.077.066-.145.126-.31.237-.194.13-.286.211-.364.281-.078.07-.14.126-.306.237a.26.26 0 00-.063.382c.097.12.286.146.417.06l-.004-.01zM7.504 21.302l.368.141c.093.04.19.075.379.146.203.075.31.1.412.13.092.026.18.05.354.111a.896.896 0 01.272.15c.092.066.199.152.427.237.208.076.325.106.426.126.097.02.175.04.345.1a3.5 3.5 0 00.422.131c.097.02.18.04.349.106.15.055.325-.01.388-.151.063-.14-.014-.302-.165-.357a2.607 2.607 0 00-.422-.126c-.097-.025-.18-.04-.344-.105a2.772 2.772 0 00-.427-.126 2.292 2.292 0 01-.344-.1c-.146-.056-.2-.096-.277-.151-.087-.066-.199-.151-.427-.237a3.498 3.498 0 00-.412-.13 3.544 3.544 0 01-.354-.116l-.369-.14c-.092-.04-.189-.076-.378-.146a.275.275 0 00-.112-.02.304.304 0 00-.276.17c-.063.141.01.302.165.357zM12.611 23.222c.18.066.262.11.354.156.102.05.204.106.418.181.223.08.349.106.46.126.097.02.185.035.36.1.184.07.271.11.358.156.097.045.204.096.413.176.198.075.3.11.397.146l.393.14c.184.07.272.111.364.151.102.046.204.096.412.171.209.08.316.11.422.141.097.03.194.055.379.126.218.08.34.11.446.13.102.02.189.04.364.106.189.07.276.11.373.15.097.046.199.086.403.167.194.07.286.11.383.15.097.04.199.081.398.156.17.066.242.106.33.156.096.055.203.12.426.206.219.08.345.11.452.131.101.02.189.04.363.106.194.07.282.11.379.15a10.52 10.52 0 00.824.297c.097.03.194.055.378.126.195.07.292.11.389.15.097.04.198.08.397.151.209.08.32.11.427.141.097.025.19.05.374.12.155.061.218.106.296.162.092.065.208.15.44.24.22.081.34.112.447.132.102.025.19.045.364.11.213.08.335.11.441.136.097.025.19.045.369.11.15.056.325-.01.388-.15.063-.141-.01-.302-.165-.357a3.192 3.192 0 00-.441-.136c-.097-.025-.19-.045-.369-.11a2.385 2.385 0 00-.446-.131c-.102-.025-.19-.046-.364-.11-.155-.061-.218-.106-.296-.162-.092-.065-.208-.15-.446-.241-.209-.08-.32-.11-.432-.136a3.054 3.054 0 01-.373-.12c-.194-.07-.291-.111-.388-.151a7.302 7.302 0 00-.398-.151 5.978 5.978 0 00-.422-.14c-.097-.031-.19-.056-.378-.127-.194-.07-.282-.11-.379-.15-.097-.04-.199-.086-.402-.161-.219-.08-.34-.106-.451-.13a2.133 2.133 0 01-.364-.106 2 2 0 01-.33-.156c-.097-.056-.204-.12-.427-.206-.194-.07-.286-.111-.383-.151-.102-.04-.199-.08-.398-.156-.189-.07-.276-.11-.373-.15a4.373 4.373 0 00-.408-.167c-.218-.08-.34-.11-.446-.13-.102-.02-.19-.04-.364-.106a5.994 5.994 0 00-.422-.14c-.102-.03-.194-.056-.378-.127-.184-.07-.272-.11-.364-.15-.097-.046-.199-.096-.412-.171-.2-.076-.301-.11-.398-.146l-.393-.14a3.152 3.152 0 01-.359-.157c-.097-.045-.204-.095-.412-.175a2.624 2.624 0 00-.456-.126c-.102-.02-.19-.035-.359-.1-.18-.066-.262-.111-.354-.157a3.56 3.56 0 00-.417-.18.293.293 0 00-.112-.02.304.304 0 00-.276.17c-.063.141.01.297.165.357h.01zM27.842 28.888a1.5 1.5 0 01.33.161c.097.055.209.12.432.206.218.08.344.11.45.13.103.021.19.041.37.106.189.07.285.111.383.151.097.04.198.086.402.161.209.08.32.11.427.14.097.031.194.056.378.127.175.065.272.105.36.135-.185-.256-.36-.517-.54-.779-.004 0-.014 0-.023-.005-.097-.03-.195-.055-.379-.126-.194-.07-.286-.11-.383-.15-.097-.04-.199-.086-.403-.161-.218-.08-.344-.106-.45-.131a2.01 2.01 0 01-.364-.106c-.175-.065-.248-.11-.33-.16-.097-.056-.209-.126-.432-.206a.29.29 0 00-.111-.02.304.304 0 00-.277.17c-.063.141.01.302.165.357h-.005zM73.078 50.083c-.092-.066-.204-.151-.436-.237a5.353 5.353 0 00-.422-.135 3.908 3.908 0 01-.37-.116c-.188-.07-.285-.11-.377-.146-.097-.04-.194-.075-.388-.15a4.758 4.758 0 00-.418-.136 3.842 3.842 0 01-.368-.121 9.288 9.288 0 01-.374-.146c-.097-.04-.194-.08-.393-.156-.213-.08-.334-.105-.446-.13a1.961 1.961 0 01-.354-.106c-.165-.06-.238-.105-.32-.156a2.22 2.22 0 00-.422-.2h-.015c-.873-.122-1.755-.257-2.629-.363.03.01.054.02.088.03.213.08.334.106.441.131.097.02.184.04.354.106.184.07.272.105.369.15.097.04.199.086.398.161.189.07.286.11.378.146.097.04.194.08.393.15.165.061.237.106.32.157.097.055.204.12.422.2.213.081.34.106.441.132.102.02.185.04.354.105.19.07.277.106.374.146.097.04.199.08.393.156.204.075.31.105.417.135.097.03.19.056.369.121.189.07.286.11.378.146.097.04.194.08.393.15.208.076.315.106.422.136.097.026.189.05.368.116.156.055.214.1.291.156.093.065.204.15.437.236.213.08.335.106.437.13.097.026.184.041.359.106.213.08.33.106.431.131.097.025.184.045.36.11.15.056.324-.01.387-.15.063-.14-.014-.302-.165-.357-.213-.08-.33-.106-.436-.136-.097-.025-.185-.045-.36-.11-.213-.08-.334-.106-.436-.131a2.121 2.121 0 01-.359-.106c-.155-.055-.213-.1-.29-.155h.004zM82.789 53.64a3.799 3.799 0 00-.427-.13c-.097-.025-.18-.045-.35-.106a2.21 2.21 0 00-.431-.126c-.097-.02-.18-.04-.35-.105a.935.935 0 01-.276-.15c-.087-.066-.199-.152-.427-.237a3.248 3.248 0 00-.417-.13 3.537 3.537 0 01-.359-.117l-.368-.14a6.703 6.703 0 00-.383-.146c-.2-.075-.306-.106-.408-.136a2.774 2.774 0 01-.359-.12 7.757 7.757 0 01-.364-.146c-.092-.04-.189-.08-.388-.151a2.33 2.33 0 00-.436-.126c-.097-.02-.18-.04-.345-.1a.291.291 0 00-.111-.02.304.304 0 00-.277.17c-.063.141.015.302.165.357.214.08.33.106.437.126.097.02.18.035.344.1.184.071.272.106.364.146.092.04.19.08.388.151.199.076.306.106.407.136.093.025.185.05.36.12l.368.141c.092.04.19.076.383.151a3.5 3.5 0 00.413.13c.092.026.184.051.359.117a.935.935 0 01.276.15c.087.066.199.151.432.237.208.08.325.105.431.13.097.02.18.04.35.1.208.076.325.107.422.132.097.02.18.04.349.105.15.056.325-.01.388-.15.063-.141-.01-.302-.165-.358l.005-.005zM80.62 20.252c.2-.076.301-.131.389-.181.082-.046.15-.08.315-.146.204-.08.306-.136.393-.181.082-.045.15-.086.31-.146a.873.873 0 01.296-.065c.112-.01.252-.02.476-.106.15-.06.223-.221.16-.357a.3.3 0 00-.277-.166.315.315 0 00-.116.02.897.897 0 01-.296.066c-.112.01-.252.02-.475.105-.2.08-.301.136-.393.181-.083.046-.15.086-.31.146-.2.075-.302.13-.389.181-.082.045-.15.085-.315.146a.265.265 0 00-.16.357c.063.14.237.206.388.146h.005zM65.099 25.57c-.03 0-.058.005-.092.01-.054.207-.107.408-.165.609a.96.96 0 01.32-.07 1.61 1.61 0 00.495-.116c.208-.08.31-.131.407-.181.088-.046.175-.086.354-.156.194-.076.291-.106.383-.14.102-.036.2-.071.398-.147.204-.08.306-.125.403-.176.092-.045.18-.085.364-.155.189-.07.28-.106.383-.136.102-.035.203-.07.402-.146.219-.085.325-.146.417-.196a1.9 1.9 0 01.335-.156c.17-.065.252-.08.354-.1a2.27 2.27 0 00.461-.131 45.9 45.9 0 01.786-.287c.19-.07.281-.1.378-.135.102-.036.209-.066.412-.146.214-.08.32-.141.418-.196.087-.05.165-.09.34-.156.203-.08.305-.126.407-.176.092-.045.18-.085.359-.156.184-.07.276-.095.373-.126a5.94 5.94 0 00.422-.14c.199-.076.296-.116.393-.156.097-.04.194-.076.383-.151.184-.07.277-.096.374-.126.106-.03.218-.06.422-.14.218-.086.325-.151.422-.207.087-.05.16-.095.33-.155.179-.07.271-.09.363-.116.102-.025.223-.055.437-.136.199-.075.296-.115.393-.156.097-.04.189-.075.383-.15.213-.08.32-.141.417-.191.087-.05.165-.09.34-.156.15-.06.223-.216.16-.357a.304.304 0 00-.277-.171.47.47 0 00-.116.02c-.214.08-.32.14-.417.191-.088.05-.165.09-.34.156-.199.075-.296.115-.393.156-.097.04-.189.075-.383.15-.18.07-.267.091-.364.116a2.742 2.742 0 00-.436.14c-.219.086-.325.152-.422.207-.088.05-.16.096-.33.156-.184.07-.277.095-.374.126-.106.03-.218.06-.422.14-.198.076-.296.116-.393.156-.097.04-.194.076-.383.15-.184.071-.276.096-.373.127a5.976 5.976 0 00-.825.311c-.092.04-.18.086-.364.156-.213.08-.32.14-.417.196-.087.05-.165.09-.34.156-.189.07-.28.1-.378.13-.102.036-.208.066-.412.147-.19.075-.286.105-.383.14-.102.035-.199.07-.398.146-.17.065-.252.08-.35.1-.11.02-.237.046-.46.131-.218.086-.325.146-.417.196-.087.05-.165.09-.335.161-.189.07-.281.106-.383.136-.102.035-.204.07-.402.146-.204.08-.306.125-.403.176-.092.04-.18.085-.36.15-.188.076-.29.111-.382.146-.102.035-.2.07-.398.146-.209.08-.31.13-.407.176a3.414 3.414 0 01-.355.156c-.155.06-.232.065-.33.075l-.01.005zM38.038 44.839c-.078.02-.175.045-.3.095-.214.08-.321.141-.413.196-.088.05-.16.09-.33.156-.184.07-.276.1-.373.136-.097.035-.2.07-.398.146-.204.075-.301.126-.398.17a2.698 2.698 0 01-.354.151c-.19.07-.281.106-.379.141-.097.035-.194.07-.392.146-.204.08-.306.13-.403.176-.087.045-.17.086-.35.15-.15.061-.227.066-.32.076-.116.01-.261.025-.494.116-.209.08-.315.14-.407.19a1.9 1.9 0 01-.335.157c-.209.08-.316.136-.408.186a3.322 3.322 0 01-.34.156.265.265 0 00-.16.356c.064.141.238.207.389.146.208-.08.315-.135.407-.186.087-.045.165-.085.34-.155.208-.081.315-.141.407-.192.087-.05.16-.09.335-.155.15-.056.228-.066.32-.076a1.7 1.7 0 00.49-.11c.204-.08.306-.131.403-.176.087-.04.17-.086.344-.151l.378-.14c.097-.036.194-.071.388-.147.204-.075.301-.125.398-.17.087-.04.175-.081.354-.151.184-.07.277-.101.374-.136.097-.03.199-.066.397-.141.214-.08.32-.14.413-.196.082-.045.155-.086.305-.146.034-.2.068-.407.092-.608l.02-.01zM24.893 50.525c.194-.076.29-.111.388-.146.102-.035.199-.07.398-.151.208-.08.31-.126.407-.176.092-.045.18-.085.364-.156l.383-.14c.102-.036.204-.071.408-.147.218-.085.325-.145.422-.196.087-.05.164-.09.34-.155.169-.066.251-.08.353-.1.112-.021.238-.046.46-.132.151-.06.224-.216.161-.357a.304.304 0 00-.276-.17.317.317 0 00-.117.02c-.17.065-.257.08-.354.1-.111.02-.238.045-.46.13-.219.086-.326.147-.423.197-.087.05-.165.09-.34.16-.189.076-.28.106-.383.142-.101.035-.203.07-.407.145a4.33 4.33 0 00-.407.176c-.092.046-.18.086-.364.156-.194.076-.291.11-.388.14-.102.036-.2.071-.403.152-.208.08-.31.13-.412.18a3.618 3.618 0 01-.359.156c-.155.06-.233.07-.335.081-.116.01-.262.025-.494.116-.214.08-.325.14-.418.19-.087.05-.165.091-.344.157-.213.08-.32.14-.417.19-.088.046-.17.091-.35.156-.15.06-.223.221-.16.357.064.141.238.206.389.146.213-.08.32-.14.417-.191.087-.045.17-.09.344-.156.218-.08.325-.14.417-.19.088-.051.165-.091.345-.157.155-.06.233-.065.334-.075a1.66 1.66 0 00.5-.116c.209-.08.31-.13.412-.18.092-.046.175-.086.36-.156h.009zM70.464 71.01a1.697 1.697 0 01-.253-.23c-.14-.151-.227-.222-.305-.287-.073-.06-.136-.11-.252-.231a.298.298 0 00-.228-.096.312.312 0 00-.194.065.26.26 0 00-.034.388c.14.15.228.22.305.286.073.06.136.11.252.231.146.156.233.227.31.287.074.055.137.105.253.231a.321.321 0 00.422.03.255.255 0 00.03-.387c-.146-.15-.234-.221-.311-.286h.005zM68.101 68.577a5.81 5.81 0 00-.28-.306c-.122-.131-.166-.202-.22-.282-.057-.09-.125-.196-.28-.367-.156-.166-.253-.241-.34-.312a1.974 1.974 0 01-.272-.251 7.475 7.475 0 01-.267-.297c-.067-.08-.135-.16-.28-.311a3.472 3.472 0 00-.311-.302c-.073-.07-.146-.13-.277-.271a20.735 20.735 0 01-.271-.297 5.761 5.761 0 00-.282-.307c-.15-.16-.233-.23-.315-.306-.073-.066-.145-.126-.276-.267a.874.874 0 01-.185-.271c-.053-.106-.111-.221-.276-.402a2.697 2.697 0 00-.33-.307 2.37 2.37 0 01-.272-.251 2.809 2.809 0 00-.325-.307 2.417 2.417 0 01-.276-.256.298.298 0 00-.228-.096.312.312 0 00-.194.065.26.26 0 00-.034.388c.15.16.242.24.325.306.073.06.145.12.272.257.155.16.247.24.33.306.077.066.145.12.27.257.113.12.147.186.19.271.053.106.112.221.277.402.15.161.232.231.315.307.073.065.145.126.276.266.136.146.204.222.272.297.068.075.136.156.281.306.15.156.228.232.31.307.073.066.146.13.277.272.136.145.2.216.267.296.068.08.136.161.281.312.156.166.253.241.335.312.078.06.146.115.272.251.12.13.165.201.218.281.058.091.121.197.281.368.14.145.204.22.272.296.068.08.14.156.281.307a.321.321 0 00.422.03.26.26 0 00.034-.387c-.136-.146-.203-.221-.271-.297l.004-.01zM61.214 61.197c-.068-.085-.136-.175-.291-.341-.146-.156-.219-.232-.291-.312-.073-.075-.146-.15-.287-.302-.135-.145-.194-.22-.261-.301a4.86 4.86 0 00-.292-.337c-.15-.161-.237-.236-.315-.312-.077-.07-.15-.136-.286-.281-.16-.171-.257-.247-.344-.317a2.167 2.167 0 01-.282-.261 3.512 3.512 0 01-.267-.302c-.067-.08-.14-.166-.286-.327-.14-.15-.208-.231-.281-.306-.073-.08-.14-.161-.291-.317-.126-.136-.17-.206-.223-.292a1.908 1.908 0 00-.291-.372c-.16-.17-.257-.246-.345-.317a2.152 2.152 0 01-.28-.26c-.142-.152-.205-.227-.273-.307a8.322 8.322 0 00-.606-.634c-.078-.07-.15-.136-.286-.282-.14-.15-.214-.23-.281-.306-.073-.08-.141-.161-.286-.317a3.823 3.823 0 00-.326-.316c-.077-.07-.15-.131-.28-.277-.117-.126-.151-.196-.2-.282-.029-.06-.068-.13-.121-.21a1.226 1.226 0 00-.058.25c-.01.222-.01.443-.015.664.117.12.194.186.262.252.078.07.15.13.286.276.141.15.214.226.282.307.072.08.14.16.286.316.15.161.237.237.315.312.078.07.15.136.286.282.141.15.204.226.277.306.068.08.14.166.286.322.16.171.257.246.344.317.083.065.15.12.282.261.126.136.17.206.223.292.063.095.126.2.29.372.142.15.21.226.277.306.073.08.141.161.286.317.141.146.204.221.267.302.068.08.141.166.291.326.156.171.257.247.345.317.082.066.15.12.281.262.15.16.233.236.315.311.078.07.15.136.287.282.135.146.198.221.261.301.068.086.141.171.291.337.146.156.224.232.296.312.073.075.146.15.286.301.136.146.195.222.258.302.068.086.135.176.29.342a.321.321 0 00.423.03.255.255 0 00.029-.387c-.136-.146-.194-.221-.257-.302zM59.84 55.597c-.082-.07-.16-.136-.32-.277a3.877 3.877 0 01-.29-.276c-.078-.08-.155-.161-.325-.307a6.325 6.325 0 00-.345-.281c-.082-.066-.16-.12-.315-.257-.174-.155-.281-.22-.373-.281-.088-.06-.165-.11-.306-.236-.15-.136-.223-.207-.296-.277-.078-.075-.155-.156-.32-.302-.155-.135-.233-.21-.31-.281a8.853 8.853 0 00-.32-.292 1.352 1.352 0 01-.253-.271c-.068-.086-.145-.186-.325-.347-.174-.156-.281-.221-.373-.286-.073-.05-.146-.096-.252-.186-.204.07-.408.14-.612.216.04.04.088.08.146.13.174.156.281.221.378.287.087.055.165.105.306.231.14.12.194.191.257.272.068.09.145.186.325.346.155.136.233.207.31.282.078.075.16.146.32.291.15.136.224.207.301.277.078.075.155.156.32.302.175.15.282.22.374.286.087.056.165.106.305.236.17.146.257.217.35.282.082.065.16.12.31.256.15.131.218.202.291.277.078.08.155.16.325.306.16.141.243.212.325.282.078.07.16.136.315.276.122.106.306.101.422-.01a.262.262 0 00-.01-.387l-.324-.281h-.01zM23.845 10.59c.088.06.17.115.316.245.179.156.28.227.378.292.087.06.165.11.315.241.131.116.175.186.233.272.063.1.14.216.33.387.174.15.266.221.359.292.087.06.165.12.32.256.16.14.238.211.315.286.083.076.16.151.325.292.17.15.267.221.354.292a7.284 7.284 0 01.63.548c.083.075.16.15.33.296.18.156.287.226.384.292.087.06.165.11.315.236.121.105.31.1.422-.01a.258.258 0 00-.01-.387c-.18-.156-.286-.226-.383-.292-.092-.06-.17-.11-.315-.241a7.338 7.338 0 01-.31-.287c-.078-.075-.16-.15-.325-.301-.17-.151-.267-.221-.355-.287a4.755 4.755 0 01-.32-.261c-.16-.14-.237-.216-.315-.287-.082-.075-.16-.15-.325-.291a4.392 4.392 0 00-.359-.287c-.087-.065-.165-.12-.32-.256-.131-.116-.175-.186-.233-.272-.068-.1-.14-.216-.33-.387a2.742 2.742 0 00-.378-.286 3.759 3.759 0 01-.315-.242c-.175-.155-.277-.22-.374-.291-.082-.06-.165-.116-.315-.247a.31.31 0 00-.417.01.258.258 0 00.01.388c.174.155.276.22.368.286h-.005zM78.899 35.634c-.18 0-.262-.01-.36-.025-.101-.015-.218-.035-.412-.035h-.067c-.233 0-.355.025-.461.04-.102.015-.19.03-.379.03-.213 0-.32.01-.422.015-.101 0-.208.01-.412.01-.19 0-.286 0-.383-.015a3.492 3.492 0 00-.456-.015c-.238 0-.359.025-.47.05-.097.02-.185.035-.364.04-.194 0-.291 0-.393-.01-.107-.005-.223-.015-.446-.01-.214 0-.32.01-.422.01-.102 0-.209.005-.413.01-.199 0-.29 0-.393-.01-.111-.005-.223-.015-.446-.01-.218 0-.335.015-.441.026-.102.01-.2.02-.393.02-.233 0-.354.025-.461.04-.102.015-.184.03-.374.035h-.402c-.107 0-.218-.01-.437 0h-.834c-.18 0-.267-.01-.364-.025-.111-.015-.237-.04-.475-.03-.233 0-.354.025-.466.04-.102.015-.184.03-.373.035h-.839c-.223 0-.335.015-.442.025-.102.01-.194.02-.393.026h-.834c-.223 0-.34.02-.446.03-.102.01-.194.02-.388.025a1.13 1.13 0 01-.335-.04c-.053-.015-.111-.026-.184-.04.048.195.097.392.14.593.097.02.214.035.388.03.224 0 .34-.015.447-.03.102-.01.194-.02.388-.026h.839c.223 0 .335-.015.441-.025.102-.01.2-.02.393-.025h.839c.233 0 .355-.025.466-.045.102-.015.184-.03.374-.035.179 0 .266.01.363.025.112.015.238.035.476.035h1.241c.107 0 .219.01.437 0 .233 0 .354-.025.46-.04.103-.015.185-.03.374-.035.223 0 .335-.015.442-.026.102-.01.194-.02.392-.02.195 0 .291 0 .393.01.112.005.224.016.447.01.213 0 .315-.01.422-.01.106 0 .208-.005.412-.01.194 0 .291 0 .388.01.111.01.223.016.446.01.238 0 .36-.025.47-.05.098-.015.185-.035.364-.035.19 0 .287 0 .384.015.106.01.228.02.456.015.213 0 .32-.01.427-.015.101 0 .203-.005.412-.01.228 0 .354-.025.46-.04.102-.015.19-.03.379-.035.18 0 .262.01.359.025.111.02.242.04.48.035.165 0 .296-.13.291-.282 0-.15-.14-.271-.306-.266l-.004.005zM21.692 39.692c.232 0 .354-.02.46-.036.102-.015.194-.025.388-.03.233-.005.36-.025.47-.04.103-.015.195-.03.384-.035.17 0 .248.015.345.04.116.025.257.06.514.055.228 0 .344-.015.456-.03.102-.01.198-.02.397-.025.427-.01.427 0 .854-.01.228 0 .34-.015.451-.025.102-.01.204-.02.403-.02h.858c.238 0 .364-.025.47-.046.103-.015.19-.03.384-.035.184 0 .272.01.373.026.112.014.243.04.485.03h1.267c.111 0 .223.005.446 0 .233-.005.359-.026.47-.04.102-.016.194-.03.383-.036.228 0 .34-.015.451-.025.102-.01.204-.02.403-.025.204 0 .3 0 .403.005.111.005.228.01.45.01.22 0 .326-.01.433-.01.106 0 .208-.01.421-.01.2 0 .296 0 .398.01.112.005.228.015.456.01.238 0 .369-.03.48-.05a2.686 2.686 0 01.766-.025c.112.01.234.02.466.015.219 0 .325-.01.432-.015h.121a22.22 22.22 0 00-.14-.543c-.107 0-.214.01-.422.01-.194 0-.291 0-.393-.015a3.708 3.708 0 00-.466-.015c-.242 0-.368.03-.48.05-.102.02-.19.035-.373.04-.2 0-.296 0-.403-.01-.112-.005-.228-.015-.456-.01-.218 0-.325.01-.432.01-.106 0-.213.005-.422.01-.203 0-.3 0-.402-.005a8.631 8.631 0 00-.451-.01c-.228 0-.34.015-.451.025-.102.01-.2.02-.403.025-.238 0-.359.025-.47.04-.103.016-.19.03-.384.036h-.412c-.112 0-.223-.005-.446 0h-.854c-.184 0-.272-.01-.373-.026a2.315 2.315 0 00-.486-.03c-.237 0-.363.026-.47.046-.102.015-.19.03-.383.035h-.859c-.228 0-.34.015-.45.025-.108.01-.205.02-.404.025-.426.01-.426 0-.853.01-.228 0-.345.015-.456.03-.102.01-.199.02-.398.025-.17 0-.247-.015-.344-.04-.112-.025-.257-.06-.514-.055-.233 0-.36.025-.466.04-.102.015-.194.03-.388.03-.233.005-.354.02-.466.035-.102.016-.194.03-.388.03-.165 0-.296.126-.29.282 0 .151.14.272.305.267h.005zM20.086 39.169c-.102.01-.204.025-.402.025a1.19 1.19 0 01-.35-.04c-.111-.026-.237-.056-.46-.056h-.054c-.238 0-.359.025-.47.04-.107.015-.194.03-.389.036-.232 0-.358.02-.465.035a2.935 2.935 0 01-.393.03c-.165 0-.296.13-.291.281 0 .151.14.272.305.267a3.76 3.76 0 00.471-.035c.102-.015.194-.026.393-.03.238 0 .359-.026.47-.04.102-.016.194-.03.389-.03.174 0 .247.014.349.04.121.03.257.065.514.055.228 0 .344-.015.46-.03.102-.01.2-.02.403-.026.165 0 .296-.13.291-.281 0-.151-.136-.272-.305-.267a3.08 3.08 0 00-.461.03l-.005-.005zM24.51 55.597c.17-.09.252-.13.34-.176.091-.045.184-.09.363-.19.184-.101.276-.162.359-.217.082-.05.155-.1.32-.191.17-.09.257-.136.345-.181.092-.045.179-.09.358-.186.185-.1.277-.166.364-.221.078-.056.15-.106.31-.191a.882.882 0 01.301-.11c.112-.026.253-.056.461-.172.194-.105.286-.176.369-.236.077-.055.14-.106.296-.191.194-.106.286-.171.368-.231.078-.056.146-.106.301-.191a.266.266 0 00.107-.377.305.305 0 00-.408-.096c-.189.106-.286.171-.368.231-.078.056-.146.106-.301.191-.194.106-.286.176-.369.237-.077.055-.14.105-.296.19a.9.9 0 01-.295.111c-.112.025-.253.056-.466.171-.19.1-.277.161-.364.221-.078.056-.15.101-.31.191-.17.09-.257.136-.345.181-.092.046-.18.096-.359.191-.184.101-.276.161-.363.217-.078.05-.156.1-.32.19-.17.091-.253.136-.345.177-.092.045-.184.09-.364.186a.266.266 0 00-.106.377c.087.13.266.17.407.095h.01zM32.853 50.927c.174-.096.262-.141.349-.181l.359-.191c.189-.1.276-.161.364-.222a2.26 2.26 0 01.315-.19.881.881 0 01.3-.111c.112-.025.253-.055.466-.171.194-.106.286-.176.374-.236.077-.056.145-.106.3-.191a2.88 2.88 0 00.37-.232c.077-.055.145-.105.305-.19a.266.266 0 00.106-.378.312.312 0 00-.257-.136.321.321 0 00-.15.04 2.902 2.902 0 00-.369.232c-.077.055-.145.106-.305.191-.194.106-.286.176-.374.236-.077.056-.145.106-.3.191a.881.881 0 01-.301.11c-.112.026-.252.056-.466.172-.189.1-.281.166-.368.221-.078.05-.15.1-.316.191-.174.096-.262.136-.349.186-.092.045-.18.09-.359.191-.19.1-.276.161-.364.216-.077.056-.155.1-.32.191-.17.096-.257.136-.344.181-.092.046-.185.09-.369.191-.14.076-.19.247-.107.372.083.131.267.176.408.096.17-.09.257-.136.344-.176.092-.045.184-.09.369-.191.184-.1.276-.161.364-.216.077-.056.155-.1.32-.191l.005-.005zM65.55 22.187l.02-.01c.184-.1.276-.151.368-.196.097-.05.194-.096.383-.201.2-.106.296-.171.383-.232.088-.055.165-.11.34-.206.15-.08.228-.1.325-.125.121-.03.257-.06.48-.181a2.93 2.93 0 00.393-.247c.083-.06.155-.115.325-.206.204-.11.3-.18.388-.241.083-.06.16-.11.33-.206a.266.266 0 00.107-.377.312.312 0 00-.257-.136.32.32 0 00-.15.04c-.204.11-.302.181-.389.242-.082.06-.155.11-.325.206-.204.11-.305.18-.393.246-.082.06-.155.116-.325.206-.15.08-.228.1-.325.12-.12.03-.257.061-.48.182-.199.105-.296.17-.388.231-.082.055-.165.11-.34.206-.184.1-.276.146-.368.196-.02.01-.034.02-.053.03-.01.222-.025.438-.04.654l-.009.005zM10.962 29.763s-.039-.005-.063-.005c-.136 0-.262.09-.29.216-.035.15.067.292.232.322.238.045.369.055.485.06.107.005.204.015.403.05.208.04.31.066.417.09.111.026.223.056.45.101.214.04.321.066.428.086.111.025.223.05.446.09.194.035.281.07.378.106.112.04.238.085.48.136.238.045.374.05.486.055.111.005.203.01.402.05.214.04.315.066.427.09.111.026.223.05.446.096.228.045.35.055.461.07.107.01.213.026.417.066.218.04.325.065.432.085.111.025.218.046.441.09.233.046.35.056.466.071.107.01.209.02.412.06.18.036.252.07.35.116.111.055.242.116.499.166.238.045.369.055.48.06.107.005.204.015.403.05.238.046.359.056.475.066.107.01.209.015.408.055.16.03.32-.065.349-.21.034-.147-.068-.292-.233-.323a3.939 3.939 0 00-.48-.065c-.107-.01-.209-.015-.408-.055a3.09 3.09 0 00-.48-.06 3.025 3.025 0 01-.407-.05c-.18-.036-.252-.071-.35-.116a1.764 1.764 0 00-.5-.166c-.232-.046-.353-.056-.465-.07a3.556 3.556 0 01-.412-.061c-.213-.04-.325-.065-.432-.085-.106-.02-.223-.046-.441-.091-.228-.045-.35-.055-.46-.07-.108-.015-.21-.025-.418-.066-.214-.04-.315-.065-.422-.085a18.59 18.59 0 00-.446-.096 3.126 3.126 0 00-.49-.06 2.176 2.176 0 01-.398-.05c-.194-.035-.276-.07-.378-.106-.112-.04-.238-.09-.48-.136-.219-.04-.325-.065-.432-.085a9.725 9.725 0 00-.442-.09c-.208-.04-.31-.066-.417-.091-.111-.025-.223-.055-.45-.096a3.083 3.083 0 00-.486-.06 2.215 2.215 0 01-.402-.05l.01-.005zM22.506 32.507c.2.04.291.066.393.096.112.035.228.07.461.115.243.046.374.05.49.056.107 0 .199.005.388.045.204.04.296.065.398.095.111.03.223.066.456.106l.436.08.427.08c.204.041.3.066.403.096.111.03.223.06.45.101.229.045.345.055.457.07.107.015.208.025.412.066.238.045.364.05.48.06.107 0 .204.01.393.045.209.04.306.066.412.09.107.026.224.056.447.096.213.04.315.06.422.086.111.025.218.045.436.09.19.035.272.066.374.106.107.04.233.085.475.136.238.045.369.05.48.06.107 0 .2.01.393.045.209.04.31.06.417.086.107.025.219.05.442.09.228.04.344.06.456.07.106.01.208.026.412.066.213.04.32.065.422.085.107.025.218.046.437.09.223.04.34.056.45.066-.17-.211-.339-.427-.514-.638l-.242-.05c-.107-.02-.218-.046-.437-.091-.227-.04-.344-.055-.456-.07-.106-.016-.208-.026-.412-.066-.208-.04-.31-.065-.417-.085a12.85 12.85 0 00-.441-.096c-.238-.045-.364-.05-.48-.055-.107 0-.2-.01-.393-.045-.19-.036-.272-.07-.37-.106-.11-.04-.232-.085-.474-.136-.214-.04-.316-.065-.422-.085-.107-.025-.219-.045-.437-.09-.209-.04-.306-.066-.412-.091-.107-.025-.223-.055-.446-.096a3.041 3.041 0 00-.48-.06 2.131 2.131 0 01-.394-.05c-.228-.04-.344-.056-.456-.07-.106-.016-.208-.026-.412-.066-.204-.04-.3-.065-.402-.096-.112-.03-.224-.06-.452-.1l-.436-.08-.427-.08a4.38 4.38 0 01-.403-.096 5.823 5.823 0 00-.45-.106c-.243-.045-.374-.05-.49-.055-.107 0-.2-.005-.389-.04a4 4 0 01-.393-.096 3.669 3.669 0 00-.46-.116c-.02 0-.04-.005-.058-.005-.141 0-.262.09-.291.217-.035.145.072.291.232.321l-.005.005zM73.316 43.678c.043.005.092.015.15.025.199.04.291.06.398.086.107.025.213.05.431.095.204.04.306.06.408.086.107.025.213.045.422.085.18.035.262.066.354.1.107.04.228.086.46.131.229.046.355.05.467.056.101 0 .194.01.378.045.204.04.3.06.402.085.107.026.214.05.427.09.219.041.335.056.442.066.102.01.199.025.393.06l.407.081c.107.02.209.045.422.085.223.04.34.056.451.066.102.01.199.02.393.055.165.03.233.065.32.11.107.05.233.116.485.161.228.046.354.05.461.056.102.005.194.01.383.045.228.045.35.05.461.06a2.6 2.6 0 01.383.05c.16.03.32-.065.354-.21.034-.146-.068-.292-.233-.322-.228-.045-.349-.05-.456-.06a2.615 2.615 0 01-.383-.05c-.228-.046-.354-.051-.46-.056a1.968 1.968 0 01-.379-.05c-.165-.03-.233-.066-.325-.111-.106-.05-.233-.116-.485-.16a4.767 4.767 0 00-.446-.066 3.937 3.937 0 01-.388-.056l-.408-.08c-.106-.02-.208-.045-.422-.085-.218-.04-.334-.056-.441-.07a3.212 3.212 0 01-.393-.061c-.204-.04-.3-.06-.402-.086a7.209 7.209 0 00-.427-.09c-.228-.045-.36-.05-.466-.055-.102 0-.194-.01-.378-.046a1.844 1.844 0 01-.354-.1c-.107-.04-.223-.086-.461-.13-.204-.041-.306-.061-.408-.086a9.4 9.4 0 00-.422-.086 9.668 9.668 0 01-.397-.085c-.107-.025-.214-.05-.432-.096-.228-.045-.354-.05-.466-.055h-.01c.083.181.15.372.204.568l-.014.005zM82.4 24.811a.273.273 0 00-.203.342c.044.146.209.231.369.186.213-.055.32-.1.412-.14.087-.036.165-.066.335-.117.213-.055.32-.1.417-.14.087-.035.165-.07.334-.116a.828.828 0 01.31-.035c.117 0 .258.005.49-.055.21-.056.311-.09.408-.131.088-.035.175-.066.35-.11.16-.04.247-.192.203-.338a.293.293 0 00-.286-.196c-.029 0-.053 0-.082.01-.209.056-.31.091-.408.131-.087.03-.17.066-.35.11-.15.041-.217.036-.31.036-.111 0-.257-.005-.49.055-.213.056-.32.1-.417.141-.087.035-.165.07-.334.116-.209.055-.32.1-.412.135-.088.036-.166.07-.34.116h.005zM78.603 25.776c-.19.05-.286.066-.383.086-.107.02-.219.04-.432.095s-.32.09-.422.126c-.097.03-.184.065-.373.115-.224.06-.335.106-.437.151-.092.04-.175.07-.354.12-.194.051-.286.071-.388.091-.107.02-.214.046-.422.1l-.398.102-.412.1a1.565 1.565 0 01-.36.06c-.11.01-.242.02-.47.08-.223.061-.334.106-.436.152-.092.04-.17.07-.35.12-.194.05-.29.07-.392.096-.102.025-.209.045-.418.1-.213.056-.32.096-.422.131a3.819 3.819 0 01-.373.116l-.398.1c-.102.025-.208.05-.412.106-.213.055-.32.095-.427.136a3.654 3.654 0 01-.368.115c-.16.04-.238.04-.335.04-.117 0-.262 0-.505.066a3.1 3.1 0 00-.431.145c-.093.04-.175.07-.355.121-.218.06-.33.106-.431.146-.092.035-.175.07-.36.12a.277.277 0 00-.203.342c.049.146.214.227.369.186.218-.06.33-.105.431-.145.093-.036.175-.07.36-.121.223-.06.334-.106.431-.146.092-.04.175-.07.354-.12.16-.04.238-.04.335-.04.116 0 .262 0 .504-.061.214-.055.32-.096.422-.136a3.68 3.68 0 01.369-.115l.398-.1c.102-.026.204-.051.407-.107.214-.055.32-.095.422-.13a6.948 6.948 0 01.766-.211c.102-.02.21-.046.418-.1.223-.061.334-.106.436-.152.092-.04.17-.075.35-.12.174-.046.257-.05.358-.06.112-.01.243-.02.471-.081l.393-.1c.102-.026.208-.05.412-.106.194-.05.286-.07.388-.09.107-.02.214-.046.422-.101.223-.06.335-.106.437-.151.092-.04.174-.07.354-.12.213-.056.32-.096.422-.131.097-.036.184-.066.373-.116.19-.05.287-.065.383-.085.107-.02.219-.04.432-.096.204-.055.306-.085.408-.11.097-.03.198-.056.397-.111.16-.04.248-.191.204-.337a.293.293 0 00-.286-.196c-.024 0-.053 0-.082.01-.204.055-.306.08-.408.11-.102.026-.199.056-.398.111h.015zM65.065 29.4c-.092.041-.17.071-.35.122-.188.05-.285.07-.382.09-.102.02-.209.045-.418.1-.194.05-.29.076-.392.101l-.209.05c-.117.217-.243.433-.369.644.088-.01.19-.025.335-.066.194-.05.291-.075.393-.095l.407-.1c.19-.05.287-.07.383-.091.102-.02.214-.045.418-.1a3.1 3.1 0 00.431-.146c.093-.04.17-.07.35-.121.208-.055.315-.096.417-.126.092-.03.184-.065.373-.115a.277.277 0 00.204-.342.293.293 0 00-.286-.196c-.03 0-.054 0-.083.01-.213.055-.315.09-.417.126-.097.03-.184.065-.373.11-.219.06-.335.106-.432.15v-.004zM21.677 48.223c.097-.04.18-.07.364-.121.165-.045.247-.045.344-.045.121 0 .267 0 .51-.066.218-.055.33-.095.431-.135.097-.036.184-.07.378-.121.204-.055.306-.075.408-.1.107-.026.209-.05.417-.106.218-.056.325-.096.427-.13.097-.036.19-.066.383-.117.199-.055.3-.075.403-.1.107-.025.213-.05.427-.106.228-.06.344-.11.446-.156.092-.04.175-.075.359-.125.18-.05.267-.055.368-.066.117-.01.248-.02.48-.08.2-.055.301-.08.403-.1.107-.026.214-.05.422-.106.2-.05.296-.07.398-.096.107-.02.218-.045.432-.1.228-.06.34-.11.441-.15.097-.041.175-.076.364-.127.218-.055.325-.095.427-.13a5.99 5.99 0 01.776-.206c.111-.02.223-.04.441-.1.209-.056.31-.086.417-.111.102-.03.204-.056.408-.111.194-.05.29-.066.388-.086.111-.02.223-.04.446-.095.228-.06.344-.116.446-.161.093-.04.17-.075.35-.126.189-.05.286-.065.383-.08.111-.015.228-.035.45-.096.21-.055.311-.085.418-.115.102-.03.204-.06.407-.11.224-.061.34-.106.442-.152.092-.04.18-.07.364-.12.16-.04.252-.196.203-.342a.293.293 0 00-.286-.196c-.029 0-.053 0-.082.01a2.8 2.8 0 00-.442.15c-.097.04-.18.076-.364.121-.208.056-.31.086-.417.116-.102.03-.203.055-.402.11-.19.05-.282.066-.383.081a3.268 3.268 0 00-.456.096c-.233.06-.345.11-.452.16-.092.04-.17.076-.354.126-.194.05-.286.07-.388.085-.111.02-.223.04-.446.096-.208.055-.31.086-.412.116-.102.03-.204.055-.408.11-.194.05-.29.07-.393.086-.111.02-.223.04-.44.1-.22.056-.326.096-.428.13-.097.036-.189.066-.383.117-.228.06-.34.11-.441.15-.097.04-.175.076-.364.121-.199.05-.296.075-.398.096-.107.02-.218.045-.431.1-.204.055-.306.08-.408.1-.107.026-.209.05-.422.106a2.17 2.17 0 01-.369.066c-.116.01-.247.02-.48.08-.228.06-.344.11-.446.15-.092.041-.175.076-.359.127-.199.055-.3.075-.403.1-.106.025-.213.05-.427.106-.218.055-.324.095-.426.13-.097.035-.19.066-.383.116-.204.055-.306.08-.408.1-.107.026-.209.05-.417.106-.218.06-.33.1-.432.136-.097.035-.184.07-.378.12-.165.046-.243.046-.345.046-.116 0-.266 0-.509.065-.228.06-.34.106-.441.15-.097.041-.18.076-.364.122-.223.06-.34.105-.437.145-.092.035-.179.07-.368.12-.155.041-.252.192-.204.338.044.145.209.231.369.186.223-.06.34-.106.436-.146.092-.035.18-.07.369-.12.223-.061.34-.106.441-.151l.01.015zM19.242 48.342c-.03 0-.053 0-.082.01-.224.06-.335.096-.442.136a6.263 6.263 0 01-.398.12c-.208.056-.315.081-.422.106-.111.025-.218.056-.431.11-.228.061-.34.101-.447.142-.096.035-.194.07-.392.12-.175.046-.258.046-.364.05-.126 0-.272 0-.524.07-.233.061-.35.111-.456.152-.097.04-.184.075-.378.125-.228.06-.345.106-.451.151-.097.035-.19.076-.384.126-.16.04-.252.191-.203.337.043.145.208.231.368.186.228-.06.345-.106.451-.146.097-.04.19-.075.384-.126.232-.06.349-.11.456-.15.097-.04.184-.076.378-.126.175-.045.257-.045.364-.045.126 0 .271 0 .524-.07.227-.061.34-.101.446-.142.102-.035.194-.07.393-.12.208-.055.315-.08.422-.106.106-.025.218-.055.431-.11.224-.06.335-.1.442-.136.102-.035.199-.07.398-.12.16-.041.252-.192.203-.338a.293.293 0 00-.286-.196v-.01zM65.167 12.475a.314.314 0 00-.422-.01c-.146.126-.218.181-.3.241-.088.066-.18.131-.345.272-.155.136-.233.206-.31.276-.073.07-.151.136-.301.272a3.097 3.097 0 01-.301.241c-.088.065-.175.13-.34.272-.16.14-.237.22-.315.296-.068.07-.13.14-.276.267l-.01.005c-.02.296-.044.598-.068.894.111-.105.18-.18.233-.246.063-.075.116-.14.257-.261.165-.141.238-.221.31-.297.068-.07.136-.14.282-.266.145-.126.218-.181.3-.242.088-.065.175-.13.34-.271.155-.136.233-.206.305-.277.078-.065.15-.135.301-.271.146-.126.223-.181.3-.241.088-.066.18-.131.345-.272a.258.258 0 00.01-.387l.005.005zM26.692 64.67s.04-.04.054-.06c.063-.07.121-.14.262-.26a2.69 2.69 0 00.31-.317 2.09 2.09 0 01.252-.257.997.997 0 01.277-.18c.102-.051.233-.111.417-.272.16-.141.238-.221.31-.302.068-.07.127-.14.272-.261l.3-.262c.078-.065.156-.136.311-.266.16-.141.238-.221.31-.297.069-.07.132-.136.277-.261.15-.13.223-.191.3-.257.078-.065.16-.13.321-.271.17-.15.247-.241.31-.322.063-.075.117-.14.253-.256.13-.116.203-.161.286-.206.097-.056.204-.12.378-.272.15-.13.223-.196.3-.256.078-.066.161-.13.316-.272.146-.125.218-.186.3-.246.083-.065.166-.13.326-.271.17-.146.242-.242.31-.317a2.08 2.08 0 01.253-.257c.16-.14.237-.22.31-.296.068-.07.131-.136.276-.262.146-.125.219-.18.296-.24.04-.03.083-.061.131-.101.059-.196.112-.392.17-.589a.34.34 0 00-.17-.055.333.333 0 00-.208.076c-.14.125-.219.18-.296.24-.087.066-.175.132-.335.272-.16.141-.238.222-.31.297-.068.07-.131.136-.277.261-.17.146-.247.237-.31.317a2.09 2.09 0 01-.252.256 4.611 4.611 0 01-.301.247c-.083.065-.17.13-.325.271-.15.131-.223.196-.3.257-.078.065-.16.13-.316.266-.131.116-.204.161-.286.206-.097.055-.204.12-.379.272a2.29 2.29 0 00-.31.321c-.063.076-.116.141-.252.257a6.72 6.72 0 01-.301.251c-.083.066-.165.13-.32.272-.16.14-.238.22-.31.296-.069.07-.132.136-.277.262-.15.13-.228.196-.3.261-.078.065-.16.13-.311.271-.165.141-.238.222-.31.302-.069.07-.132.136-.272.262a.994.994 0 01-.277.18c-.102.05-.233.111-.417.272a2.677 2.677 0 00-.31.317c-.063.075-.117.14-.257.261a2.737 2.737 0 00-.31.312c-.06.065-.117.13-.239.241.219.055.432.11.65.16v.006zM68.591 53.305c.093.035.175.06.335.145.199.1.31.141.412.171.093.03.175.06.33.141.14.07.194.12.257.181.078.075.18.17.398.282a.307.307 0 00.403-.106c.077-.13.029-.297-.117-.372a.886.886 0 01-.257-.181 1.452 1.452 0 00-.398-.282c-.198-.1-.31-.14-.412-.175-.092-.03-.17-.06-.335-.141-.194-.1-.305-.141-.407-.176-.092-.035-.175-.06-.335-.146a.297.297 0 00-.145-.035.3.3 0 00-.262.14.266.266 0 00.116.373c.2.1.306.14.408.176l.01.005zM67.379 52.048c-.175-.09-.257-.141-.345-.191-.092-.056-.189-.116-.383-.216-.194-.101-.3-.141-.398-.186-.092-.04-.184-.076-.359-.166-.203-.106-.325-.146-.426-.181-.097-.035-.18-.06-.35-.146-.18-.09-.262-.14-.349-.191a5.365 5.365 0 00-.378-.206c-.184-.096-.272-.141-.36-.191-.091-.05-.184-.1-.378-.196-.16-.08-.227-.131-.305-.191a1.887 1.887 0 00-.398-.252 2.576 2.576 0 00-.431-.18c-.097-.03-.18-.061-.345-.147-.18-.09-.267-.14-.359-.19-.092-.05-.189-.106-.378-.202-.2-.1-.3-.14-.403-.186-.063-.025-.126-.055-.213-.095-.17.126-.345.246-.52.362.03.015.054.03.088.045.194.1.3.14.403.186.092.04.184.075.359.166.18.09.266.14.359.191.092.05.184.106.378.201.204.106.325.146.432.181.097.03.18.06.344.146.16.08.228.13.306.19.087.066.189.147.397.252.185.09.272.141.364.191.092.05.184.1.374.196.18.09.261.136.349.191.092.056.184.11.378.207.204.105.325.145.427.18.097.036.18.06.344.146.2.1.301.141.403.186.092.04.184.076.359.166.175.09.257.136.34.191.092.055.189.116.383.216a.307.307 0 00.402-.105.266.266 0 00-.116-.372h.005zM22.938 22.855c.209.106.32.151.432.191.097.035.189.07.364.156.208.106.33.15.436.186.097.035.19.065.364.156.155.08.213.13.291.201.092.08.194.176.422.292.204.105.315.145.422.19.097.04.19.076.369.166.189.096.281.146.378.197l.388.2c.204.101.31.151.412.192.097.04.19.08.374.17.189.096.276.146.369.197.092.055.194.105.392.206.214.105.335.15.442.186.102.035.189.065.359.15.087.046.145.081.199.111 0-.206.019-.412.053-.608-.19-.096-.306-.136-.407-.171a2.47 2.47 0 01-.36-.15c-.189-.096-.276-.147-.368-.197-.097-.05-.194-.106-.393-.206-.204-.1-.31-.146-.417-.191a5.82 5.82 0 01-.374-.171c-.189-.096-.281-.146-.378-.196l-.388-.201c-.204-.1-.315-.146-.422-.191-.097-.04-.19-.075-.369-.166a1.146 1.146 0 01-.29-.201c-.093-.08-.195-.176-.423-.292a2.917 2.917 0 00-.436-.186c-.097-.035-.19-.065-.364-.155a2.918 2.918 0 00-.432-.186 2.668 2.668 0 01-.363-.161.297.297 0 00-.146-.036.3.3 0 00-.262.141c-.078.136-.03.297.116.372l.01.005zM22.094 21.683a4.187 4.187 0 00-.49-.216 3.324 3.324 0 01-.427-.186c-.237-.12-.363-.166-.485-.216a3.527 3.527 0 01-.427-.19.296.296 0 00-.145-.036.306.306 0 00-.262.14c-.078.131-.029.297.116.373.238.12.364.17.486.216.111.045.218.085.426.19.238.122.364.172.49.217.112.04.219.08.427.186a.315.315 0 00.408-.106c.077-.13.029-.296-.117-.372zM55.815 61.64c-.068-.076-.136-.147-.252-.307a2.715 2.715 0 00-.296-.357 2.768 2.768 0 01-.252-.302 1.046 1.046 0 01-.165-.312c-.039-.11-.083-.24-.233-.442-.131-.186-.209-.272-.281-.357a2.863 2.863 0 01-.253-.317c-.116-.16-.18-.251-.237-.331.034.361.073.724.106 1.085.044.056.097.121.17.222.102.14.131.216.165.311.039.11.087.242.233.443.136.186.223.276.3.357.069.075.136.145.253.301.136.186.213.277.29.357.074.075.137.146.253.307.092.125.277.16.412.075.136-.085.175-.251.083-.382a3.004 3.004 0 00-.296-.357v.005zM59.972 67.386c-.068-.07-.126-.13-.233-.276-.126-.176-.208-.262-.281-.337a2.11 2.11 0 01-.228-.272.76.76 0 01-.14-.281c-.035-.1-.079-.231-.22-.422a3.891 3.891 0 00-.266-.332 3.197 3.197 0 01-.233-.287c-.111-.156-.17-.236-.223-.316-.058-.08-.116-.166-.233-.327a.304.304 0 00-.247-.126.326.326 0 00-.165.045c-.136.086-.175.252-.083.383.112.155.17.236.224.316.058.08.111.166.228.327.126.17.199.251.266.332.064.07.122.135.233.286.092.126.112.191.14.282.035.1.078.231.214.422.126.176.209.261.282.337.068.07.126.13.228.271.126.176.208.262.276.332.068.07.126.13.233.277.092.125.276.16.412.075a.257.257 0 00.083-.377c-.126-.176-.209-.261-.277-.337l.01.005zM69.168 39.209c-.227-.02-.344-.02-.455-.02-.102 0-.2 0-.398-.016-.194-.015-.291-.035-.393-.055-.112-.02-.228-.045-.456-.065-.223-.02-.34-.02-.446-.025-.107 0-.204-.005-.408-.026-.203-.02-.3-.035-.402-.05-.107-.015-.223-.035-.447-.055-.232-.02-.349-.015-.465-.015-.102 0-.2 0-.393-.01l-.422-.04-.427-.04c-.068-.006-.121-.01-.17-.01l.073.552h.039l.422.04.432.04c.227.02.349.016.465.016.102 0 .2-.005.393.01.204.015.3.03.403.05.111.015.223.035.446.055.223.02.335.026.446.026.107 0 .204.005.408.025.199.015.29.035.392.055.112.02.228.045.456.065.229.02.345.02.456.02.102 0 .2 0 .403.02a.296.296 0 00.325-.246c.015-.15-.107-.286-.267-.296l-.01-.005zM29.254 31.814c.223.06.344.08.455.1.102.016.195.03.384.081.223.06.349.08.46.095.102.016.194.026.379.08.165.046.233.086.315.137.107.06.223.13.47.2.219.061.335.081.447.101.102.02.199.036.388.09.204.056.3.086.403.116.101.03.208.06.412.121.048.015.087.025.126.035-.199-.246-.398-.498-.597-.744-.048-.015-.106-.03-.174-.05-.219-.06-.335-.08-.447-.1-.101-.02-.198-.036-.388-.091a1.037 1.037 0 01-.315-.136c-.107-.06-.223-.13-.47-.2-.224-.066-.35-.081-.461-.096-.102-.015-.194-.026-.378-.08a3.268 3.268 0 00-.457-.096 3.002 3.002 0 01-.383-.08c-.029-.01-.058-.01-.087-.01a.297.297 0 00-.286.195c-.049.146.043.297.199.342l.005-.01zM26.916 36.513c.232.02.358.015.465.015.102 0 .2-.005.388.01.233.02.36.016.47.01.107 0 .195-.01.389.01.17.016.242.04.34.076.11.04.247.09.504.11.228.02.34.02.456.02.102 0 .199 0 .398.016l.417.04c.106.01.213.025.431.04.223.02.34.02.451.02.107 0 .204 0 .403.02.209.016.306.03.412.04.107.016.219.026.437.046.237.02.364.015.475.01.102-.005.194-.01.383.005.185.015.267.04.364.065.112.03.238.066.48.086.209.015.316.03.417.04.107.01.219.025.432.04.204.02.301.03.408.045.106.015.223.03.441.05.233.02.364.016.47.01h.141c-.126-.18-.252-.361-.383-.537-.049 0-.102 0-.175-.01a8.594 8.594 0 01-.407-.045 7.824 7.824 0 00-.441-.05l-.418-.041c-.106-.015-.218-.025-.436-.045-.184-.015-.267-.04-.369-.066-.111-.03-.237-.065-.475-.085a3.233 3.233 0 00-.475-.01c-.102.005-.194.01-.384-.005a9.19 9.19 0 01-.412-.045c-.107-.015-.218-.026-.436-.046-.224-.02-.34-.02-.452-.02-.106 0-.203 0-.402-.02l-.417-.04c-.107-.01-.214-.025-.432-.04-.228-.02-.344-.02-.456-.02-.102 0-.199 0-.398-.015a1.124 1.124 0 01-.34-.076 1.649 1.649 0 00-.499-.11 3.163 3.163 0 00-.47-.01c-.107.005-.194.01-.388-.01-.233-.02-.355-.016-.466-.016-.102 0-.194.005-.393-.01h-.03c-.15 0-.28.106-.295.247-.014.15.107.286.267.296l.01.005zM26.6 30.406c-.223-.06-.344-.075-.45-.09a1.859 1.859 0 01-.365-.07c-.194-.056-.286-.086-.383-.116-.102-.03-.204-.066-.407-.121-.209-.06-.32-.08-.427-.1-.097-.02-.194-.04-.379-.091-.194-.055-.29-.08-.387-.11-.102-.03-.204-.061-.403-.116a2.98 2.98 0 00-.432-.096c-.097-.02-.189-.035-.373-.085-.155-.04-.219-.08-.301-.131a1.682 1.682 0 00-.456-.201c-.218-.06-.34-.076-.446-.09-.102-.016-.185-.026-.364-.076-.218-.06-.34-.08-.441-.096a3.253 3.253 0 01-.37-.075.297.297 0 00-.373.181c-.048.146.044.297.2.342.218.06.334.075.44.095.103.015.19.03.37.076.218.06.339.075.446.095.102.016.184.026.363.076.156.045.224.08.301.13.097.06.218.131.456.202.213.06.325.08.432.1.097.015.189.035.373.086.194.055.291.085.388.11.102.03.2.06.403.116.209.06.32.08.427.1.097.02.194.035.378.09.194.056.286.086.383.116.097.03.204.066.408.121.223.06.344.076.45.09.098.01.185.026.365.071.155.045.325-.04.368-.181.049-.146-.043-.297-.199-.342l.005-.01z"
        fill="#FFE3B8"
      />
      <path
        d="M38.848 42.677S27.87 73.15 19.75 81.807H29.7l6.005 9.99S47.312 69.592 47.23 45.039l-8.377-2.362h-.005z"
        fill="#D63B3B"
      />
      <path
        d="M54.49 42.677s10.978 30.474 19.097 39.13H63.64l-6.005 9.99S46.027 69.592 46.109 45.039l8.377-2.362h.005z"
        fill="#D63B3B"
      />
      <path
        d="M46.114 45.04l.558-.156-1.494-.422-8.348 3.574a315.677 315.677 0 01-4.821 11.739c2.23 2.473 5.646 4.846 10.836 5.967.64.14 1.28.23 1.916.281.8-3.519 1.47-7.269 1.906-11.15a84.87 84.87 0 01-.558-9.828l.005-.005z"
        fill="#B93333"
      />
      <path
        d="M46.667 54.867c.432 3.826 1.091 7.521 1.872 10.995 4.759-.754 9.197-3.464 12.699-6.294a317.055 317.055 0 01-6.752-16.891l-7.82 2.207-.557.155c-.01 3.338.194 6.626.558 9.828z"
        fill="#B93333"
      />
      <path
        d="M71.083 37.236C71.79 24 62.01 12.674 49.237 11.941c-12.772-.733-23.699 9.404-24.406 22.64-.707 13.238 9.073 24.563 21.845 25.296 12.772.733 23.7-9.404 24.407-22.64z"
        fill="#F39F1C"
      />
      <path
        d="M63.372 18c3.657 4.242 5.884 9.842 5.884 15.975 0 13.257-10.37 24.005-23.161 24.005-5.923 0-11.322-2.308-15.415-6.098 4.239 4.921 10.409 8.023 17.277 8.023 12.791 0 23.161-10.748 23.161-24.004 0-7.119-2.992-13.508-7.741-17.907l-.005.005z"
        fill="#B07A25"
      />
      <path
        d="M48.924 54.06c9.675-.556 17.083-9.135 16.548-19.161-.536-10.027-8.813-17.705-18.488-17.15-9.675.555-17.083 9.134-16.548 19.16.536 10.028 8.813 17.706 18.488 17.15z"
        fill="#F39F1C"
      />
      <path
        d="M36.33 49.519c-2.74-3.207-4.404-7.425-4.404-12.045 0-10.044 7.853-18.183 17.545-18.183 4.457 0 8.527 1.73 11.621 4.564-3.215-3.765-7.906-6.138-13.14-6.138-9.691 0-17.544 8.14-17.544 18.183 0 5.42 2.29 10.286 5.922 13.619z"
        fill="#B07A25"
      />
      <path
        d="M60.113 31.734c-.18-.608-.772-1.026-1.582-1.212-.043-.01-5.597-.85-5.597-.85s-2.41-5.082-2.493-5.232c-.413-.75-.97-1.212-1.587-1.212-.615 0-1.173.462-1.59 1.222-.078.145-2.489 5.223-2.489 5.223s-5.549.834-5.578.844c-.815.176-1.411.584-1.6 1.187-.185.588.048 1.261.581 1.89l4.075 4.117s-.926 5.59-.941 5.761c-.082.86.116 1.574.616 1.94.504.373 1.445.327 2.207-.04.01 0 4.996-2.694 4.996-2.694s4.501 2.609 4.608 2.66c.034.014.068.034.102.05.766.351 1.48.382 1.979 0 .495-.377.679-1.091.582-1.951a.3.3 0 00-.01-.065c-.014-.1-.936-5.666-.936-5.666l4.036-4.077c.553-.623.8-1.297.625-1.895h-.004z"
        fill="#EE8821"
      />
      <path
        d="M59.686 31.703c-.18-.609-.772-1.026-1.581-1.212-.044-.01-5.598-.85-5.598-.85s-2.41-5.082-2.493-5.233c-.413-.749-.97-1.211-1.586-1.211-.616 0-1.174.462-1.591 1.216-.078.146-2.489 5.224-2.489 5.224s-5.549.834-5.573.844c-.815.176-1.411.583-1.6 1.186-.185.594.048 1.262.582 1.89l4.074 4.118s-.927 5.59-.941 5.76c-.083.86.116 1.57.616 1.941.504.372 1.217.327 1.979-.04.01 0 4.947-2.694 4.947-2.694s4.778 2.609 4.885 2.659c.034.015.068.035.102.05.766.352 1.48.382 1.979 0 .495-.377.679-1.09.582-1.95a.404.404 0 00-.01-.07c-.014-.101-.936-5.666-.936-5.666l4.036-4.077c.553-.624.8-1.297.625-1.895l-.01.01z"
        fill="#FFE3B8"
      />
    </g>
    <defs>
      <clipPath id="clip0_613_1920">
        <path fill="#fff" transform="translate(0 .5)" d="M0 0H92V92H0z" />
      </clipPath>
    </defs>
  </svg>
)

export const leftArrowLong = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-arrow-left"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M15 8a.5.5 0 00-.5-.5H2.707l3.147-3.146a.5.5 0 10-.708-.708l-4 4a.5.5 0 000 .708l4 4a.5.5 0 00.708-.708L2.707 8.5H14.5A.5.5 0 0015 8"
    />
  </svg>
)

export const rightArrowLong = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-arrow-right"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M1 8a.5.5 0 01.5-.5h11.793l-3.147-3.146a.5.5 0 01.708-.708l4 4a.5.5 0 010 .708l-4 4a.5.5 0 01-.708-.708L13.293 8.5H1.5A.5.5 0 011 8"
    />
  </svg>
)

export const emplyArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-tag"
    viewBox="0 0 16 16"
  >
    <path 
    transform="rotate(135 7.3 8)" d="M2 1h4.586a1 1 0 01.707.293l7 7a1 1 0 010 1.414l-4.586 4.586a1 1 0 01-1.414 0l-7-7A1 1 0 011 6.586V2a1 1 0 011-1m0 5.586l7 7L13.586 9l-7-7H2z" />
  </svg>
)

export const lockPadDot = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      height={16}
      viewBox="0 -960 960 960"
      width={16}
      fill="currentColor"
    >
      <path d="M240-80q-33 0-56.5-23.5T160-160v-400q0-33 23.5-56.5T240-640h40v-80q0-83 58.5-141.5T480-920q83 0 141.5 58.5T680-720v80h40q33 0 56.5 23.5T800-560v400q0 33-23.5 56.5T720-80H240zm0-80h480v-400H240v400zm240-120q33 0 56.5-23.5T560-360q0-33-23.5-56.5T480-440q-33 0-56.5 23.5T400-360q0 33 23.5 56.5T480-280zM360-640h240v-80q0-50-35-85t-85-35q-50 0-85 35t-35 85v80zM240-160v-400 400z" />
    </svg>
)

export const trophyIcon = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-trophy"
      viewBox="0 0 16 16"
    >
      <path d="M2.5.5A.5.5 0 013 0h10a.5.5 0 01.5.5q0 .807-.034 1.536a3 3 0 11-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 01-.3.9H3a.5.5 0 01-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 11-1.132-5.89A33 33 0 012.5.5m.099 2.54a2 2 0 00.72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 00.72-3.935c-.133 1.59-.388 2.885-.72 3.935M3.504 1q.01.775.056 1.469c.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 01.5.5v2.61a1 1 0 01-.757.97l-1.426.356a.5.5 0 00-.179.085L4.5 15h7l-.638-.479a.5.5 0 00-.18-.085l-1.425-.356a1 1 0 01-.757-.97V10.5A.5.5 0 019 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667q.045-.694.056-1.469z" />
    </svg>
)

export const arrowsFullScreenIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-arrows-fullscreen"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M5.828 10.172a.5.5 0 00-.707 0l-4.096 4.096V11.5a.5.5 0 00-1 0v3.975a.5.5 0 00.5.5H4.5a.5.5 0 000-1H1.732l4.096-4.096a.5.5 0 000-.707m4.344 0a.5.5 0 01.707 0l4.096 4.096V11.5a.5.5 0 111 0v3.975a.5.5 0 01-.5.5H11.5a.5.5 0 010-1h2.768l-4.096-4.096a.5.5 0 010-.707m0-4.344a.5.5 0 00.707 0l4.096-4.096V4.5a.5.5 0 101 0V.525a.5.5 0 00-.5-.5H11.5a.5.5 0 000 1h2.768l-4.096 4.096a.5.5 0 000 .707m-4.344 0a.5.5 0 01-.707 0L1.025 1.732V4.5a.5.5 0 01-1 0V.525a.5.5 0 01.5-.5H4.5a.5.5 0 010 1H1.732l4.096 4.096a.5.5 0 010 .707"
    />
  </svg>
)

export const cancelFullScreenIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-arrows-angle-contract"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M.172 15.828a.5.5 0 00.707 0l4.096-4.096V14.5a.5.5 0 101 0v-3.975a.5.5 0 00-.5-.5H1.5a.5.5 0 000 1h2.768L.172 15.121a.5.5 0 000 .707M15.828.172a.5.5 0 00-.707 0l-4.096 4.096V1.5a.5.5 0 10-1 0v3.975a.5.5 0 00.5.5H14.5a.5.5 0 000-1h-2.768L15.828.879a.5.5 0 000-.707"
    />
  </svg>
)

export const MessageQuestionIcon = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      height={16}
      viewBox="0 -960 960 960"
      width={16}
      fill="currentColor"
    >
      <path d="M476-280q21 0 35.5-14.5T526-330q0-21-14.5-35.5T476-380q-21 0-35.5 14.5T426-330q0 21 14.5 35.5T476-280zm-36-154h74q0-17 1.5-29t6.5-23q5-11 12.5-20.5T556-530q35-35 49.5-58.5T620-642q0-53-36-85.5T487-760q-55 0-93.5 27T340-658l66 26q7-27 28-43.5t49-16.5q27 0 45 14.5t18 38.5q0 17-11 36t-37 42q-17 14-27.5 27.5T453-505q-7 15-10 31.5t-3 39.5zm40 394L360-160H200q-33 0-56.5-23.5T120-240v-560q0-33 23.5-56.5T200-880h560q33 0 56.5 23.5T840-800v560q0 33-23.5 56.5T760-160H600L480-40zM200-240h192l88 88 88-88h192v-560H200v560zm280-280z" />
    </svg>
)

export const noAnnouncementBadge = (
  <svg
    width={152}
    height={152}
    viewBox="0 0 152 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={152}
      height={152}
    >
      <circle cx={76} cy={76} r={75.5} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.719 101.867c-2.319 1.733-4.58 3.362-7.139 4.769l.148 12.675a1.8 1.8 0 01-2.898 1.448l-11.396-8.768A59.913 59.913 0 0176 113.5c-27.338 0-49.5-18.132-49.5-40.5 0-22.367 22.162-40.5 49.5-40.5s49.5 18.133 49.5 40.5c0 6.19-1.698 12.057-4.733 17.305a38.343 38.343 0 01-1.814 2.838s-1.268 1.907-3.803 4.607-4.431 4.117-4.431 4.117z"
        fill="url(#paint0_linear_1817_15690)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58 67.6a5.4 5.4 0 110 10.8 5.4 5.4 0 010-10.8zm17.1 0a5.4 5.4 0 110 10.8 5.4 5.4 0 010-10.8zm17.1 0a5.4 5.4 0 110 10.8 5.4 5.4 0 010-10.8z"
        fill="#F5F6FF"
      />
      <path
        d="M39.696 59.78a30.915 30.915 0 00-2.115 4.285M56.22 45.166c-5.898 2.815-10.877 6.796-14.475 11.562"
        stroke="#E4E6FF"
        strokeWidth={2.25}
        strokeLinecap="round"
      />
      <circle
        cx={135.046}
        cy={41.9568}
        r={3.56333}
        fill="#D2D6FF"
        stroke="#B6BBF0"
        strokeWidth={1.4382}
      />
      <circle
        cx={71.7824}
        cy={138.782}
        r={3.56333}
        fill="#D2D6FF"
        stroke="#B6BBF0"
        strokeWidth={1.4382}
      />
      <g filter="url(#filter0_f_1817_15690)">
        <path
          d="M20.741 85.135l1.214 3.28 3.28 1.214-3.28 1.214-1.213 3.28-1.214-3.28-3.28-1.214 3.28-1.214 1.213-3.28z"
          fill="#D2D6FF"
        />
        <path
          d="M20.741 85.653l1.046 2.825.028.077.078.029 2.825 1.045-2.825 1.045-.078.03-.028.077-1.046 2.825-1.045-2.825-.029-.078-.077-.029-2.825-1.045 2.825-1.045.078-.029.028-.077 1.045-2.825z"
          stroke="#B6BBF0"
          strokeWidth={0.359551}
        />
      </g>
      <path
        d="M134.928 105.788l1.635 4.42.029.078.078.028 4.42 1.636-4.42 1.636-.078.029-.029.077-1.635 4.421-1.636-4.421-.029-.077-.077-.029-4.421-1.636 4.421-1.636.077-.028.029-.078 1.636-4.42z"
        fill="#D2D6FF"
        stroke="#B6BBF0"
        strokeWidth={0.359551}
      />
      <path
        d="M41.736 14.102l2.006 5.421.03.078.077.029 5.42 2.006-5.42 2.005-.078.029-.029.078-2.005 5.42-2.006-5.42-.03-.078-.077-.029-5.42-2.005 5.42-2.006.078-.03.029-.077 2.005-5.42z"
        fill="#B6BBF0"
        stroke="#B6BBF0"
        strokeWidth={0.359551}
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1817_15690"
        x={14.8089}
        y={83.6966}
        width={11.8647}
        height={11.8652}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          stdDeviation={0.719101}
          result="effect1_foregroundBlur_1817_15690"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1817_15690"
        x1={34.1154}
        y1={39.1187}
        x2={92.0211}
        y2={125.639}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CFD6FC" />
        <stop offset={1} stopColor="#5A69DB" />
      </linearGradient>
    </defs>
  </svg>
)

export const noQuestionBadge = (
  <svg
    width={151}
    height={150}
    viewBox="0 0 151 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={152}
      height={151}
    >
      <circle cx={76} cy={75.5} r={75.5} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.205 106.811a4.078 4.078 0 005.84 0l36.071-36.979h7.507a5.827 5.827 0 015.827 5.827V119.8a5.827 5.827 0 01-5.827 5.827H34.182a5.827 5.827 0 01-5.827-5.827V75.659a5.826 5.826 0 015.827-5.827h6.952l36.071 36.979z"
        fill="url(#paint0_linear_1817_16408)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.308 39.575a5.826 5.826 0 00-5.827 5.827v23.875h.43c.092 1.416.707 2.828 1.961 3.94l24.555 21.777a5.827 5.827 0 007.732 0l24.555-21.777c1.254-1.112 1.87-2.524 1.961-3.94h.43V45.402a5.826 5.826 0 00-5.826-5.827H55.308zm6.635 15.822c0-.92.745-1.665 1.665-1.665h33.588a1.666 1.666 0 010 3.331H63.608c-.92 0-1.665-.746-1.665-1.666zm1.665 9.438a1.666 1.666 0 000 3.331h33.588a1.666 1.666 0 000-3.33H63.608z"
        fill="url(#paint1_linear_1817_16408)"
      />
      <circle
        cx={33.3513}
        cy={51.7888}
        r={3.58112}
        fill="#B6BBF0"
        stroke="#B6BBF0"
        strokeWidth={1.16529}
      />
      <circle
        cx={139.325}
        cy={87.4493}
        r={2.88716}
        fill="#B6BBF0"
        stroke="#B6BBF0"
        strokeWidth={1.16529}
      />
      <circle
        cx={79.7085}
        cy={135.342}
        r={2.1932}
        fill="#B6BBF0"
        stroke="#B6BBF0"
        strokeWidth={1.16529}
      />
      <path
        d="M41.856 131.57a.437.437 0 01.757 0l3.078 5.33a.437.437 0 01-.379.656h-6.155a.437.437 0 01-.378-.656l3.077-5.33z"
        fill="#B6BBF0"
        stroke="#B6BBF0"
        strokeWidth={0.291323}
      />
      <g filter="url(#filter0_f_1817_16408)">
        <path
          d="M24.053 88.152l.003 3.468 3.002 1.737-3.005-1.731-3.005 1.731 3.002-1.737.003-3.468z"
          fill="#33397E"
        />
      </g>
      <g filter="url(#filter1_f_1817_16408)">
        <path
          d="M99.846 141.953l.005 6.52 5.644 3.265-5.65-3.255-5.649 3.255 5.644-3.265.005-6.52z"
          fill="#33397E"
        />
      </g>
      <path
        d="M110.971 45.234l.004 5.41 4.683 2.71-4.687-2.701-4.688 2.7 4.683-2.708.005-5.41z"
        fill="#33397E"
      />
      <g filter="url(#filter2_d_1817_16408)">
        <path
          d="M15.19 76.68c9.973-2.684 20.252-9.378 24.407-13.926 9.184 9.658 25.296 16.617 34.8 19.472L51.082 99.17c-7.633-1.939-23.326-12.936-35.89-22.49z"
          fill="url(#paint2_linear_1817_16408)"
        />
      </g>
      <rect
        x={27.5137}
        y={78.9971}
        width={16.241}
        height={1.6922}
        rx={0.846099}
        transform="rotate(-32.017 27.514 78.997)"
        fill="#D2D6FF"
      />
      <rect
        x={30.5723}
        y={82.4082}
        width={19.829}
        height={1.6922}
        rx={0.846099}
        transform="rotate(-32.017 30.572 82.408)"
        fill="#D2D6FF"
      />
      <rect
        x={41.876}
        y={91.4814}
        width={19.829}
        height={1.6922}
        rx={0.846099}
        transform="rotate(-32.017 41.876 91.481)"
        fill="#D2D6FF"
      />
      <rect
        x={33.7939}
        y={85.5947}
        width={10.7824}
        height={1.6922}
        rx={0.846099}
        transform="rotate(-32.017 33.794 85.595)"
        fill="#D2D6FF"
      />
      <rect
        x={37.4189}
        y={88.6367}
        width={22.1806}
        height={1.6922}
        rx={0.846099}
        transform="rotate(-32.017 37.419 88.637)"
        fill="#D2D6FF"
      />
      <g filter="url(#filter3_d_1817_16408)">
        <path
          d="M141.974 94.34c-10.798 1.296-26.393-9.079-35.283-13.785-10.626 13.952-27.173 24.566-39.196 29.665l30.76 18.692c9.707-3.632 28.655-20.27 43.719-34.573z"
          fill="url(#paint3_linear_1817_16408)"
        />
      </g>
      <rect
        width={21.372}
        height={2.22681}
        rx={1.1134}
        transform="scale(-1 1) rotate(-27.433 141.197 308.653)"
        fill="#D2D6FF"
      />
      <rect
        width={22.1651}
        height={2.22681}
        rx={1.1134}
        transform="scale(-1 1) rotate(-27.433 152.848 303.568)"
        fill="#D2D6FF"
      />
      <rect
        width={26.0935}
        height={2.22681}
        rx={1.1134}
        transform="scale(-1 1) rotate(-27.433 186.6 281.694)"
        fill="#D2D6FF"
      />
      <rect
        width={14.1888}
        height={2.22681}
        rx={1.1134}
        transform="scale(-1 1) rotate(-27.433 164.049 297.856)"
        fill="#D2D6FF"
      />
      <rect
        width={22.3961}
        height={2.22681}
        rx={1.1134}
        transform="scale(-1 1) rotate(-27.433 175.221 290.955)"
        fill="#D2D6FF"
      />
      <g filter="url(#filter4_f_1817_16408)">
        <circle cx={114.683} cy={75.661} r={11.1034} fill="#E1A7A7" />
      </g>
      <circle cx={114.683} cy={73.4403} r={11.1034} fill="#B93333" />
      <path
        d="M113.562 74.924c-.306-2.286 2.797-2.796 2.797-4.21 0-.888-.699-1.383-1.85-1.383-.889 0-1.617.408-2.331 1.15l-1.194-1.092c.932-1.078 2.214-1.791 3.773-1.791 2.112 0 3.656.99 3.656 2.927 0 2.127-3.19 2.39-2.957 4.4h-1.894zm.962 3.89c-.758 0-1.297-.54-1.297-1.297 0-.757.554-1.282 1.297-1.282.728 0 1.281.525 1.281 1.282 0 .758-.553 1.297-1.281 1.297z"
        fill="#fff"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1817_16408"
        x={19.8826}
        y={86.9871}
        width={8.34035}
        height={7.53566}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          stdDeviation={0.582646}
          result="effect1_foregroundBlur_1817_16408"
        />
      </filter>
      <filter
        id="filter1_f_1817_16408"
        x={93.031}
        y={140.788}
        width={13.6294}
        height={12.1157}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          stdDeviation={0.582646}
          result="effect1_foregroundBlur_1817_16408"
        />
      </filter>
      <filter
        id="filter2_d_1817_16408"
        x={3.53752}
        y={56.9275}
        width={82.5129}
        height={59.7218}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5.82646} />
        <feGaussianBlur stdDeviation={5.82646} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.0533333 0 0 0 0 0 0 0 0 0 0.266667 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1817_16408"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1817_16408"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_1817_16408"
        x={55.8422}
        y={74.7282}
        width={97.7843}
        height={71.6632}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={5.82646} />
        <feGaussianBlur stdDeviation={5.82646} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0.13627 0 0 0 0 0 0 0 0 0 0.4375 0 0 0 0.23 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1817_16408"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_1817_16408"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_f_1817_16408"
        x={94.8404}
        y={55.8179}
        width={39.6864}
        height={39.6864}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          stdDeviation={4.36984}
          result="effect1_foregroundBlur_1817_16408"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1817_16408"
        x1={80.4026}
        y1={69.832}
        x2={80.4026}
        y2={125.627}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E4E6FF" />
        <stop offset={1} stopColor="#606AE3" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1817_16408"
        x1={80.2933}
        y1={39.5752}
        x2={80.2933}
        y2={96.4617}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1D4F8" />
        <stop offset={1} stopColor="#606AE3" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1817_16408"
        x1={57.494}
        y1={85.2745}
        x2={36.6138}
        y2={76.9105}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F1F3FF" />
        <stop offset={1} stopColor="#EAE7FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1817_16408"
        x1={87.8721}
        y1={111.656}
        x2={113.984}
        y2={97.7178}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={1} stopColor="#EAE7FF" />
      </linearGradient>
    </defs>
  </svg>
)

export const noReportBadgeInner = (
  <svg
      width={152}
      height={152}
      viewBox="0 0 152 152"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="a"
        style={{
          maskType: "alpha"
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={152}
        height={152}
      >
        <circle cx={76} cy={76} r={75.5} fill="#fff" />
      </mask>
      <g mask="url(#a)">
        <path
          d="M48.36 72.85v60.75l8.746-5.32 8.747 5.32 8.748-5.32 8.745 5.32 8.749-5.32 8.746 5.32 8.745-5.32 8.749 5.32V59.08c0-4.943-4-8.95-8.935-8.95H39.427"
          fill="url(#paint0_linear_1817_17752)"
        />
        <path
          d="M30.493 95.268H48.36V58.283c0-4.503-3.642-8.153-8.137-8.153H38.63c-4.494 0-8.138 3.65-8.138 8.153v36.985h.001z"
          fill="url(#paint1_linear_1817_17752)"
        />
        <path
          d="M118.337 104.321a1.631 1.631 0 001.626-1.63V59.08c0-5.834-4.736-10.58-10.559-10.58H39.427c-5.823 0-10.56 4.747-10.56 10.58v25.964a1.628 1.628 0 001.626 1.63 1.628 1.628 0 001.626-1.63V59.08c0-4.038 3.278-7.321 7.306-7.321 4.03 0 7.307 3.285 7.307 7.32v34.559H32.12v-2.633a1.628 1.628 0 00-1.626-1.63 1.63 1.63 0 00-1.627 1.632v4.261a1.628 1.628 0 001.626 1.63h16.24V133.6a1.628 1.628 0 002.47 1.393l7.903-4.806 7.904 4.806a1.625 1.625 0 001.687 0l7.903-4.806 7.904 4.806a1.625 1.625 0 001.687 0l7.903-4.806 7.904 4.806a1.624 1.624 0 001.687 0l7.904-4.806 7.902 4.806c.246.15.529.232.817.237a1.63 1.63 0 001.652-1.63v-24.946a1.626 1.626 0 10-3.251 0v22.052l-6.278-3.817a1.61 1.61 0 00-1.687 0l-7.902 4.806-7.904-4.806a1.612 1.612 0 00-1.687 0l-7.904 4.806-7.902-4.806a1.612 1.612 0 00-1.687 0l-7.905 4.806-7.903-4.806a1.61 1.61 0 00-1.686 0l-6.278 3.817V59.08c0-2.84-1.124-5.42-2.947-7.321h62.367c4.029 0 7.305 3.285 7.305 7.32v43.612a1.631 1.631 0 001.626 1.63z"
          fill="#7C89FF"
        />
        <rect
          x={58.2852}
          y={69.314}
          width={17.2959}
          height={4.55156}
          rx={2.27578}
          fill="#fff"
        />
        <rect
          x={78.7676}
          y={69.314}
          width={26.8542}
          height={4.55156}
          rx={2.27578}
          fill="#fff"
        />
        <rect
          x={58.2852}
          y={80.2378}
          width={27.7645}
          height={4.55156}
          rx={2.27578}
          fill="#F5F6FF"
        />
        <rect
          x={58.2852}
          y={101.175}
          width={18.2062}
          height={4.55156}
          rx={2.27578}
          fill="#F5F6FF"
        />
        <rect
          x={58.2852}
          y={90.7065}
          width={45.0604}
          height={4.55156}
          rx={2.27578}
          fill="#F5F6FF"
        />
        <circle
          cx={135.046}
          cy={41.9568}
          r={3.56333}
          fill="#D2D6FF"
          stroke="#B6BBF0"
          strokeWidth={1.4382}
        />
        <circle
          cx={88.6643}
          cy={148.743}
          r={3.56333}
          fill="#D2D6FF"
          stroke="#B6BBF0"
          strokeWidth={1.4382}
        />
        <g filter="url(#filter0_f_1817_17752)">
          <path
            d="M20.741 85.135l1.214 3.28 3.28 1.214-3.28 1.214-1.213 3.28-1.214-3.28-3.28-1.214 3.28-1.214 1.213-3.28z"
            fill="#D2D6FF"
          />
          <path
            d="M20.741 85.653l1.046 2.825.028.077.078.029 2.825 1.045-2.825 1.045-.078.03-.028.077-1.046 2.825-1.045-2.825-.029-.078-.077-.029-2.825-1.045 2.825-1.045.078-.029.028-.077 1.045-2.825z"
            stroke="#B6BBF0"
            strokeWidth={0.359551}
          />
        </g>
        <path
          d="M134.928 105.788l1.635 4.42.029.078.078.028 4.42 1.636-4.42 1.636-.078.029-.029.077-1.635 4.421-1.636-4.421-.029-.077-.077-.029-4.421-1.636 4.421-1.636.077-.028.029-.078 1.636-4.42z"
          fill="#D2D6FF"
          stroke="#B6BBF0"
          strokeWidth={0.359551}
        />
        <path
          d="M41.736 14.102l2.006 5.421.03.078.077.029 5.42 2.006-5.42 2.005-.078.029-.029.078-2.005 5.42-2.006-5.42-.03-.078-.077-.029-5.42-2.005 5.42-2.006.078-.03.029-.077 2.005-5.42z"
          fill="#B6BBF0"
          stroke="#B6BBF0"
          strokeWidth={0.359551}
        />
      </g>
      <defs>
        <filter
          id="filter0_f_1817_17752"
          x={14.8089}
          y={83.6966}
          width={11.8647}
          height={11.8652}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            stdDeviation={0.719101}
            result="effect1_foregroundBlur_1817_17752"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1817_17752"
          x1={88.0006}
          y1={50.5}
          x2={100.151}
          y2={145.334}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DBE1FF" />
          <stop offset={1} stopColor="#828FF2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1817_17752"
          x1={39.4259}
          y1={50.1304}
          x2={39.4259}
          y2={95.2681}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5D6CF6" />
          <stop offset={1} stopColor="#B3BAFF" />
        </linearGradient>
        <circle
          cx={80.5}
          cy={80.5}
          r={77.5}
          fill="#F5F6FF"
          stroke="#fff"
          strokeWidth={5}
        />
      </defs>
    </svg>
)

export const noTestData = (
  <svg
    width={152}
    height={152}
    viewBox="0 0 152 152"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="a"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={152}
      height={152}
    >
      <circle cx={76} cy={76} r={75.5} fill="#fff" />
    </mask>
    <g mask="url(#a)">
      <rect
        x={38.5}
        y={99.7358}
        width={85.573}
        height={25.1685}
        rx={8}
        fill="url(#paint0_linear_1817_12588)"
      />
      <circle cx={49.1071} cy={112.14} r={3.41573} fill="#fff" />
      <rect
        x={55.7588}
        y={109.084}
        width={46.0225}
        height={6.47191}
        rx={3.23595}
        fill="#F5F6FF"
      />
      <rect
        x={38.5}
        y={67.7358}
        width={85.573}
        height={25.1685}
        rx={8}
        fill="url(#paint1_linear_1817_12588)"
      />
      <circle cx={49.1071} cy={80.1403} r={3.41573} fill="#fff" />
      <rect
        x={55.7588}
        y={77.084}
        width={46.0225}
        height={6.47191}
        rx={3.23595}
        fill="#F5F6FF"
      />
      <rect
        x={38.5}
        y={36.7358}
        width={85.573}
        height={25.1685}
        rx={8}
        fill="url(#paint2_linear_1817_12588)"
      />
      <circle cx={49.1071} cy={49.1403} r={3.41573} fill="#fff" />
      <rect
        x={55.7588}
        y={46.084}
        width={46.0225}
        height={6.47191}
        rx={3.23595}
        fill="#F5F6FF"
      />
      <circle
        cx={135.046}
        cy={41.9568}
        r={3.56333}
        fill="#D2D6FF"
        stroke="#B6BBF0"
        strokeWidth={1.4382}
      />
      <g filter="url(#filter0_f_1817_12588)">
        <path
          d="M20.741 85.135l1.214 3.28 3.28 1.214-3.28 1.214-1.213 3.28-1.214-3.28-3.28-1.214 3.28-1.214 1.213-3.28z"
          fill="#D2D6FF"
        />
        <path
          d="M20.741 85.653l1.046 2.825.028.077.078.029 2.825 1.045-2.825 1.045-.078.03-.028.077-1.046 2.825-1.045-2.825-.029-.078-.077-.029-2.825-1.045 2.825-1.045.078-.029.028-.077 1.045-2.825z"
          stroke="#B6BBF0"
          strokeWidth={0.359551}
        />
      </g>
      <path
        d="M41.736 14.102l2.006 5.421.03.078.077.029 5.42 2.006-5.42 2.005-.078.029-.029.078-2.005 5.42-2.006-5.42-.03-.078-.077-.029-5.42-2.005 5.42-2.006.078-.03.029-.077 2.005-5.42z"
        fill="#B6BBF0"
        stroke="#B6BBF0"
        strokeWidth={0.359551}
      />
    </g>
    <defs>
      <filter
        id="filter0_f_1817_12588"
        x={14.8089}
        y={83.6966}
        width={11.8647}
        height={11.8652}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          stdDeviation={0.719101}
          result="effect1_foregroundBlur_1817_12588"
        />
      </filter>
      <linearGradient
        id="paint0_linear_1817_12588"
        x1={45.0825}
        y1={101.615}
        x2={52.5435}
        y2={135.549}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CFD6FC" />
        <stop offset={1} stopColor="#5A69DB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1817_12588"
        x1={45.0825}
        y1={69.6153}
        x2={52.5435}
        y2={103.549}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CFD6FC" />
        <stop offset={1} stopColor="#5A69DB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1817_12588"
        x1={45.0825}
        y1={38.6153}
        x2={52.5435}
        y2={72.5485}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CFD6FC" />
        <stop offset={1} stopColor="#5A69DB" />
      </linearGradient>
    </defs>
  </svg>
);

export const cameraIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-camera"
    viewBox="0 0 16 16"
  >
    <path d="M15 12a1 1 0 01-1 1H2a1 1 0 01-1-1V6a1 1 0 011-1h1.172a3 3 0 002.12-.879l.83-.828A1 1 0 016.827 3h2.344a1 1 0 01.707.293l.828.828A3 3 0 0012.828 5H14a1 1 0 011 1zM2 4a2 2 0 00-2 2v6a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1.172a2 2 0 01-1.414-.586l-.828-.828A2 2 0 009.172 2H6.828a2 2 0 00-1.414.586l-.828.828A2 2 0 013.172 4z" />
    <path d="M8 11a2.5 2.5 0 110-5 2.5 2.5 0 010 5m0 1a3.5 3.5 0 100-7 3.5 3.5 0 000 7M3 6.5a.5.5 0 11-1 0 .5.5 0 011 0" />
  </svg>
);

export const uploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-upload"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 01.5.5v2.5a1 1 0 001 1h12a1 1 0 001-1v-2.5a.5.5 0 011 0v2.5a2 2 0 01-2 2H2a2 2 0 01-2-2v-2.5a.5.5 0 01.5-.5" />
    <path d="M7.646 1.146a.5.5 0 01.708 0l3 3a.5.5 0 01-.708.708L8.5 2.707V11.5a.5.5 0 01-1 0V2.707L5.354 4.854a.5.5 0 11-.708-.708z" />
  </svg>
);


export const qrIcon = (
  <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      fill="currentColor"
      className="bi bi-qr-code-scan"
      viewBox="0 0 16 16"
    >
      <path d="M0 .5A.5.5 0 01.5 0h3a.5.5 0 010 1H1v2.5a.5.5 0 01-1 0zm12 0a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v3a.5.5 0 01-1 0V1h-2.5a.5.5 0 01-.5-.5M.5 12a.5.5 0 01.5.5V15h2.5a.5.5 0 010 1h-3a.5.5 0 01-.5-.5v-3a.5.5 0 01.5-.5m15 0a.5.5 0 01.5.5v3a.5.5 0 01-.5.5h-3a.5.5 0 010-1H15v-2.5a.5.5 0 01.5-.5M4 4h1v1H4z" />
      <path d="M7 2H2v5h5zM3 3h3v3H3zm2 8H4v1h1z" />
      <path d="M7 9H2v5h5zm-4 1h3v3H3zm8-6h1v1h-1z" />
      <path d="M9 2h5v5H9zm1 1v3h3V3zM8 8v2h1v1H8v1h2v-2h1v2h1v-1h2v-1h-3V8zm2 2H9V9h1zm4 2h-1v1h-2v1h3zm-4 2v-1H8v1z" />
      <path d="M12 9h2V8h-2z" />
    </svg>
)

export const zipIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-file-earmark-zip"
    viewBox="0 0 16 16"
  >
    <path d="M5 7.5a1 1 0 011-1h1a1 1 0 011 1v.938l.4 1.599a1 1 0 01-.416 1.074l-.93.62a1 1 0 01-1.11 0l-.929-.62a1 1 0 01-.415-1.074L5 8.438zm2 0H6v.938a1 1 0 01-.03.243l-.4 1.598.93.62.929-.62-.4-1.598A1 1 0 017 8.438z" />
    <path d="M14 4.5V14a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2h5.5zm-3 0A1.5 1.5 0 019.5 3V1h-2v1h-1v1h1v1h-1v1h1v1H6V5H5V4h1V3H5V2h1V1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V4.5z" />
  </svg>
);

export const programsBadge = (
  <svg
    width={93}
    height={92}
    viewBox="0 0 93 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 45.9931C0.5 43.8434 4.17051 42.0519 4.40732 39.9021C4.76253 37.7524 1.68404 35.0055 2.27606 32.9751C2.86808 30.9448 6.8938 30.1088 7.84104 28.1979C8.66986 26.287 6.65702 22.7041 7.72266 20.9126C8.9067 19.1212 13.0508 19.5989 14.3533 17.9268C15.7741 16.3742 14.7085 12.3136 16.3661 10.8804C17.9054 9.56669 21.6943 11.1193 23.4704 9.92496C25.2465 8.85009 25.4833 4.67003 27.3777 3.83402C29.2722 2.87857 32.4691 5.50604 34.482 4.90889C36.4948 4.31173 37.7973 0.370506 39.9286 0.0122129C41.9414 -0.226649 44.3095 3.11742 46.4408 3.11742C48.6905 3.11742 50.9402 -0.226649 53.0714 0.0122129C55.2027 0.370506 56.5052 4.31173 58.518 4.90889C60.5309 5.50604 63.7278 2.87857 65.6223 3.83402C67.5167 4.67003 67.7535 8.85009 69.5296 9.92496C71.3057 11.1193 75.0946 9.5667 76.6338 10.9999C78.2915 12.3136 77.2259 16.3742 78.6467 17.9268C79.9492 19.5989 84.0933 19.1212 85.2774 20.9126C86.343 22.7041 84.3301 26.287 85.159 28.1979C85.9878 30.1088 90.1319 30.9448 90.7239 32.9751C91.3159 35.0055 88.2375 37.7524 88.5927 39.9021C88.8295 42.0519 92.5 43.8434 92.5 45.9931C92.5 48.1429 88.8295 50.0538 88.5927 52.2035C88.2375 54.2339 91.3159 57.1002 90.7239 59.1305C90.1319 61.1608 85.9878 61.8774 85.159 63.9077C84.3301 65.8186 86.343 69.4016 85.2774 71.193C84.0933 72.9845 79.9492 72.5068 78.6467 74.0594C77.2259 75.7314 78.2915 79.792 76.6338 81.1058C75.0946 82.539 71.3057 80.9864 69.5296 82.0612C67.7535 83.2556 67.5167 87.4356 65.6223 88.2716C63.7278 89.2271 60.5309 86.5996 58.518 87.1968C56.5052 87.7939 55.2027 91.7351 53.0714 91.974C50.9402 92.3323 48.6905 88.8688 46.4408 88.8688C44.3095 88.8688 41.9414 92.3323 39.9286 91.974C37.7973 91.7351 36.4948 87.7939 34.482 87.1968C32.4691 86.5996 29.2722 89.2271 27.3777 88.2716C25.4833 87.4356 25.2465 83.2556 23.4704 82.0612C21.6943 80.9864 17.9054 82.539 16.3661 81.1058C14.7085 79.792 15.7741 75.7314 14.3533 74.0594C12.9324 72.5068 8.9067 72.9845 7.72266 71.193C6.65702 69.4016 8.66986 65.8186 7.84104 63.9077C6.8938 61.8774 2.86808 61.1608 2.27606 59.1305C1.68404 57.1002 4.76253 54.2339 4.40732 52.2035C4.17051 50.0538 0.5 48.1429 0.5 45.9931Z"
      fill="#F5F6FF"
    />
    <path
      d="M62.612 43.79L65.01 45.2272C65.1578 45.3157 65.2802 45.441 65.3651 45.5909C65.4501 45.7408 65.4947 45.9101 65.4947 46.0824C65.4947 46.2547 65.4501 46.424 65.3651 46.5739C65.2802 46.7237 65.1578 46.849 65.01 46.9375L46.4999 58.0404L27.9918 46.9375C27.844 46.849 27.7216 46.7237 27.6367 46.5739C27.5517 46.424 27.5071 46.2547 27.5071 46.0824C27.5071 45.9101 27.5517 45.7408 27.6367 45.5909C27.7216 45.441 27.844 45.3157 27.9918 45.2272L30.3878 43.79L46.4999 53.4577L62.612 43.79ZM62.612 53.1587L65.01 54.5959C65.1578 54.6844 65.2802 54.8097 65.3651 54.9596C65.4501 55.1094 65.4947 55.2788 65.4947 55.451C65.4947 55.6233 65.4501 55.7927 65.3651 55.9425C65.2802 56.0924 65.1578 56.2177 65.01 56.3062L47.5245 66.7951C47.2149 66.9806 46.8608 67.0786 46.4999 67.0786C46.139 67.0786 45.7849 66.9806 45.4753 66.7951L27.9918 56.3082C27.844 56.2197 27.7216 56.0944 27.6367 55.9445C27.5517 55.7947 27.5071 55.6253 27.5071 55.453C27.5071 55.2808 27.5517 55.1114 27.6367 54.9616C27.7216 54.8117 27.844 54.6864 27.9918 54.5979L30.3878 53.1607L46.4999 62.8264L62.612 53.1587ZM47.5265 25.4693L65.008 35.9582C65.1558 36.0467 65.2782 36.172 65.3631 36.3219C65.4481 36.4718 65.4927 36.6411 65.4927 36.8134C65.4927 36.9857 65.4481 37.155 65.3631 37.3049C65.2782 37.4547 65.1558 37.58 65.008 37.6685L46.4999 48.7714L27.9918 37.6705C27.844 37.582 27.7216 37.4567 27.6367 37.3069C27.5517 37.157 27.5071 36.9877 27.5071 36.8154C27.5071 36.6431 27.5517 36.4738 27.6367 36.3239C27.7216 36.174 27.844 36.0487 27.9918 35.9602L45.4733 25.4713C45.7834 25.285 46.1382 25.1866 46.4999 25.1866C46.8616 25.1866 47.2164 25.2831 47.5265 25.4693Z"
      fill="url(#paint0_linear_2378_426)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2378_426"
        x1={30.4292}
        y1={28.3149}
        x2={58.0834}
        y2={70.6613}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B5C0FF" />
        <stop offset={1} stopColor="#5464DA" />
      </linearGradient>
    </defs>
  </svg>
);

export const coursesBadge = (
  <svg
    width={93}
    height={92}
    viewBox="0 0 93 92"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.5 45.9931C0.5 43.8434 4.17051 42.0519 4.40732 39.9021C4.76253 37.7524 1.68404 35.0055 2.27606 32.9751C2.86808 30.9448 6.8938 30.1088 7.84104 28.1979C8.66986 26.287 6.65702 22.7041 7.72266 20.9126C8.9067 19.1212 13.0508 19.5989 14.3533 17.9268C15.7741 16.3742 14.7085 12.3136 16.3661 10.8804C17.9054 9.56669 21.6943 11.1193 23.4704 9.92496C25.2465 8.85009 25.4833 4.67003 27.3777 3.83402C29.2722 2.87857 32.4691 5.50604 34.482 4.90889C36.4948 4.31173 37.7973 0.370506 39.9286 0.0122129C41.9414 -0.226649 44.3095 3.11742 46.4408 3.11742C48.6905 3.11742 50.9402 -0.226649 53.0714 0.0122129C55.2027 0.370506 56.5052 4.31173 58.518 4.90889C60.5309 5.50604 63.7278 2.87857 65.6223 3.83402C67.5167 4.67003 67.7535 8.85009 69.5296 9.92496C71.3057 11.1193 75.0946 9.5667 76.6338 10.9999C78.2915 12.3136 77.2259 16.3742 78.6467 17.9268C79.9492 19.5989 84.0933 19.1212 85.2774 20.9126C86.343 22.7041 84.3301 26.287 85.159 28.1979C85.9878 30.1088 90.1319 30.9448 90.7239 32.9751C91.3159 35.0055 88.2375 37.7524 88.5927 39.9021C88.8295 42.0519 92.5 43.8434 92.5 45.9931C92.5 48.1429 88.8295 50.0538 88.5927 52.2035C88.2375 54.2339 91.3159 57.1002 90.7239 59.1305C90.1319 61.1608 85.9878 61.8774 85.159 63.9077C84.3301 65.8186 86.343 69.4016 85.2774 71.193C84.0933 72.9845 79.9492 72.5068 78.6467 74.0594C77.2259 75.7314 78.2915 79.792 76.6338 81.1058C75.0946 82.539 71.3057 80.9864 69.5296 82.0612C67.7535 83.2556 67.5167 87.4356 65.6223 88.2716C63.7278 89.2271 60.5309 86.5996 58.518 87.1968C56.5052 87.7939 55.2027 91.7351 53.0714 91.974C50.9402 92.3323 48.6905 88.8688 46.4408 88.8688C44.3095 88.8688 41.9414 92.3323 39.9286 91.974C37.7973 91.7351 36.4948 87.7939 34.482 87.1968C32.4691 86.5996 29.2722 89.2271 27.3777 88.2716C25.4833 87.4356 25.2465 83.2556 23.4704 82.0612C21.6943 80.9864 17.9054 82.539 16.3661 81.1058C14.7085 79.792 15.7741 75.7314 14.3533 74.0594C12.9324 72.5068 8.9067 72.9845 7.72266 71.193C6.65702 69.4016 8.66986 65.8186 7.84104 63.9077C6.8938 61.8774 2.86808 61.1608 2.27606 59.1305C1.68404 57.1002 4.76253 54.2339 4.40732 52.2035C4.17051 50.0538 0.5 48.1429 0.5 45.9931Z"
      fill="#FFF3F0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.4706 26C62.1547 26 64.9536 26.3441 67.5 27.1471C69.2206 27.7206 70.7118 28.4088 72.0883 29.4412V62.9353C72.0883 63.5088 71.5147 64.0824 70.9412 64.0824C70.7118 64.0824 70.5971 64.0824 70.3677 63.9676C67.1559 62.2471 63.2559 61.5588 59.4706 61.5588C55.5706 61.5588 49.95 63.05 46.853 65C43.5265 62.4765 38.7089 61.5588 34.2353 61.5588C30.9089 61.5588 26.4353 62.5912 23.3383 64.0824C23.2236 64.0824 23.1375 64.111 23.0515 64.1397C22.9655 64.1684 22.8794 64.1971 22.7647 64.1971C22.1912 64.1971 21.6177 63.6235 21.6177 63.05V29.4412C24.9441 26.9176 29.7618 26 34.2353 26C38.7089 26 43.5265 26.9176 46.853 29.4412C50.1794 26.9176 54.9971 26 59.4706 26ZM59.4706 56.9706C62.2236 56.9706 64.9765 57.3147 67.5 58.1176V31.7353C64.9765 30.9324 62.2236 30.5882 59.4706 30.5882C55.5706 30.5882 49.95 32.0794 46.853 34.0294V60.4118C49.95 58.4618 55.5706 56.9706 59.4706 56.9706ZM65.2058 40.3612C63.4394 39.9712 61.4894 39.7647 59.4706 39.7647C55.3411 39.7647 51.7394 40.5676 49.147 42.0359V38.2276C52.0376 36.9888 55.5706 36.3235 59.4706 36.3235C61.4435 36.3235 63.3935 36.53 65.2058 36.8741V40.3612ZM49.147 44.33V48.1383C51.7394 46.67 55.3411 45.8671 59.4706 45.8671C61.4894 45.8671 63.4394 46.0736 65.2058 46.4636V42.9765C63.3935 42.6324 61.4435 42.4259 59.4706 42.4259C55.5706 42.4259 52.0376 43.1142 49.147 44.33ZM49.147 50.4552C52.0376 49.2164 55.5706 48.5511 59.4706 48.5511C61.4435 48.5511 63.3935 48.7346 65.2058 49.1016V52.5887C63.4394 52.1987 61.4894 51.9922 59.4706 51.9922C55.3411 51.9922 51.7394 52.7952 49.147 54.2634V50.4552Z"
      fill="url(#paint0_linear_2378_102)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2378_102"
        x1={46.853}
        y1={26}
        x2={46.853}
        y2={65}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F88968" />
        <stop offset={1} stopColor="#AD4728" />
      </linearGradient>
    </defs>
  </svg>
);

export const downloadBaseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-download"
    viewBox="0 0 16 16"
  >
    <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
    <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
  </svg>
);

export const folderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-folder"
    viewBox="0 0 16 16"
  >
    <path d="M.54 3.87.5 3a2 2 0 0 1 2-2h3.672a2 2 0 0 1 1.414.586l.828.828A2 2 0 0 0 9.828 3h3.982a2 2 0 0 1 1.992 2.181l-.637 7A2 2 0 0 1 13.174 14H2.826a2 2 0 0 1-1.991-1.819l-.637-7a2 2 0 0 1 .342-1.31zM2.19 4a1 1 0 0 0-.996 1.09l.637 7a1 1 0 0 0 .995.91h10.348a1 1 0 0 0 .995-.91l.637-7A1 1 0 0 0 13.81 4zm4.69-1.707A1 1 0 0 0 6.172 2H2.5a1 1 0 0 0-1 .981l.006.139q.323-.119.684-.12h5.396z" />
  </svg>
);

export const achievementIcon = (
  <svg
    width={9}
    height={18}
    viewBox="0 0 9 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.66683 7.69166V0.666656H0.333496V7.69166C0.333496 7.98332 0.483496 8.25832 0.741829 8.40832L4.22516 10.5L3.40016 12.45L0.558496 12.6917L2.71683 14.5583L2.0585 17.3333L4.50016 15.8583L6.94183 17.3333L6.29183 14.5583L8.45016 12.6917L5.6085 12.45L4.7835 10.5L8.26683 8.40832C8.51683 8.25832 8.66683 7.99166 8.66683 7.69166ZM3.66683 8.22499L2.00016 7.22499V2.33332H3.66683V8.22499ZM7.00016 7.22499L5.3335 8.22499V2.33332H7.00016V7.22499Z"
      fill="currentColor"
    />
  </svg>
);

export const presenterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-easel"
  >
    <path d="M8 0a.5.5 0 0 1 .473.337L9.046 2H14a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1h-1.85l1.323 3.837a.5.5 0 1 1-.946.326L11.092 11H8.5v3a.5.5 0 0 1-1 0v-3H4.908l-1.435 4.163a.5.5 0 1 1-.946-.326L3.85 11H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h4.954L7.527.337A.5.5 0 0 1 8 0M2 3v7h12V3z" />
  </svg>
);

export const broadcastIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-broadcast"
  >
    <path d="M3.05 3.05a7 7 0 0 0 0 9.9.5.5 0 0 1-.707.707 8 8 0 0 1 0-11.314.5.5 0 0 1 .707.707m2.122 2.122a4 4 0 0 0 0 5.656.5.5 0 1 1-.708.708 5 5 0 0 1 0-7.072.5.5 0 0 1 .708.708m5.656-.708a.5.5 0 0 1 .708 0 5 5 0 0 1 0 7.072.5.5 0 1 1-.708-.708 4 4 0 0 0 0-5.656.5.5 0 0 1 0-.708m2.122-2.12a.5.5 0 0 1 .707 0 8 8 0 0 1 0 11.313.5.5 0 0 1-.707-.707 7 7 0 0 0 0-9.9.5.5 0 0 1 0-.707zM10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
  </svg>
);

export const wifiIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-wifi"
  >
    <path d="M15.384 6.115a.485.485 0 0 0-.047-.736A12.44 12.44 0 0 0 8 3C5.259 3 2.723 3.882.663 5.379a.485.485 0 0 0-.048.736.52.52 0 0 0 .668.05A11.45 11.45 0 0 1 8 4c2.507 0 4.827.802 6.716 2.164.205.148.49.13.668-.049" />
    <path d="M13.229 8.271a.482.482 0 0 0-.063-.745A9.46 9.46 0 0 0 8 6c-1.905 0-3.68.56-5.166 1.526a.48.48 0 0 0-.063.745.525.525 0 0 0 .652.065A8.46 8.46 0 0 1 8 7a8.46 8.46 0 0 1 4.576 1.336c.206.132.48.108.653-.065m-2.183 2.183c.226-.226.185-.605-.1-.75A6.5 6.5 0 0 0 8 9c-1.06 0-2.062.254-2.946.704-.285.145-.326.524-.1.75l.015.015c.16.16.407.19.611.09A5.5 5.5 0 0 1 8 10c.868 0 1.69.201 2.42.56.203.1.45.07.61-.091zM9.06 12.44c.196-.196.198-.52-.04-.66A2 2 0 0 0 8 11.5a2 2 0 0 0-1.02.28c-.238.14-.236.464-.04.66l.706.706a.5.5 0 0 0 .707 0l.707-.707z" />
  </svg>
);

export const videoRecordIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-camera-video"
  >
    <path
      fillRule="evenodd"
      d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2zm11.5 5.175 3.5 1.556V4.269l-3.5 1.556zM2 4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h7.5a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z"
    />
  </svg>
);

export const webCamIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-webcam"
  >
    <path d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H9.269c.144.162.33.324.531.475a7 7 0 0 0 .907.57l.014.006.003.002A.5.5 0 0 1 10.5 13h-5a.5.5 0 0 1-.224-.947l.003-.002.014-.007a5 5 0 0 0 .268-.148 7 7 0 0 0 .639-.421c.2-.15.387-.313.531-.475H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1z" />
    <path d="M8 6.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0m7 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0" />
  </svg>
);

export const transferIcon = (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="invisible_box" data-name="invisible box">
        <rect width={48} height={48} fill="none" />
      </g>
      <g id="icons_Q2" data-name="icons Q2">
        <g>
          <path d="M19,26a2,2,0,0,0-2,2V40H7V28a2,2,0,0,0-4,0V42a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V28A2,2,0,0,0,19,26Z" />
          <path d="M43,26a2,2,0,0,0-2,2V40H31V28a2,2,0,0,0-4,0V42a2,2,0,0,0,2,2H43a2,2,0,0,0,2-2V28A2,2,0,0,0,43,26Z" />
          <path d="M34,16v1.2l-2.6-2.6a1.9,1.9,0,0,0-3,.2,2.1,2.1,0,0,0,.2,2.7l6,5.9a1.9,1.9,0,0,0,2.8,0l6-5.9a2.1,2.1,0,0,0,.2-2.7,1.9,1.9,0,0,0-3-.2L38,17.2V16a14,14,0,0,0-28,0v6a2,2,0,0,0,4,0V16a10,10,0,0,1,20,0Z" />
        </g>
      </g>
    </g>
  </svg>
);

export const refundIcon = (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 8L3.29289 8.70711L2.58579 8L3.29289 7.29289L4 8ZM9 20C8.44772 20 8 19.5523 8 19C8 18.4477 8.44772 18 9 18L9 20ZM8.29289 13.7071L3.29289 8.70711L4.70711 7.29289L9.70711 12.2929L8.29289 13.7071ZM3.29289 7.29289L8.29289 2.29289L9.70711 3.70711L4.70711 8.70711L3.29289 7.29289ZM4 7L14.5 7L14.5 9L4 9L4 7ZM14.5 20L9 20L9 18L14.5 18L14.5 20ZM21 13.5C21 17.0898 18.0898 20 14.5 20L14.5 18C16.9853 18 19 15.9853 19 13.5L21 13.5ZM14.5 7C18.0899 7 21 9.91015 21 13.5L19 13.5C19 11.0147 16.9853 9 14.5 9L14.5 7Z"
      fill="currentColor"
    />
  </svg>
);

export const closeCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-x-circle"
    viewBox="0 0 16 16"
  >
    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
  </svg>
);

export const dotIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-dot"
    viewBox="0 0 16 16"
  >
    <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
  </svg>
);

export const dots3VerticalIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-three-dots-vertical"
    viewBox="0 0 16 16"
  >
    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
  </svg>
); 

export const gridIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-grid"
    viewBox="0 0 16 16"
  >
    <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z" />
  </svg>
);

export const versionClockIcon = (
  <svg
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33333 3.33333V6.66667L8.16667 8.34667L8.68 7.49333L6.33333 6.1V3.33333H5.33333ZM12 4.66667V0L10.24 1.76C9.16 0.673333 7.66 0 6 0C2.68667 0 0 2.68667 0 6C0 9.31333 2.68667 12 6 12C9.31333 12 12 9.31333 12 6H10.6667C10.6667 8.57333 8.57333 10.6667 6 10.6667C3.42667 10.6667 1.33333 8.57333 1.33333 6C1.33333 3.42667 3.42667 1.33333 6 1.33333C7.28667 1.33333 8.45333 1.86 9.3 2.7L7.33333 4.66667H12Z"
      fill="currentColor"
    />
  </svg>
);

export const uptrendIcon = (
  <svg
    width={16}
    height={12}
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99984 4L10.6265 2.62L11.9998 2L10.6265 1.38L9.99984 0L9.3865 1.38L7.99984 2L9.3865 2.62L9.99984 4ZM13.9998 3.33333C13.0332 3.33333 12.4932 4.29333 12.7132 5.00667L10.3465 7.38C10.1465 7.32 9.85317 7.32 9.65317 7.38L7.95317 5.68C8.17984 4.96667 7.63984 4 6.6665 4C5.69984 4 5.15317 4.96 5.37984 5.68L2.33984 8.71333C1.6265 8.49333 0.666504 9.03333 0.666504 10C0.666504 10.7333 1.2665 11.3333 1.99984 11.3333C2.9665 11.3333 3.5065 10.3733 3.2865 9.66L6.31984 6.62C6.51984 6.68 6.81317 6.68 7.01317 6.62L8.71317 8.32C8.4865 9.03333 9.0265 10 9.99984 10C10.9665 10 11.5132 9.04 11.2865 8.32L13.6598 5.95333C14.3732 6.17333 15.3332 5.63333 15.3332 4.66667C15.3332 3.93333 14.7332 3.33333 13.9998 3.33333ZM2.6665 4L2.33317 5.33333L1.99984 4L0.666504 3.66667L1.99984 3.33333L2.33317 2L2.6665 3.33333L3.99984 3.66667L2.6665 4Z"
      fill="currentColor"
    />
  </svg>
);

export const dmsFolderIcon = (
  <svg
    width={20}
    height={16}
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.17 2L9.17 4H18V14H2V2H7.17ZM8 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2H10L8 0Z"
      fill="currentColor"
    />
  </svg>
)

export const organizationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-buildings"
    viewBox="0 0 16 16"
  >
    <path d="M14.763.075A.5.5 0 0 1 15 .5v15a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5V14h-1v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .342-.474L6 7.64V4.5a.5.5 0 0 1 .276-.447l8-4a.5.5 0 0 1 .487.022M6 8.694 1 10.36V15h5zM7 15h2v-1.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5V15h2V1.309l-7 3.5z" />
    <path d="M2 11h1v1H2zm2 0h1v1H4zm-2 2h1v1H2zm2 0h1v1H4zm4-4h1v1H8zm2 0h1v1h-1zm-2 2h1v1H8zm2 0h1v1h-1zm2-2h1v1h-1zm0 2h1v1h-1zM8 7h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zM8 5h1v1H8zm2 0h1v1h-1zm2 0h1v1h-1zm0-2h1v1h-1z" />
  </svg>
);

export const bundleBoxIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-box-seam"
    viewBox="0 0 16 16"
  >
    <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2zm3.564 1.426L5.596 5 8 5.961 14.154 3.5zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464z" />
  </svg>
);


export const caretIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6.119}
    height={11.658}
    viewBox="0 0 6.119 11.658"
  >
    <path
      id="Path_21616"
      data-name="Path 21616"
      d="M0,0,4.42,3.71,8.84,0"
      transform="translate(1.409 10.249) rotate(-90)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    />
  </svg>
)

export const bannerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-card-image"
    viewBox="0 0 16 16"
  >
    <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
    <path d="M1.5 2A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2zm13 1a.5.5 0 0 1 .5.5v6l-3.775-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12v.54L1 12.5v-9a.5.5 0 0 1 .5-.5z" />
  </svg>
)
